var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 61 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Degradado_sin_nombre_373-11);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43 {\n        stroke-width: 0px;\n      }\n\n      .cls-1, .cls-2, .cls-30, .cls-31 {\n        opacity: .3;\n      }\n\n      .cls-2 {\n        fill: url(#Degradado_sin_nombre_373-18);\n      }\n\n      .cls-44 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        fill: url(#Degradado_sin_nombre_373-6);\n      }\n\n      .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17 {\n        opacity: .2;\n      }\n\n      .cls-5 {\n        fill: url(#Degradado_sin_nombre_373-9);\n      }\n\n      .cls-6 {\n        fill: url(#Degradado_sin_nombre_373-8);\n      }\n\n      .cls-7 {\n        fill: url(#Degradado_sin_nombre_373-3);\n      }\n\n      .cls-8 {\n        fill: url(#Degradado_sin_nombre_373-4);\n      }\n\n      .cls-9 {\n        fill: url(#Degradado_sin_nombre_373-5);\n      }\n\n      .cls-45 {\n        fill: url(#Degradado_sin_nombre_166);\n        filter: url(#drop-shadow-10);\n        stroke: #fff;\n        stroke-width: .25px;\n      }\n\n      .cls-45, .cls-46 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-47 {\n        filter: url(#drop-shadow-9);\n      }\n\n      .cls-48 {\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-10 {\n        fill: url(#Degradado_sin_nombre_373-19);\n      }\n\n      .cls-11 {\n        fill: url(#Degradado_sin_nombre_373-15);\n      }\n\n      .cls-12 {\n        fill: url(#Degradado_sin_nombre_373-17);\n      }\n\n      .cls-13 {\n        fill: url(#Degradado_sin_nombre_373-16);\n      }\n\n      .cls-14 {\n        fill: url(#Degradado_sin_nombre_373-14);\n      }\n\n      .cls-15 {\n        fill: url(#Degradado_sin_nombre_373-13);\n      }\n\n      .cls-16 {\n        fill: url(#Degradado_sin_nombre_373-12);\n      }\n\n      .cls-17 {\n        fill: url(#Degradado_sin_nombre_373-20);\n      }\n\n      .cls-18 {\n        fill: url(#Degradado_sin_nombre_373-21);\n      }\n\n      .cls-19 {\n        fill: url(#Degradado_sin_nombre_373-22);\n      }\n\n      .cls-20 {\n        fill: url(#Degradado_sin_nombre_373-10);\n      }\n\n      .cls-20, .cls-21, .cls-49 {\n        opacity: .9;\n      }\n\n      .cls-21 {\n        fill: url(#Degradado_sin_nombre_373);\n      }\n\n      .cls-46 {\n        fill: url(#Degradado_sin_nombre_579);\n        stroke: url(#Degradado_sin_nombre_604);\n        stroke-width: .49px;\n      }\n\n      .cls-50 {\n        isolation: isolate;\n      }\n\n      .cls-22 {\n        fill: url(#Degradado_sin_nombre_671);\n        mix-blend-mode: lighten;\n        opacity: .7;\n      }\n\n      .cls-23 {\n        filter: url(#drop-shadow-3);\n      }\n\n      .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-38 {\n        fill: #fff;\n      }\n\n      .cls-24 {\n        filter: url(#drop-shadow-8);\n      }\n\n      .cls-25 {\n        filter: url(#drop-shadow-6);\n      }\n\n      .cls-26 {\n        filter: url(#drop-shadow-7);\n      }\n\n      .cls-27 {\n        filter: url(#drop-shadow-4);\n      }\n\n      .cls-28 {\n        filter: url(#drop-shadow-5);\n      }\n\n      .cls-29 {\n        fill: #606060;\n        filter: url(#drop-shadow-2);\n      }\n\n      .cls-30 {\n        fill: url(#Degradado_sin_nombre_373-7);\n      }\n\n      .cls-31 {\n        fill: url(#Degradado_sin_nombre_373-2);\n      }\n\n      .cls-32 {\n        fill: #f9d656;\n      }\n\n      .cls-33 {\n        fill: #d29d47;\n      }\n\n      .cls-34 {\n        fill: #cb8a18;\n      }\n\n      .cls-35 {\n        fill: #e1991c;\n      }\n\n      .cls-36 {\n        fill: #dcaa12;\n      }\n\n      .cls-37 {\n        fill: #fdebb6;\n      }\n\n      .cls-39 {\n        fill: #eeae1a;\n      }\n\n      .cls-40 {\n        fill: #e4c44d;\n      }\n\n      .cls-41 {\n        fill: #fbde7f;\n      }\n\n      .cls-42 {\n        fill: #f1bb16;\n      }\n\n      .cls-43 {\n        fill: #e8ad4f;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_671",
    "data-name": "Degradado sin nombre 671",
    x1: 30.39,
    y1: -5.14,
    x2: 30.91,
    y2: 62.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#180d5b",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#9590a3",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffe0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373",
    "data-name": "Degradado sin nombre 373",
    x1: 9428.72,
    y1: 3683.26,
    x2: 9430.74,
    y2: 3683.26,
    gradientTransform: "translate(9459.82 3698.14) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fff",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fff",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fff",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#fff",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-2",
    "data-name": "Degradado sin nombre 373",
    x1: 9441.88,
    y1: 3675.23,
    x2: 9443.13,
    y2: 3675.23,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-3",
    "data-name": "Degradado sin nombre 373",
    x1: 9437.5,
    y1: 3668.14,
    x2: 9438.77,
    y2: 3668.14,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-4",
    "data-name": "Degradado sin nombre 373",
    x1: 9419.02,
    y1: 3665.82,
    x2: 9419.83,
    y2: 3665.82,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-5",
    "data-name": "Degradado sin nombre 373",
    x1: 9420.07,
    y1: 3663.72,
    x2: 9421.76,
    y2: 3663.72,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-6",
    "data-name": "Degradado sin nombre 373",
    x1: 9439.46,
    y1: 3666.87,
    x2: 9440.28,
    y2: 3666.87,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-7",
    "data-name": "Degradado sin nombre 373",
    x1: 9439.96,
    y1: 3686.66,
    x2: 9441.21,
    y2: 3686.66,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-8",
    "data-name": "Degradado sin nombre 373",
    x1: 9435.58,
    y1: 3679.58,
    x2: 9436.86,
    y2: 3679.58,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-9",
    "data-name": "Degradado sin nombre 373",
    x1: 9437.54,
    y1: 3678.3,
    x2: 9438.36,
    y2: 3678.3,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-10",
    "data-name": "Degradado sin nombre 373",
    x1: 9430.27,
    y1: 3672.95,
    x2: 9432.07,
    y2: 3672.95,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-11",
    "data-name": "Degradado sin nombre 373",
    x1: 9421.38,
    y1: 3663.23,
    x2: 9422.5,
    y2: 3663.23,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-12",
    "data-name": "Degradado sin nombre 373",
    x1: 9426.69,
    y1: 3658.09,
    x2: 9427.82,
    y2: 3658.09,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-13",
    "data-name": "Degradado sin nombre 373",
    x1: 9443.5,
    y1: 3660.2,
    x2: 9444.22,
    y2: 3660.2,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-14",
    "data-name": "Degradado sin nombre 373",
    x1: 9442.3,
    y1: 3658.07,
    x2: 9443.8,
    y2: 3658.07,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-15",
    "data-name": "Degradado sin nombre 373",
    x1: 9425.68,
    y1: 3656.61,
    x2: 9426.41,
    y2: 3656.61,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-16",
    "data-name": "Degradado sin nombre 373",
    x1: 9421.89,
    y1: 3686.74,
    x2: 9422.7,
    y2: 3686.74,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-17",
    "data-name": "Degradado sin nombre 373",
    x1: 9420.81,
    y1: 3684.25,
    x2: 9422.5,
    y2: 3684.25,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-18",
    "data-name": "Degradado sin nombre 373",
    x1: 9421.39,
    y1: 3683.15,
    x2: 9422.5,
    y2: 3683.15,
    gradientTransform: "translate(1551.29 10017.4) rotate(-119.96)",
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-19",
    "data-name": "Degradado sin nombre 373",
    x1: 9420.9,
    y1: 3675.77,
    x2: 9422.03,
    y2: 3675.77,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-20",
    "data-name": "Degradado sin nombre 373",
    x1: 9419.19,
    y1: 3675.74,
    x2: 9419.92,
    y2: 3675.74,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-21",
    "data-name": "Degradado sin nombre 373",
    x1: 9432.71,
    y1: 3693.3,
    x2: 9434.51,
    y2: 3693.3,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373-22",
    "data-name": "Degradado sin nombre 373",
    x1: 9430.63,
    y1: 3688.51,
    x2: 9431.9,
    y2: 3688.51,
    xlinkHref: "#Degradado_sin_nombre_373"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.58,
    dy: 6.13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 12.26
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffb600",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 6.86
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a56f16",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-5",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-5",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-6",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-6",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-6",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-7",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-7",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-7",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-8",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-8",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-8",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-9",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-9",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-9",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_579",
    "data-name": "Degradado sin nombre 579",
    x1: 6500.78,
    y1: -2606.19,
    x2: 6543.11,
    y2: -2606.19,
    gradientTransform: "translate(2635.85 -6501.85) rotate(90) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#db0083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#b744ae",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#9587d9",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#7fb1f4",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#77c2ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_604",
    "data-name": "Degradado sin nombre 604",
    cx: 29.66,
    cy: 21.16,
    fx: 29.66,
    fy: 21.16,
    r: 16.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c9fbd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#c7fad1",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#a5e2e4",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8cd0f2",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7cc6fb",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#77c2ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_166",
    "data-name": "Degradado sin nombre 166",
    cx: 30.17,
    cy: -48.07,
    fx: 30.17,
    fy: -48.07,
    r: 13.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fff",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#fff",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fff",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-10",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10.29,
    dy: 8.33
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-10",
    stdDeviation: 10.29
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff00cf",
    floodOpacity: 0.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-10",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m53.25,93.81l-24.79-11.91c-2.04-.98-4.48-.12-5.46,1.92l-7.27,15.14c-.98,2.04-.12,4.48,1.92,5.46l.79.38,18.37-2.75c2.23-.33,4.32,1.21,4.65,3.44l1.66,11.09c1.87.52,3.91-.36,4.78-2.17l7.27-15.14c.98-2.04.12-4.48-1.92-5.46Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "43.58 56.53 19.07 57.13 5.16 9.58 55.84 8.55 43.58 56.53"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m31.1,14.88c0-.56-.45-1.01-1.01-1.01s-1.01.45-1.01,1.01.45,1.01,1.01,1.01,1.01-.45,1.01-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m17.94,22.91c0-.35-.28-.63-.63-.63s-.63.28-.63.63.28.63.63.63.63-.28.63-.63Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 21.68,
    cy: 30,
    r: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m40.8,32.32c0-.22-.18-.4-.4-.4s-.4.18-.4.4.18.4.4.4.4-.18.4-.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 38.91,
    cy: 34.43,
    r: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m20.36,31.27c0-.23-.18-.41-.41-.41s-.41.18-.41.41.18.41.41.41.41-.18.41-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m19.86,11.48c0-.35-.28-.63-.63-.63s-.63.28-.63.63.28.63.63.63.63-.28.63-.63Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 23.6,
    cy: 18.56,
    r: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.28,19.84c0-.23-.18-.41-.41-.41s-.41.18-.41.41.18.41.41.41.41-.18.41-.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m27.78,24.97c.12-.48.61-.77,1.09-.65s.77.61.65,1.09c-.12.48-.61.77-1.09.65-.48-.12-.77-.61-.65-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.34,34.78c.08-.3.38-.48.68-.4s.48.38.4.68c-.08.3-.38.48-.68.4s-.48-.38-.4-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m32.01,39.91c.08-.3.39-.49.69-.41.3.08.49.39.41.69-.08.3-.39.49-.69.41s-.49-.39-.41-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m15.61,37.85c.05-.19.24-.31.44-.26.19.05.31.24.26.44-.05.19-.24.31-.44.26-.19-.05-.31-.24-.26-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m16.04,39.89c.1-.4.51-.64.91-.54s.64.51.54.91c-.1.4-.51.64-.91.54s-.64-.51-.54-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m33.42,41.44c.05-.19.25-.31.44-.26.19.05.31.25.26.44s-.25.31-.44.26c-.19-.05-.31-.25-.26-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m37.78,11.09c-.17-.14-.42-.12-.57.05-.14.17-.12.42.05.57.17.14.42.12.57-.05.14-.17.12-.42-.05-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m38.71,13.25c-.36-.3-.89-.26-1.19.1-.3.36-.26.89.1,1.19.36.3.89.26,1.19-.1.3-.36.26-.89-.1-1.19Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 37.87,
    cy: 14.99,
    r: 0.56,
    transform: "translate(5.97 40.32) rotate(-60.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m37.89,22.7c-.18-.26-.12-.61.13-.79.26-.18.61-.12.79.13s.12.61-.13.79c-.26.18-.61.12-.79-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m39.97,22.61c-.12-.16-.08-.39.09-.51.16-.12.39-.08.51.09s.08.39-.09.51-.39.08-.51-.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m25.33,4.61c.12-.48.61-.77,1.09-.65.48.12.77.61.65,1.09-.12.48-.61.77-1.09.65-.48-.12-.77-.61-.65-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m27.94,9.48c.09-.34.43-.55.77-.46s.55.43.46.77-.43.55-.77.46c-.34-.09-.55-.43-.46-.77Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.03,53.41l-.02,3.27c.31-.03.59-.05.86-.08l.02-3.27c-.26.03-.55.05-.86.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.56,53.05c-.23.08-.6.15-1.09.21l-.02,3.27c.86-.11,1.36-.25,1.36-.39v-3.11s-.09,0-.14.01c-.04,0-.08,0-.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.14,56.5h0c-.14.13-.27.27-.41.4.14,0,.27,0,.41,0v-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m38.01,53.58l-.02,3.27c.29-.01.56-.02.84-.03l.02-3.27c-.27.01-.55.02-.84.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m41.89,53.33l-.02,3.27c.21-.02.41-.04.59-.07l.02-3.27c-.18.02-.38.05-.59.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m35.44,53.64c-.27.44-.56.88-.87,1.3-.13.16-.26.32-.4.47-.04.05-.08.09-.12.14-.1.11-.2.22-.3.33-.04.05-.09.09-.13.14-.11.12-.23.24-.34.36-.03.03-.06.06-.09.09l-.05.05v.4c.28,0,.56,0,.85,0,1.42,0,2.78-.02,4-.07l.02-3.27c-.8.03-1.66.05-2.57.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m38.84,53.54l-.02,3.27c.81-.03,1.55-.08,2.19-.13l.02-3.27c-.64.05-1.38.1-2.19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m41.49,53.17c-.27.01-.55.02-.84.03-1.22.04-2.57.07-4,.07-.29,0-.57,0-.85,0-.05,0-.09,0-.14,0h0s-.02.04-.03.05c-.04.07-.08.13-.12.2-.02.04-.05.08-.07.12h0c.9-.01,1.76-.03,2.57-.06.29-.01.56-.02.84-.03.81-.04,1.55-.08,2.19-.13.31-.02.59-.05.86-.08.21-.02.41-.05.59-.07.49-.07.86-.14,1.09-.21-.62.05-1.31.09-2.07.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.14,49.63l-.02,3.27c.86-.11,1.36-.25,1.36-.39v-3.26c0,.14-.49.27-1.34.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.7,49.77l-.02,3.27s.09,0,.14-.01c.25-.02.49-.04.72-.07l.02-3.27c-.26.03-.55.05-.86.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m40.65,53.21c.29-.01.56-.02.84-.03l.02-3.27c-.27.01-.55.02-.84.03l-.02,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m35.67,53.26h0s.09,0,.14,0v-.25c-.04.08-.09.16-.14.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m44.55,49.7l-.02,3.27c.21-.02.41-.04.59-.07l.02-3.27c-.18.02-.38.05-.59.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m37.09,50.01h0c-.15.51-.32,1.02-.52,1.52-.06.14-.13.27-.19.4-.03.07-.07.13-.1.2h0s-.01.03-.01.03c-.03.05-.05.11-.08.16-.05.1-.1.2-.15.29-.01.02-.03.05-.04.07-.01.02-.02.04-.04.07l-.02.03s-.04.07-.05.1h0l-.03.05s-.03.05-.05.08h0s0,.01,0,.01v.25c.28,0,.56,0,.85,0,1.42,0,2.78-.02,4-.07l.02-3.27c-1.1.04-2.31.06-3.58.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m41.49,53.17c.76-.03,1.46-.07,2.07-.12.04,0,.08,0,.12,0l.02-3.27c-.64.05-1.38.1-2.19.13l-.02,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m44.52,48.9c.56.07.88.14.88.22,0,.27-3.62.49-8.2.51-.03.12-.07.25-.11.37,1.27,0,2.48-.03,3.58-.07.29,0,.56-.02.84-.03.81-.04,1.55-.08,2.19-.13.31-.02.59-.05.86-.08.21-.02.41-.05.59-.07.85-.11,1.34-.25,1.34-.39h0c0-.17-.73-.33-1.95-.46v.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m41.73,49.4c-.64.05-1.38.1-2.19.13-.27.01-.55.02-.84.03-.48.02-.98.03-1.49.04v.02c4.57-.02,8.19-.24,8.19-.51,0-.08-.32-.16-.88-.22-.07.13-.55.25-1.35.36-.18.03-.38.05-.59.07-.26.03-.55.05-.86.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.19,45.99l-.02,3.27c.8-.1,1.28-.23,1.35-.36v-.03s0-.09,0-.09v-2.97c-.15.01-.31.02-.47.03-.22.05-.52.11-.88.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m38.7,49.57c.29-.01.56-.02.84-.03l.02-3.27c-.27.01-.55.02-.84.03l-.02,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.73,49.4c.31-.03.59-.05.86-.08l.02-3.27c-.26.03-.55.05-.86.08l-.02,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m42.58,49.33c.21-.02.41-.04.59-.07l.02-3.27c-.18.02-.38.05-.59.07l-.02,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m37.49,48.47h0v.03s0,0,0,0c-.04.18-.08.36-.13.54v.02c-.05.18-.1.36-.15.54.52-.01,1.02-.02,1.49-.04l.02-3.27c-.3.01-.62.02-.94.03-.02.35-.05.7-.09,1.05-.06.36-.13.73-.21,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m39.54,49.54c.81-.03,1.55-.08,2.19-.13l.02-3.27c-.64.05-1.38.1-2.19.13l-.02,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m42.01,45.93c-1.22.04-2.57.07-4,.07-.07,0-.14,0-.21,0,0,.11-.01.22-.02.33.32,0,.63-.02.94-.03.29,0,.56-.02.84-.03.81-.04,1.55-.08,2.19-.13.31-.02.59-.05.86-.08.21-.02.41-.05.59-.07.36-.05.66-.1.88-.15-.39.02-.79.04-1.22.06-.27.01-.55.02-.84.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m42.01,45.93c.29-.01.56-.02.84-.03l.02-3.27c-.27.01-.55.02-.84.03l-.02,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m46.5,42.35l-.02,3.27c.86-.11,1.36-.25,1.36-.39v-3.26c0,.14-.49.27-1.34.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.05,42.5l-.02,3.27c.31-.03.59-.05.86-.08l.02-3.27c-.26.03-.55.05-.86.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m45.91,42.42l-.02,3.27c.21-.02.41-.04.59-.07l.02-3.27c-.18.02-.38.05-.59.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m37.82,44.87h0s0,.09,0,.13h0v.05s0,.05,0,.05h0c0,.12,0,.23,0,.34,0,.02,0,.04,0,.07,0,.03,0,.06,0,.09h0c0,.13,0,.26-.02.4.07,0,.14,0,.21,0,1.43,0,2.78-.02,4-.07l.02-3.27c-1.23.04-2.59.07-4.02.07-.1,0-.2,0-.3,0,.07.71.11,1.43.11,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m42.86,42.63l-.02,3.27c.43-.02.84-.04,1.22-.06.16,0,.31-.02.47-.03.17-.01.34-.02.5-.04l.02-3.27c-.64.05-1.38.1-2.19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m46.76,41.85c0,.28-3.92.51-8.75.51-.11,0-.23,0-.34,0,0,.03.01.07.02.1,0,.09.02.18.03.27.1,0,.2,0,.3,0,1.43,0,2.79-.02,4.02-.07.29,0,.56-.02.84-.03.81-.04,1.55-.08,2.19-.13.31-.02.59-.05.86-.08.21-.02.41-.05.59-.07.85-.11,1.34-.25,1.34-.39h0c0-.26-1.58-.48-4.02-.62v.12c1.8.09,2.94.23,2.94.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m41.87,42.05c-.26.03-.55.05-.86.08-.64.05-1.38.1-2.19.13-.27.01-.55.02-.84.03-.11,0-.22,0-.33.01h0s0,.04.01.05h0c.11,0,.23,0,.34,0,4.83,0,8.75-.23,8.75-.51,0-.15-1.14-.29-2.94-.38v.13c0,.14-.5.28-1.36.39-.18.03-.38.05-.59.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m42.48,38.72l-.02,3.27c.86-.11,1.36-.25,1.36-.39v-3.14s-.1,0-.15.01c-.21.09-.62.18-1.19.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m37.99,42.3c.29-.01.56-.02.84-.03l.02-3.27c-.27.01-.55.02-.84.03l-.02,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.02,42.13c.31-.03.59-.05.86-.08l.02-3.27c-.26.03-.55.05-.86.08l-.02,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m41.87,42.05c.21-.02.41-.04.59-.07l.02-3.27c-.18.02-.38.05-.59.07l-.02,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m38.01,39.03c-.4.01-.81.03-1.24.04.01.03.03.06.04.09.25.67.46,1.35.62,2.05h0s.02.09.03.14h0s0,0,0,0c0,.02,0,.04.01.06.02.09.04.19.06.28.02.07.03.15.05.22,0,.02,0,.04.01.06h0c.01.07.03.14.04.21,0,.04.02.09.02.13.11,0,.22,0,.33-.01l.02-3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m38.83,42.26c.81-.03,1.55-.08,2.19-.13l.02-3.27c-.64.05-1.38.1-2.19.13l-.02,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m41.12,38.63c-.27.01-.55.02-.84.03-1.13.04-2.38.06-3.69.06.06.11.11.23.17.34.43,0,.84-.02,1.24-.04.29,0,.56-.02.84-.03.81-.04,1.55-.08,2.19-.13.31-.02.59-.05.86-.08.21-.02.41-.05.59-.07.58-.08.99-.16,1.19-.25-.12.01-.23.02-.36.03-.64.05-1.38.1-2.19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.92,36.33h0c.18.18.36.37.53.57v-1.44c-.17,0-.35,0-.52,0v.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.33,35.23l-.02,3.27c.12-.01.24-.02.36-.03.05,0,.1,0,.15-.01.12-.01.24-.02.35-.03l.02-3.27c-.26.03-.55.05-.86.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m44.78,35.08l-.02,3.27c.86-.11,1.36-.25,1.36-.39v-3.26c0,.14-.49.27-1.34.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m40.29,38.66c.29-.01.56-.02.84-.03l.02-3.27c-.27.01-.55.02-.84.03l-.02,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m33.9,35.44c.07.05.14.1.21.14.14.12.28.24.42.37h0c.13.13.26.26.39.39h0s0-.88,0-.88c-.35,0-.69,0-1.03-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m44.19,35.15l-.02,3.27c.21-.02.41-.04.59-.07l.02-3.27c-.18.02-.38.05-.59.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m35.45,36.9h0c.05.06.1.11.15.17.12.17.23.34.34.51h0c.06.09.11.18.17.27l.02.04c.16.27.32.55.46.83h0c1.31,0,2.56-.02,3.69-.06l.02-3.27c-1.23.04-2.59.07-4.02.07-.28,0-.56,0-.83,0v1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m41.12,38.63c.81-.03,1.55-.08,2.19-.13l.02-3.27c-.64.05-1.38.1-2.19.13l-.02,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m45.03,34.58c0,.28-3.92.51-8.75.51-.55,0-1.09,0-1.62,0-.43,0-.87,0-1.32,0h0c.06.04.13.08.19.12h0s.09.06.14.09c.04.02.07.05.11.07.03.02.07.05.1.07h0c.34.01.68.02,1.03.02.18,0,.35,0,.53,0,.27,0,.55,0,.83,0,1.43,0,2.79-.02,4.02-.07.29-.01.56-.02.84-.03.81-.04,1.55-.08,2.19-.13.31-.02.59-.05.86-.08.21-.02.41-.05.59-.07.85-.11,1.34-.25,1.34-.39h0c0-.22-1.2-.42-3.11-.56v.12c1.27.09,2.03.2,2.03.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m41.06,34.78c-.26.03-.55.05-.86.08-.64.05-1.38.1-2.19.13-.27.01-.55.02-.84.03-.79.03-1.63.05-2.5.06.52,0,1.06,0,1.62,0,4.83,0,8.75-.23,8.75-.51,0-.12-.76-.24-2.03-.33v.07c0,.14-.5.28-1.36.39-.18.03-.38.05-.59.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m26.04,34.85c-.18-.01-.35-.03-.52-.05.16.02.34.03.52.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.67,31.44l-.02,3.27c.86-.11,1.36-.25,1.36-.39v-3.26c0,.14-.49.27-1.34.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.42,33.79v-2c-.34,0-.69-.02-1.02-.03v1.73c.34.09.68.19,1.02.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m24.71,32.84v-1.39c-.86-.11-1.36-.25-1.36-.39v1.89c.45.05.91.02,1.36-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m25.3,31.52v1.16c.2,0,.4,0,.6.03.14.02.28.05.42.08v-1.18c-.37-.03-.71-.06-1.03-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m37.18,35.02c.29-.01.56-.02.84-.03l.02-3.27c-.27.01-.55.02-.84.03l-.02,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m40.2,34.86c.31-.03.59-.05.86-.08l.02-3.27c-.26.03-.55.05-.86.08l-.02,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.8,34.27l.05.02c.13.06.26.12.38.18.02.01.04.02.06.03h.03s0,.02,0,.02l.02-2.7c-.18,0-.35,0-.53,0v2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m29.4,31.76c-1.15-.04-2.19-.09-3.06-.16v1.18c.71.14,1.42.31,2.13.48.31.07.62.15.93.23v-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m30.76,33.9h.04c.11.05.21.08.32.12h.03s.02.02.02.02h0c.11.04.21.07.32.11h.01c.1.04.2.08.3.12v-2.45c-.46,0-.92-.01-1.37-.02v2c.1.03.21.07.32.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m41.06,34.78c.21-.02.41-.04.59-.07l.02-3.27c-.18.02-.38.05-.59.07l-.02,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m25.29,34.78c-.21-.02-.41-.04-.59-.07.18.02.38.05.59.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m24.71,31.45v1.39s0,0,0,0c.05-.01.1-.03.15-.05.03,0,.06-.02.09-.03.08-.03.15-.06.23-.09.04,0,.08,0,.12,0v-1.16c-.21-.02-.4-.05-.58-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m32.33,34.52h0s0,0,0,0c.04.02.07.04.11.06.05.03.11.06.16.08l.05.03h0s0,0,0,0c.02.01.05.03.07.04.03.01.05.03.08.04l.05.03.05.03s.05.03.07.04h.03s.08.06.12.09c.06.03.12.07.17.1h0s.05.03.05.03c.45,0,.89,0,1.32,0,.88-.01,1.72-.03,2.5-.06l.02-3.27c-1.23.04-2.59.07-4.02.07-.28,0-.56,0-.83,0l-.02,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m38.01,34.99c.81-.03,1.55-.08,2.19-.13l.02-3.27c-.64.05-1.38.1-2.19.13l-.02,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.71,31.45c.18.02.38.05.59.07.31.03.66.06,1.03.09.88.07,1.92.12,3.06.16.34.01.68.02,1.03.03.45.01.91.02,1.39.02.18,0,.35,0,.53,0,.27,0,.55,0,.83,0,1.43,0,2.79-.02,4.02-.07.29-.01.56-.02.84-.03.81-.04,1.55-.08,2.19-.13.31-.02.59-.05.86-.08.21-.02.41-.05.59-.07.85-.11,1.34-.25,1.34-.39h0c0-.43-4.4-.77-9.83-.77s-9.82.34-9.83.77h0s0,0,0,0h0c0,.14.5.28,1.37.39Zm-.28-.51c0-.28,3.92-.51,8.75-.51s8.75.23,8.75.51-3.92.51-8.75.51-8.75-.23-8.75-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m33.18,31.45c4.83,0,8.75-.23,8.75-.51s-3.92-.51-8.75-.51-8.75.23-8.75.51,3.92.51,8.75.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m30.2,55.6v1.25c.33.01.67.02,1.02.03v-2.21c-.31.33-.66.64-1.02.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m33.16,53.64c-.18,0-.35,0-.53,0l-.02,3.26s.08,0,.12,0c.14-.13.28-.27.41-.4l.02-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m34.17,55.4s-.08.09-.12.14c.04-.05.08-.09.12-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m33.75,55.87s-.09.09-.13.14c.04-.05.09-.09.13-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m33.28,56.37s-.06.06-.09.09c.03-.03.06-.06.09-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m28.41,56.77c.43.02.88.04,1.36.06.14,0,.28,0,.43.01v-1.25c-.55.45-1.15.84-1.78,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m32.15,53.63c-.28.36-.59.71-.91,1.03v2.21c.44.01.9.02,1.37.02l.02-3.26c-.16,0-.32,0-.48,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m33.99,53.64c-.28,0-.56,0-.83,0l-.02,2.86h0s.05-.05.05-.05c.03-.03.06-.06.09-.09.12-.12.23-.24.34-.36.04-.05.09-.09.13-.14.1-.11.2-.22.3-.33.04-.05.08-.09.12-.14.14-.15.27-.31.4-.47.31-.42.6-.85.87-1.3-.47,0-.96,0-1.45,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m35.63,53.32c-.04.07-.08.13-.12.2.04-.07.08-.13.12-.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "35.89 52.87 35.89 52.87 35.86 52.92 35.89 52.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "36.28 52.13 36.28 52.13 36.28 52.13 36.28 52.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m35.44,53.64h0s.05-.08.07-.12c.04-.07.08-.13.12-.2.01-.02.02-.04.03-.05-.09,0-.18,0-.28,0-.46,0-.92,0-1.4,0-.53,0-1.06,0-1.56,0-.09.12-.18.25-.28.37.16,0,.32,0,.48,0,.18,0,.35,0,.53,0,.27,0,.55,0,.83,0,.49,0,.98,0,1.45,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m35.67,53.26h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m35.96,52.74l-.02.03.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m33.99,53.27c.48,0,.94,0,1.4,0-.04,0-.08,0-.11,0-.47,0-.94-.01-1.39-.02-.35,0-.7-.02-1.03-.03-.13,0-.26,0-.39-.01-.02.02-.03.04-.05.07.51,0,1.03,0,1.56,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m35.28,53.26h0s.07,0,.11,0c.09,0,.18,0,.28,0h0s0,0,0,0c.05-.08.09-.16.14-.24l.02-3.01c-.06,0-.12,0-.17,0-.08,0-.17,0-.25,0-.04,0-.07,0-.11,0l-.02,3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m36.27,52.15v-.02s.01,0,.01,0c.03-.07.07-.13.1-.2-.04.08-.07.15-.11.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m36.03,52.61c.05-.1.1-.2.15-.29-.05.1-.1.2-.15.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m35.82,53s.03-.05.05-.08l.03-.05s.04-.07.05-.1l.02-.03s.02-.04.04-.07c-.06.11-.12.22-.18.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m32.86,53.21h0c.33.01.68.02,1.03.03l.02-2.71c-.28.73-.63,1.43-1.04,2.08v.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m32.86,53.21h0v-.6c-.12.2-.25.39-.39.58.13,0,.26,0,.39.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m33.89,53.24h0c.45.01.91.02,1.39.02l.02-3.26c-.13,0-.25,0-.38,0-.28,0-.55,0-.81-.01-.06.19-.13.37-.2.55l-.02,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m35.81,53.02h0s0-.01,0-.01c.06-.11.12-.22.18-.33.01-.02.03-.05.04-.07.05-.1.1-.2.15-.29.03-.05.05-.1.08-.16.04-.07.08-.15.11-.23.07-.13.13-.27.19-.4.2-.5.37-1.01.52-1.52-.14,0-.29,0-.43,0-.28,0-.56,0-.83,0l-.02,3.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "37.49 48.47 37.48 48.5 37.49 48.47 37.49 48.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m37.48,48.51s-.02.07-.02.1h0s-.02.08-.03.12c-.02.11-.05.21-.07.32.04-.18.09-.36.13-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m37.35,49.07v.04c-.03.09-.06.17-.08.26-.02.08-.04.16-.06.24h0v.02c-.19,0-.37,0-.55,0-.35,0-.7,0-1.04,0-.3,0-.61,0-.92,0-.16,0-.33,0-.49,0-.03.12-.07.23-.11.35.27,0,.54.01.81.01.13,0,.25,0,.38,0,.04,0,.07,0,.11,0,.08,0,.16,0,.25,0,.06,0,.12,0,.17,0,.27,0,.55,0,.83,0,.15,0,.29,0,.43,0h0c.04-.12.07-.25.11-.37v-.02c.06-.18.1-.36.15-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m37.46,48.61h0s-.02.08-.03.12c0-.04.02-.08.03-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m35.62,49.63c.34,0,.68,0,1.04,0,.18,0,.36,0,.54,0v-.02c-.51.01-1.04.02-1.58.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m37.27,49.37c.02-.09.05-.17.07-.26-.02.09-.05.17-.07.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m35.62,49.63c.54,0,1.07-.01,1.59-.02h0c.02-.08.04-.16.06-.24.02-.09.05-.17.07-.26v-.04s.01-.02.01-.02c.03-.1.05-.21.07-.32,0-.04.02-.08.03-.12,0-.03.02-.07.02-.1h0s0-.04,0-.04c.08-.36.15-.72.21-1.09.04-.35.07-.7.09-1.05,0-.11.01-.22.02-.33,0-.13.01-.26.02-.4h0c0,.13,0,.26-.01.39h0c0,.12-.01.23-.02.34-.97.03-2,.04-3.08.04h0c0,.12,0,.24,0,.36-.04,1-.21,1.97-.48,2.9.16,0,.33,0,.49,0,.31,0,.61,0,.92,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "37.82 45.08 37.82 45.11 37.82 45.06 37.82 45.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m37.82,45.12c0,.05,0,.11,0,.16,0,.06,0,.11,0,.17,0-.11,0-.22,0-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m37.82,45.53c0,.12,0,.25-.01.37,0,.02,0,.04,0,.07v.02c0-.13.01-.26.01-.39,0-.03,0-.06,0-.09v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m37.82,44.87h0s0,.09,0,.13h0s0-.09,0-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m34.7,46.37c1.08,0,2.11-.01,3.08-.04,0-.11.01-.22.02-.33-.21,0-.43,0-.64,0-.18,0-.35,0-.53,0-.06,0-.12,0-.18,0-.56,0-1.15.01-1.75.01h0c0,.12,0,.25,0,.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m37.82,45.44c0-.06,0-.11,0-.17,0,.08,0,.17,0,.25v-.02s0-.04,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m37.82,45.01h0s0,.05,0,.07v-.02s0-.05,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m36.45,45.99c-.41,0-.81-.01-1.2-.02-.19,0-.37,0-.55-.01v.05h0c.6,0,1.18,0,1.75-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m37.8,45.9s0,.04,0,.07c0-.02,0-.04,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m37.18,42.73c-.18,0-.35,0-.53,0l-.02,3.26c.18,0,.35,0,.53,0l.02-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m35.27,42.7c-.35,0-.7-.02-1.03-.03v.31c.28.94.44,1.94.46,2.97.18,0,.36.01.55.01l.02-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m34.23,42.67s-.07,0-.1,0c.03.1.07.21.1.31v-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.65,42.73c-.47,0-.94-.01-1.39-.02l-.02,3.26c.39,0,.79.02,1.2.02.06,0,.12,0,.18,0l.02-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m37.71,42.73c-.18,0-.36,0-.53,0l-.02,3.26c.21,0,.42,0,.64,0h0s0-.03,0-.03c0-.02,0-.04,0-.07,0-.12,0-.25.01-.37,0-.08,0-.17,0-.25,0-.05,0-.11,0-.16h0s0-.04,0-.04c0-.02,0-.05,0-.07,0-.04,0-.09,0-.13,0-.71-.04-1.43-.11-2.14,0-.09-.02-.18-.03-.27,0,.09.02.18.03.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m37.67,42.36s.01.07.02.1c0-.03-.01-.07-.02-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m37.6,41.96c.01.07.03.14.04.21-.01-.07-.02-.14-.04-.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m37.43,41.2s.02.09.03.14c-.01-.05-.02-.09-.03-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m37.56,41.76s.02.08.02.12v.03c0-.07-.03-.15-.04-.22,0,.03.01.06.02.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m35.27,42.7c.45.01.91.02,1.39.02.18,0,.35,0,.53,0,.18,0,.35,0,.53,0,0-.09-.02-.18-.03-.27,0-.04-.01-.07-.02-.1-.6,0-1.18,0-1.75-.01-.61,0-1.25.01-1.9.01.04.1.07.21.11.31.03,0,.07,0,.1,0,.33.01.68.02,1.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m31.24,42.49v-.02s-.03-.06-.04-.09c.01.03.02.06.03.09v.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 31.25,
    y: 42.51,
    width: 0,
    height: 0,
    transform: "translate(-13.88 15.17) rotate(-22.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m37.67,42.36s0-.04-.01-.05c-.56.02-1.14.03-1.74.04.56,0,1.15.01,1.75.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m37.47,41.34s0,.04.01.06c0-.02,0-.04-.01-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m37.58,41.88s-.02-.08-.02-.12c0,.04.02.08.02.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 30.7,
    y: 41.3,
    width: 0,
    height: 0,
    transform: "translate(-15.86 19.38) rotate(-28.16)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "30.21 40.49 30.21 40.49 30.2 40.49 30.21 40.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "30.37 40.73 30.37 40.73 30.38 40.76 30.37 40.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m30.56,41.05s-.03-.04-.04-.06h0s.03.04.04.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m32.63,39.09v.62c.18.26.36.52.52.8v-1.42c-.17,0-.35,0-.52,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m30.87,41.62c.03.05.05.11.08.17.01.03.03.05.04.08v.02c.04.07.07.14.1.21-.03-.07-.06-.14-.09-.21v-.02s-.03-.05-.05-.08c-.03-.06-.05-.11-.08-.17h0s-.02-.05-.03-.07h0s.02.05.03.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m30.02,40.24c.05.07.1.13.14.2.01.02.03.04.04.06-.01-.02-.03-.04-.04-.06-.05-.07-.09-.13-.14-.2l-.03-.04s-.03-.04-.05-.06c.02.02.03.04.05.06l.03.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "29.58 39.69 29.58 39.69 29.62 39.74 29.64 39.76 29.62 39.74 29.58 39.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m29.31,39.39l-.04-.04s-.05-.06-.08-.09l-.05-.05h0s.05.05.05.05c.04.04.08.08.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m29.45,39.55l-.04-.04-.02-.02-.04-.04h0s.04.04.04.04c.02.02.04.04.06.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "28.9 38.99 28.92 39.01 28.94 39.03 28.94 39.03 28.9 38.99 28.89 38.99 28.9 38.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m32.13,39.08c.17.2.34.41.49.63v-.62c-.16,0-.33,0-.49,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m35.92,42.35c.6,0,1.18-.02,1.74-.04h0s-.02-.09-.02-.13c-.01-.07-.03-.14-.04-.21,0-.02,0-.04-.01-.06v-.03s-.02-.08-.03-.12c0-.03-.01-.06-.02-.08-.02-.09-.04-.19-.06-.28,0-.02,0-.04-.01-.06h0s-.02-.09-.03-.14c-.16-.69-.37-1.38-.62-2.05-.01-.03-.03-.06-.04-.09-.06-.11-.11-.23-.17-.34h0c.06.11.12.22.17.34-.88.02-1.81.03-2.78.03-.28,0-.56,0-.83,0v1.42c.34.58.63,1.2.87,1.85.65,0,1.28,0,1.9-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m36.02,37.71h0s.05.09.08.13c-.06-.09-.11-.18-.17-.27h0s.06.09.09.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m33.16,39.09c.27,0,.55,0,.83,0,.96,0,1.9-.01,2.78-.03-.06-.12-.11-.23-.17-.35-.14-.28-.3-.56-.46-.83.05.09.1.17.15.26.02.03.03.06.05.08.07.12.14.25.2.37.02.03.04.07.06.1h0v.02c-.09,0-.19,0-.3,0-.29,0-.57,0-.85,0-.08,0-.16,0-.25,0-.39,0-.79,0-1.2,0-.76,0-1.49,0-2.19-.02.11.12.22.25.33.37.16,0,.33,0,.5,0,.18,0,.35,0,.53,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m28.61,38.74l-.04-.04s-.06-.05-.09-.07c.04.04.09.07.13.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m28.89,38.99h0s-.06-.05-.08-.07c-.03-.03-.06-.05-.09-.08l-.03-.02-.03-.02h0s.04.03.05.05c.06.05.12.1.17.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "36.02 37.71 36.03 37.72 36.02 37.71 36.02 37.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m36.28,38.15s.03.06.05.08c-.02-.03-.03-.06-.05-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m33.99,38.72c.41,0,.81,0,1.2,0-.09,0-.19,0-.28,0-.47,0-.94-.01-1.39-.02-.35,0-.7-.02-1.03-.03-.26,0-.51-.02-.76-.03.02.02.04.05.07.07.7.01,1.43.02,2.19.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "28.45 38.6 28.42 38.58 28.42 38.58 28.43 38.59 28.45 38.61 28.45 38.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m28.22,38.43h0s-.04-.03-.05-.04h0s.04.03.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m36.59,38.7h0s-.04-.07-.06-.1c.02.03.04.07.05.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "26.8 37.57 26.84 37.59 26.84 37.59 26.82 37.58 26.8 37.57 26.8 37.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m26.56,37.46l.04.02s.05.02.07.03c.02,0,.04.02.06.03-.02,0-.04-.02-.06-.03-.02-.01-.04-.02-.07-.03l-.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m26.89,35.58h0c.12.05.23.09.34.14.02.01.05.02.07.03.11.05.23.1.34.16l-.03-.02.2.1v-.91c-.41-.05-.73-.11-.97-.17-.14,0-.27-.02-.4-.03v.54c.15.05.29.1.43.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m27.13,37.74h0s-.04-.02-.06-.03l-.03-.02.03.02s.04.02.07.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m34.11,35.58c.14.12.28.24.42.37-.14-.13-.27-.25-.42-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m34.53,35.95c.13.12.26.25.39.38-.13-.13-.26-.26-.39-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m33.54,35.21h0c-.06-.04-.13-.08-.19-.12h0c.06.04.13.08.19.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m29.45,35.24c-.37-.03-.72-.06-1.03-.09v1.12s.29.14.29.14c.25.12.49.25.73.39v-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m33.68,35.29s.07.05.11.07c-.04-.02-.07-.05-.11-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m32.66,34.69h0s.05.03.07.04c-.02-.01-.05-.03-.07-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m33.13,34.96s-.08-.05-.12-.07h.02s.07.05.11.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m27.38,37.88h.02s.08.06.12.08h0s-.08-.05-.12-.07h-.01s-.03-.03-.03-.03l.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m35.45,36.9h0c-.17-.19-.35-.38-.53-.57v2.38c.08,0,.18,0,.27,0,.08,0,.16,0,.25,0v-1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m27.8,38.14h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m27.62,38.02h0s.04.03.06.04h0s-.04-.03-.06-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m33.52,38.69l.02-3.26c-.35,0-.7-.02-1.03-.03l-.02,3.26c-.26,0-.51-.02-.76-.03.25,0,.5.02.76.03.33.01.68.02,1.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m32.51,35.4c-1.15-.04-2.19-.09-3.06-.16v1.57c.84.5,1.61,1.11,2.29,1.83.25,0,.5.02.76.03l.02-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m33.89,35.43s-.07-.05-.1-.07c-.04-.02-.07-.05-.11-.07-.05-.03-.09-.06-.14-.09h0c.12.08.23.15.35.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m34.92,36.33h0c-.13-.13-.26-.26-.39-.38h0c-.14-.13-.27-.25-.42-.37-.07-.05-.14-.1-.21-.14-.12,0-.24,0-.35,0l-.02,3.26c.45.01.91.02,1.39.02v-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m28.42,35.15c-.21-.02-.41-.05-.59-.07v.91s.58.28.58.28v-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.81,38.14s.07.05.1.07h.01s0,0,0,0h-.01s-.07-.05-.11-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m28,38.27c.05.04.11.07.16.11h0s0,0,0,0h0c-.05-.04-.11-.08-.16-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.03,37.72h0c-.03-.05-.06-.1-.09-.14-.11-.17-.22-.34-.34-.51-.05-.06-.1-.11-.15-.17v1.82c.27,0,.55,0,.84,0,.1,0,.21,0,.31,0v-.02s-.05-.07-.07-.1c-.07-.12-.13-.25-.2-.37-.02-.03-.03-.06-.05-.08-.05-.09-.1-.17-.15-.26l-.02-.04s-.05-.09-.08-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m31.85,34.28l-.05-.02c-.1-.04-.2-.08-.3-.11.12.04.23.09.35.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "31.17 34.04 31.17 34.04 31.17 34.04 31.17 34.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "32.33 34.52 32.33 34.52 32.32 34.51 32.33 34.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m32.45,34.58s-.07-.04-.11-.06h.02s.06.04.09.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "32.91 34.83 32.86 34.8 32.87 34.8 32.91 34.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m28.42,35.15c.31.03.66.06,1.03.09.88.07,1.92.12,3.06.16.34.01.68.02,1.03.03.12,0,.24,0,.35,0h0,0c-.11-.08-.23-.16-.35-.23-.06-.04-.13-.08-.19-.12-.06,0-.12,0-.18,0-.14,0-.29,0-.43,0-.14,0-.28,0-.42,0-.18,0-.35,0-.53,0-.47,0-.94-.01-1.39-.02-.35,0-.7-.02-1.03-.03-.57-.02-1.12-.04-1.63-.07-.13,0-.25-.01-.38-.02-.18,0-.35-.02-.51-.03.23.06.56.12.97.17.18.02.38.05.59.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m31.85,34.28c.13.06.26.12.38.18-.13-.06-.25-.12-.38-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m31.85,34.28c-.12-.05-.23-.09-.35-.13h-.01c.12.04.24.08.37.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m33.3,35.06h0c-.06-.03-.12-.07-.17-.1-.04-.02-.07-.04-.11-.06.09.05.19.11.28.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m32.79,34.76h.03s-.05-.01-.08-.03c-.02-.01-.05-.03-.07-.04h0s.08.05.13.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "32.33 34.52 32.33 34.52 32.32 34.51 32.3 34.5 32.33 34.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m32.37,34.54c.08.04.16.08.24.12-.05-.03-.11-.06-.16-.08-.03-.01-.06-.03-.09-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m32.89,34.82s.06.03.09.05c-.02-.01-.05-.03-.07-.04l-.05-.03h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m24.72,32.84h-.01c-.45.13-.91.16-1.36.11v1.37s.02.05.05.08l.04.03s.07.03.11.05c.22.08.61.16,1.15.23v-1.87s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m26.33,32.78c.72.14,1.42.31,2.14.48-.71-.17-1.42-.34-2.14-.48-.14-.03-.28-.06-.42-.08-.2-.02-.41-.03-.61-.03-.04,0-.08,0-.12,0,.04,0,.08,0,.12,0v2.1c.07,0,.15.02.23.02.16.02.34.03.52.05.09,0,.18.01.28.02v-2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m30.79,33.91c.11.03.21.07.32.11-.11-.04-.21-.07-.32-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m24.95,32.76s-.06.02-.09.03c.03,0,.06-.02.09-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m33.3,35.06c-.09-.06-.18-.11-.28-.16h-.02s-.03-.03-.03-.03c-.03-.02-.06-.03-.09-.05.16.09.31.18.46.27l-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m30.41,35.06v-1.26c.12.03.23.07.34.11-.11-.04-.22-.07-.34-.11-.34-.1-.68-.2-1.03-.29-.31-.08-.62-.16-.93-.23.31.07.62.15.93.23v1.53c.33.01.67.02,1.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m32.37,34.54c.14.07.28.15.42.22-.04-.02-.08-.05-.13-.07l-.05-.03c-.08-.04-.16-.08-.24-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m32.33,34.52l-.04-.02s-.04-.02-.06-.03c-.13-.06-.25-.12-.38-.18-.12-.05-.24-.09-.37-.14-.11-.04-.21-.07-.32-.11h0s-.02,0-.02,0c.22.08.44.15.66.24v.81c.17,0,.35,0,.53,0v-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m26.86,34.91c.17.01.34.02.51.03.12,0,.25.01.38.02.51.03,1.06.05,1.63.07v-1.53c-.3-.08-.61-.16-.92-.23-.71-.17-1.42-.34-2.14-.48v2.09s.08,0,.13.01c.13,0,.26.02.4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m31.8,34.27c-.22-.08-.44-.16-.66-.24h-.03c-.11-.05-.21-.08-.32-.12h-.04c-.11-.05-.22-.08-.34-.12v1.26c.44.01.9.02,1.38.02v-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m25.18,32.67c-.08.03-.15.06-.23.09-.03.01-.06.02-.09.03-.05.02-.1.03-.15.05h-.01s-.01,1.87-.01,1.87c.18.02.38.05.59.07v-2.1s-.07,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m32.89,34.82h-.02s0-.02,0-.02l-.05-.03h-.03c-.14-.09-.28-.16-.42-.24h0s-.02-.02-.02-.02h0s0,0,0,0h0s0,.57,0,.57c.14,0,.28,0,.42,0,.14,0,.28,0,.43,0,.06,0,.12,0,.18,0h0c-.15-.09-.31-.18-.46-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.39,35.03s.08-.01.12-.02c-.04,0-.08.01-.12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.74,35.01c.27.04.54.09.8.16-.26-.06-.53-.11-.8-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.13,34.88c.11,0,.23,0,.34,0-.11,0-.23,0-.34,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.77,34.89s.06,0,.09,0c-.03,0-.06,0-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.48,34.9s.07,0,.11,0c-.04,0-.07,0-.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.66,34.99s.08-.01.12-.02c-.04,0-.08.01-.12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.2,34.92s.08,0,.11,0c-.04,0-.08,0-.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.93,34.95s.08,0,.12-.01c-.04,0-.08,0-.12.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.6,35.19s.08-.02.12-.03c-.04,0-.08.02-.12.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m11.99,49.2c-.02-.07-.03-.15-.05-.22.02.07.03.15.05.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m11.77,45.54c0-.1.02-.2.03-.29-.01.1-.02.19-.03.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m11.92,48.87c-.01-.08-.03-.15-.04-.23.01.08.03.15.04.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m11.73,46.21c0-.11.01-.21.02-.31,0,.1-.01.21-.02.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m11.75,45.85c0-.09.01-.18.02-.27,0,.09-.02.18-.02.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m12.11,49.7c-.04-.14-.07-.29-.11-.43.03.15.07.29.11.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m12.47,50.79c-.03-.07-.05-.14-.08-.21.03.07.05.14.08.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m12.6,51.1c-.03-.07-.06-.14-.09-.21.03.07.06.14.09.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m12.38,50.56c-.05-.15-.1-.3-.15-.45.05.15.1.3.15.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m12.2,50.01c-.02-.07-.04-.14-.06-.22.02.07.04.14.06.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.12,35.07s.08-.01.12-.02c-.04,0-.08.01-.12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.06,55.66c-.26.02-.52.04-.79.04-.1,0-.2,0-.31,0l-.99,1.78s-.04,0-.06,0c-.05,0-.11-.01-.16-.02-.04,0-.08-.01-.12-.02.04,0,.08.01.12.02.05,0,.11.01.16.02.04,0,.08.01.12.01.05,0,.11.01.16.02.04,0,.08,0,.12.01.06,0,.12,0,.17.01.04,0,.08,0,.11,0,.06,0,.13,0,.19,0,.03,0,.06,0,.1,0,.1,0,.19,0,.29,0-.06,0-.12,0-.18,0l1.04-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.09,35.32s.08-.02.11-.03c-.04.01-.08.02-.11.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.83,35.4s.07-.02.11-.03c-.04.01-.07.02-.11.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.58,35.48s.07-.02.1-.03c-.03.01-.07.02-.1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m12.8,51.56c-.07-.14-.13-.28-.19-.42.06.14.12.28.19.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.86,35.13s.08-.02.12-.03c-.04,0-.08.02-.12.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.09,35.67h.03s-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.33,35.57s.06-.02.09-.03c-.03.01-.06.02-.09.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m16.56,37.08c.21-.16.44-.31.66-.45-.23.14-.45.29-.66.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m15.93,37.58c.2-.17.41-.34.63-.5-.21.16-.42.33-.63.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m11.81,45.24c.01-.1.03-.21.04-.31-.02.1-.03.21-.04.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.34,35.25s.08-.02.12-.03c-.04,0-.08.02-.12.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m13.53,45.93v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m14.21,50.25v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m15.72,52.69s-.03-.04-.05-.05c.02.02.03.04.05.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m12.96,42.93l1.41-2.55c-.15.21-.3.43-.44.66-.37.6-.7,1.23-.98,1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.15,36.98s-.06-.01-.09-.02c.02,0,.04,0,.06.01h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m17.08,53.97h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m15.91,52.91l-.04-.04.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.96,36.94h0s0,0,0,0c-.04,0-.08-.02-.13-.03-.03,0-.06-.01-.08-.02.03,0,.06.01.08.02.04,0,.08.02.12.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.41,37.13h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m17.35,54.16h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.19,36.99s.07.02.1.03c-.03,0-.07-.02-.1-.03h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.07,36.95h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.39,37.39h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m17.97,38.28h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m18.54,37.93h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.14,37.62h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.77,37.35h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m17.94,54.54l-.03-.02.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.54,57.53c-.11,0-.22,0-.33,0,.11,0,.22,0,.33,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.27,57.12s.08.02.12.03c.05.01.1.03.15.04-.05-.01-.1-.03-.15-.04-.04-.01-.08-.02-.12-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.29,57.48c-.11.01-.21.02-.32.03.11,0,.21-.02.32-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m18.48,56.86s.06.02.1.04c.05.02.11.04.16.06-.05-.02-.11-.04-.16-.06-.03-.01-.06-.02-.1-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m18.23,56.76s.04.02.06.03c.06.03.13.05.19.08-.06-.02-.13-.05-.19-.08-.02,0-.04-.02-.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.97,35.27c.12.03.24.07.35.11-.12-.04-.23-.07-.35-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.65,57.44c-.12.02-.23.03-.35.04.12-.01.23-.03.35-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.99,57.39c-.11.02-.21.03-.32.05.11-.01.21-.03.32-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.55,35.16c.12.03.23.06.35.09-.11-.03-.23-.06-.35-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.19,55.13h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.51,55.25h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.84,55.35h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.89,36.77h0s.09,0,.13.01h0s.07,0,.1.01c-.03,0-.07,0-.1-.01-.05,0-.09,0-.14-.01-.03,0-.06,0-.09,0,.03,0,.06,0,.09,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.62,55.67h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.87,57.28s.04,0,.06.01c.03,0,.05.01.08.02-.03,0-.05-.01-.08-.02-.02,0-.04,0-.06-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.2,55.44h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.9,55.59h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.88,57.52c-.08,0-.17,0-.25.01.08,0,.17,0,.25-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m13.51,52.82c-.04-.06-.08-.13-.12-.19.04.06.08.13.12.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m17.42,56.38s-.07-.03-.1-.05c.03.02.07.03.1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m17.12,56.22s-.07-.04-.11-.06c.04.02.07.04.11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m13.5,46.78h0s0,.06,0,.08v-.04s0-.04,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m13.55,45.63c.28-2.83,1.75-5.33,3.86-6.96h0l1.1-1.98s-.09.05-.13.07c-.45.26-.89.54-1.31.85-.25.19-.5.39-.74.59l-4.63,8.33c-.01.72.05,1.42.16,2.11l1.67-3.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m15.1,54.73c-.1-.09-.19-.18-.28-.27.09.09.19.18.28.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m14.54,54.15c-.09-.1-.18-.2-.27-.31.09.1.18.21.27.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m14.82,54.44c-.09-.09-.18-.19-.27-.29.09.1.18.19.27.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m16.77,56.01c-.06-.04-.11-.07-.17-.11.06.04.11.07.17.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m16.8,53.75l-.02-.02h0s-.04-.03-.05-.05l-.03-.02-.05-.04s-.05-.04-.07-.06l-.05-.04-.03-.03s-.08-.07-.11-.11l-.03-.03h-.01s-.93,1.65-.93,1.65c-.1-.09-.2-.18-.3-.27.43.41.9.77,1.39,1.1-.21-.14-.42-.29-.62-.45l.91-1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m13.65,40.87c.48-.88,1.09-1.7,1.8-2.41l.48-.87c-2.14,1.82-3.64,4.41-4.08,7.35l.83-1.5c.19-.89.53-1.76.96-2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m15.25,52.1h0s-.01-.02-.01-.02l-.03-.04s-.04-.05-.05-.07c-.01-.02-.03-.04-.05-.06-.03-.04-.06-.08-.08-.13l-.02-.03v-.02s-.03-.03-.03-.03h0c-.04-.07-.09-.14-.13-.21-.01-.02-.03-.04-.04-.07v-.02s-.04-.05-.04-.05c-.02-.03-.03-.05-.05-.08-.01-.03-.03-.05-.04-.08-.02-.04-.04-.08-.07-.12v-.03s-.04-.04-.04-.04l-.02-.04h0s-1.03,1.85-1.03,1.85c.23.36.49.7.76,1.02l.97-1.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.29,37.02s.08.02.13.03c.03,0,.07.02.1.03h0s0,0,0,0c.04.01.08.02.12.04h0s0,0,0,0c.03,0,.06.02.09.03h0s0,0,0,0c.02,0,.05.02.07.02.02,0,.04.01.06.02.03.01.06.02.09.03.05.02.1.03.14.05-.04-.01-.08-.03-.12-.04l.92-1.65c-.14-.06-.29-.11-.43-.16-.05-.02-.09-.03-.14-.05l-.93,1.67s-.07-.02-.1-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "13.77 48.9 13.76 48.86 13.77 48.9 13.78 48.91 13.77 48.9 13.77 48.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 15.46,
    y: 52.39,
    width: 0.01,
    height: 0,
    transform: "translate(-21.77 12.42) rotate(-26.52)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "14.36 50.59 14.38 50.62 14.38 50.62 14.36 50.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m18.23,36.47c.18-.09.36-.17.55-.24l.31-.56c-.65.26-1.27.58-1.86.96l-.35.63c.43-.3.89-.57,1.36-.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "14.05 49.83 14.07 49.87 14.06 49.84 14.05 49.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.06,36.73c.08,0,.16,0,.24,0,.03,0,.05,0,.08,0,.05,0,.11,0,.16,0,.03,0,.06,0,.1,0h0s0,0,0,0c.04,0,.07,0,.11,0h.03s-.01,0-.01,0l.97-1.75c-.41-.06-.84-.1-1.27-.12l-1.03,1.86c.2-.01.41-.02.62-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m13.21,52.33c-.08-.13-.15-.27-.22-.4.07.14.15.27.22.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m13.34,52.55c-.04-.06-.08-.13-.12-.19.04.07.08.13.12.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m12.94,51.84c-.03-.07-.07-.13-.1-.2.03.07.07.13.1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.43,56.68l1.74-3.13s-.05.04-.07.06c-.19.15-.38.29-.57.43-.08.06-.16.11-.25.16-.27.18-.55.34-.84.49h0l-1.37,2.47c-.34.09-.68.17-1.03.23,1.02-.18,2-.5,2.91-.94-.17.08-.34.16-.52.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.95,56.44c.08-.04.16-.08.23-.12-.08.04-.16.08-.23.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m28.45,53.3l-.02.02.02-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "29.69 51.99 29.69 51.98 29.69 51.99 29.69 51.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m28.97,52.81h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.08,49.59s.02-.04.02-.06c0,.02-.02.04-.02.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.45,48.54h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.54,48.18h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.35,48.87v.04s0-.04,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.23,49.22h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.72,44.33c.02.13.04.27.05.4-.01-.13-.03-.27-.05-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.42,43.01c.03.11.07.22.1.33-.03-.11-.06-.22-.1-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.65,43.91c.02.11.04.21.06.32-.02-.11-.04-.21-.06-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.53,43.41c.03.13.06.26.09.39-.03-.13-.06-.26-.09-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m33.59,44.89s0,.06,0,.1c0,.05,0,.1,0,.15l-2.64,4.76c-.06.15-.13.29-.2.43-.07.14-.14.27-.22.41-.13.23-.27.45-.41.66l-2.66,4.78c-.08.05-.17.09-.25.13,3.62-1.87,6.21-5.69,6.39-10.1,0-.13,0-.25,0-.38,0-.03,0-.07,0-.1,0-.11,0-.23,0-.34v-.04c0-.12-.01-.25-.02-.37,0-.03,0-.06,0-.1,0-.05,0-.11-.01-.16,0,.05,0,.11.01.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.39,42.9c-.04-.13-.08-.26-.13-.38.05.13.09.25.13.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.8,45.02c0-.06-.01-.12-.02-.18.04.45.06.9.04,1.37-.01.3-.04.6-.08.89h0s1.74-3.13,1.74-3.13c0,.02,0,.04.01.06-.01-.09-.03-.19-.04-.28,0-.02,0-.05-.01-.07-.02-.12-.04-.23-.07-.35,0-.03-.01-.05-.02-.08-.02-.1-.04-.19-.07-.29,0-.03-.01-.05-.02-.08-.03-.11-.06-.23-.09-.34l-1.37,2.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "31.26 42.52 31.25 42.51 31.25 42.51 31.26 42.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m30.21,40.49h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31,41.89c.03.07.06.14.09.21-.03-.07-.06-.14-.09-.21v-.02s-.03-.05-.05-.08c.01.03.03.05.04.08v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m33.15,42.48s.01.04.02.07c0-.02-.01-.04-.02-.07-.03-.1-.06-.19-.09-.28,0-.03-.02-.06-.03-.08,0,.03.02.06.03.08.03.09.06.19.09.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "29.78 39.92 29.78 39.92 29.82 39.97 29.78 39.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m29.58,39.69l.04.05.02.03s.04.04.05.06c-.02-.03-.05-.06-.07-.09l-.04-.05h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m29.49,39.58s-.05-.05-.07-.08l.04.04.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m29.27,39.35s-.05-.06-.08-.09l-.05-.05.05.05s.06.06.08.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m32.62,41.05v-.03c-.06-.1-.1-.19-.15-.29.05.1.09.19.14.29v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m30.32,40.66s-.06-.09-.09-.14c.05.07.09.14.14.21h0s.02.03.02.03h0c.05.08.09.15.13.22h0s.03.04.04.06h0c.05.08.1.17.14.25h0s0,0,0,0h0s0,0,0,0h0c.04.08.09.17.13.25h0s.02.04.03.06l1.04-1.88c.05.07.09.15.14.22-.05-.09-.11-.17-.16-.26l-.02-.04c-.06-.1-.13-.19-.19-.28-.02-.02-.03-.05-.05-.07-.06-.08-.11-.16-.17-.24l-.04-.05s-.07-.09-.11-.14l-.99,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m28.81,38.91s-.06-.05-.09-.08l-.03-.02.03.02s.06.05.09.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m28.22,38.43h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m28.42,38.58l.03.02h0s.03.03.03.03c.03.02.06.05.09.07-.04-.03-.08-.07-.12-.1l-.03-.02h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.56,37.46l.04.02s.04.02.07.03c-.02-.01-.04-.02-.07-.03-.06-.02-.11-.05-.17-.07.04.02.08.04.13.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "26.8 37.57 26.82 37.58 26.8 37.57 26.8 37.57 26.8 37.57 26.8 37.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.75,37.55s-.06-.03-.09-.04c.02,0,.04.02.06.03h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m28.94,36.66h0s-.05-.04-.08-.05c.03.02.05.03.08.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m27.65,35.91c-.11-.05-.23-.11-.34-.16.11.05.23.1.34.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.89,35.58c.12.05.23.09.34.14-.11-.05-.23-.1-.34-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m27.62,38.02s.04.03.06.04h0s0,0,0,0c.04.02.07.05.11.07h.01s.07.05.11.08c-.08-.05-.15-.1-.23-.15-.02-.01-.04-.03-.06-.04h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "27.52 37.96 27.51 37.95 27.51 37.96 27.52 37.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m30.16,37.63l-.05-.04c-.07-.06-.14-.13-.21-.19.07.06.14.13.21.19l.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m30.98,38.48s-.03-.04-.05-.06l-.02-.02.02.02s.03.04.05.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m27.93,38.22h0s.05.03.07.05c.05.04.11.07.16.11-.08-.06-.15-.11-.23-.16h-.01s.01,0,.01,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "14.99 51.73 15 51.75 15 51.74 14.99 51.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "26.36 42.92 26.36 42.9 26.36 42.91 26.36 42.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m23.35,41.72s.07.02.1.03c-.03-.01-.07-.02-.1-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26.27,42.38h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.36,42.61s-.03.06-.04.08h0s.03-.06.04-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m22.92,41.66h0c.06,0,.12,0,.18.01-.06,0-.12-.01-.18-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.14,43.26c0,.06-.01.12-.02.18h0c0-.06,0-.12.02-.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "14.76 51.35 14.79 51.4 14.78 51.38 14.76 51.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m23.16,41.68s.08.01.12.02c-.04,0-.08-.01-.12-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m14.6,47.7s-.05-.03-.08-.04c.03.01.05.03.08.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.4,44.46l-.02-.03.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.72,44.83l-.03-.03.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.67,42.2s-.04.04-.06.06h0s.04-.04.06-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "26.2 42.16 26.19 42.13 26.19 42.13 26.2 42.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "26.38 43.19 26.38 43.17 26.38 43.19 26.38 43.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.58,44.71v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m24.44,45.67h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "24.66 45.81 24.63 45.78 24.63 45.79 24.66 45.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m24.83,45.94h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "21.13 43.62 21.13 43.65 21.13 43.65 21.13 43.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "15.47 52.4 15.48 52.41 15.47 52.4 15.47 52.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "21.29 44.27 21.3 44.28 21.29 44.27 21.29 44.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.18,43.09s-.02.08-.02.11h0s.01-.08.02-.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.56,42.32s-.04.05-.05.07h0s.04-.05.05-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.29,42.76s-.02.06-.04.09h0s.02-.06.04-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "16.65 53.62 16.69 53.66 16.69 53.66 16.65 53.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "26.32 42.65 26.32 42.63 26.32 42.64 26.32 42.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "15.21 52.05 15.23 52.08 15.21 52.05 15.21 52.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "21.23 44.12 21.24 44.14 21.24 44.16 21.23 44.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.23,42.92s-.02.07-.03.1h0s.02-.07.03-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m23.54,41.78h-.02s.06.01.09.03c-.02,0-.04-.02-.07-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.49,44.59l-.03-.04.03.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "21.15 43.77 21.15 43.79 21.15 43.8 21.15 43.82 21.15 43.77"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 19.51,
    y: 55.24,
    width: 0,
    height: 0.01,
    transform: "translate(-39.08 55.58) rotate(-70.88)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "19.84 55.35 19.84 55.35 19.84 55.35 19.84 55.35"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 19.18,
    y: 55.12,
    width: 0,
    height: 0.02,
    transform: "translate(-39.17 53.67) rotate(-69.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 20.88,
    y: 55.57,
    width: 0,
    height: 0.03,
    transform: "translate(-37.3 67.41) rotate(-80.9)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "22.47 47.08 22.47 47.08 22.51 47.09 22.47 47.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m23.37,47.23s-.05-.02-.07-.03c.03.01.06.02.09.04h-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "21.24 49.99 21.25 50.01 21.27 50.03 21.24 49.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m22.94,47.11s.08.01.12.02c-.04,0-.08-.01-.12-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m23.13,47.15s.07.02.1.03c-.03-.01-.07-.02-.1-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m14.07,49.87v.03s0-.04,0-.06v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m22.7,47.09c.06,0,.12,0,.18.01-.06,0-.12-.01-.18-.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 17.93,
    y: 54.51,
    width: 0,
    height: 0.03,
    transform: "translate(-38.2 42.5) rotate(-59.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "13.59 47.95 13.59 47.95 13.59 47.95 13.59 47.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m23.06,55.66h0c-.26.02-.52.04-.79.04-.1,0-.2,0-.31,0,.1,0,.2,0,.31,0,.27,0,.53-.01.79-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.75,50.45h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.46,46.85s-.05-.02-.07-.03c.02.01.05.02.07.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "21.48 50.25 21.5 50.27 21.47 50.24 21.48 50.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.36,50.14v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.15,49.87l.02.03-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.63,46.92s-.05-.02-.08-.03c.02,0,.05.02.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.97,47.01h-.02s-.04-.01-.04-.01h-.02s.05,0,.08.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m22.33,47.07s-.05,0-.07,0c.02,0,.05,0,.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.8,46.97s-.05-.01-.08-.02c.03,0,.05.02.08.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 21.61,
    y: 55.65,
    width: 0,
    height: 0.03,
    transform: "translate(-35.42 73.38) rotate(-86.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m22.15,47.05s-.05,0-.08-.01c.03,0,.05,0,.08.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.07,49.7v.03s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "14.38 50.62 14.38 50.62 14.38 50.62 14.38 50.62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 20.18,
    y: 55.43,
    width: 0,
    height: 0.03,
    transform: "translate(-38.47 61.88) rotate(-76.26)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "20.96 49.41 20.97 49.43 20.96 49.4 20.96 49.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "16.78 53.73 16.8 53.75 16.78 53.73 16.78 53.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m20.91,49.09v-.05s0,.05,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.62,50.36l-.03-.03.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m20.93,49.25v-.04s0,.04,0,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "14.57 51.01 14.59 51.05 14.59 51.05 14.57 51.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "21.01 49.55 21.01 49.57 21.02 49.59 21.01 49.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26.43,54.69h0c.29-.15.57-.31.84-.49-.27.18-.55.34-.84.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m27.52,54.04c-.08.06-.16.11-.25.16.08-.05.16-.11.25-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m28.16,53.55h0s-.05.04-.07.06c.02-.02.05-.04.07-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "29.69 51.99 29.69 51.99 29.69 51.99 29.69 51.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "28.96 52.82 28.97 52.81 28.96 52.82 28.96 52.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m30.96,49.89h0c-.06.15-.13.29-.2.43.07-.14.14-.28.2-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26.15,48.57s0,.04,0,.06c0-.02,0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26.14,48.33v.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26.04,47.81v.04s0-.04,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.96,47.54s.01.04.02.05c0-.02-.01-.04-.02-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "25.67 46.9 25.65 46.86 25.67 46.9 25.67 46.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m31.54,48.19h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.88,47.32l.02.04-.02-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "25.53 46.68 25.51 46.65 25.51 46.65 25.53 46.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "25.06 46.13 25.02 46.09 25.03 46.1 25.06 46.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26.09,48.04s0,.04.01.06c0-.02,0-.04-.01-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.36,46.45l.03.04-.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.19,46.26l.02.03-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.76,47.07l.02.05-.02-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "31.25 42.51 31.25 42.51 31.25 42.51 31.25 42.51 31.24 42.49 31.23 42.46 31.25 42.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m24.65,40.24h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m24.85,40.37l.03.02-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.25,40.68l.02.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m30.56,41.05c.05.08.1.17.14.25-.05-.08-.09-.17-.14-.25h0s-.03-.04-.04-.06c.01.02.03.04.04.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.42,40.85v.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "26.1 41.89 26.11 41.92 26.1 41.88 26.1 41.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.06,40.51l.03.03-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m30.87,41.62c.03.05.05.11.08.17-.03-.06-.05-.11-.08-.17-.01-.02-.02-.05-.03-.07.01.02.02.05.03.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m30.02,40.24c.05.07.1.13.14.2-.05-.07-.09-.13-.14-.2l-.03-.04s-.03-.04-.05-.06l-.03-.03s.05.06.07.09l.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m28.94,39.03c.07.06.14.13.2.19l.05.05c.06.06.11.11.16.17l.04.05-.04-.05-.04-.05s-.08-.08-.12-.12l-.05-.05c-.07-.07-.13-.13-.2-.2l-.02-.02.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.88,41.45v.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.74,41.23l.02.03-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.58,41.03l.03.03-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.99,41.65v.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m28.16,38.39h0s.04.03.06.04h0s-.04-.03-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m27.39,37.89h-.02s-.03-.03-.03-.03c-.99-.39-2.07-.61-3.2-.61-5.06,0-9.33,4.24-9.55,9.48-.01.33-.01.65,0,.96.02.29.04.57.09.85,0,.03,0,.06.01.09.1.61.25,1.21.46,1.77,1.39.83,3.06,1.31,4.87,1.31.09,0,.19,0,.28,0h0s-.02-.02-.02-.02c-.06-.05-.11-.1-.17-.16h0c-.06-.06-.11-.12-.16-.18h0c-.05-.06-.1-.12-.15-.19h-.01c-.05-.08-.09-.14-.13-.21h0c-.13-.21-.24-.44-.33-.67h0c-.09-.24-.15-.49-.19-.75-.03-.22-.04-.44-.03-.67h1.8l.22.1c-.03.67.31,1.26.83,1.56.03.01.06.03.1.04.11.03.22.06.33.07.06,0,.12,0,.18,0,.12,0,.24-.01.35-.04.11-.02.22-.06.33-.1.1-.05.21-.1.3-.16.19-.13.35-.29.49-.48.07-.09.12-.2.17-.3.02-.05.05-.11.06-.16.06-.17.09-.35.1-.53,0-.12,0-.24-.02-.36-.02-.12-.05-.23-.09-.33-.04-.11-.09-.21-.15-.3-.06-.09-.12-.18-.2-.26-.07-.08-.16-.15-.25-.22-.04-.03-.08-.06-.13-.08-.19-.07-.39-.12-.6-.12-.52,0-1.01-.12-1.44-.33l-.22-.1.04.02s-.04-.02-.05-.03h0c-.15-.07-.29-.16-.42-.25h0c-.23-.16-.43-.34-.61-.54l-.02-.02c-.1-.11-.18-.23-.27-.35h0c-.04-.07-.07-.12-.11-.18l-.02-.03c-.03-.06-.07-.12-.1-.19h0c-.03-.07-.06-.14-.09-.2v-.03c-.03-.06-.06-.12-.08-.18v-.04c-.15-.41-.21-.85-.19-1.3.07-1.7,1.26-3.11,2.79-3.52v-.2s.04-.88.04-.88h1.77l.22.1-.04,1.05c.12.04.25.09.36.15h-.02s.22.1.22.1c1.19.57,1.99,1.84,1.93,3.31h-1.8l-.22-.1c0-.06,0-.11,0-.17,0-.02,0-.03,0-.05,0-.04,0-.08-.01-.11,0-.02,0-.04,0-.06,0-.04-.01-.07-.02-.11v-.05s-.04-.1-.06-.14v-.02s-.04-.09-.06-.13l-.03-.05s-.03-.06-.05-.09c-.01-.02-.02-.04-.03-.05-.02-.03-.03-.05-.05-.08l-.04-.05s-.05-.06-.07-.09l-.05-.05s-.05-.05-.08-.08l-.05-.04s-.04-.03-.06-.05c-.02-.01-.04-.03-.06-.04-.02-.02-.04-.03-.07-.04l-.04-.02c-.18-.07-.39-.11-.6-.11-.95,0-1.76.8-1.8,1.78-.03.67.31,1.26.83,1.56.02,0,.05.02.07.03.02,0,.04.01.06.02.03,0,.06.02.09.02.02,0,.04,0,.06.01.03,0,.07.01.11.02.02,0,.03,0,.05,0,.05,0,.11,0,.16,0,.06,0,.11,0,.17,0,.02,0,.04,0,.06,0,.04,0,.08,0,.11,0,.02,0,.04,0,.07,0,.03,0,.07,0,.1.01.02,0,.05,0,.07.01.03,0,.06.01.1.02.02,0,.05,0,.07.01.03,0,.06.01.09.02.02,0,.05.01.07.02.03,0,.06.02.09.03.02,0,.04.01.07.02.03.01.06.02.09.03.02,0,.04.01.06.02.04.01.07.03.11.05.03.01.06.03.09.04.02,0,.03.02.05.02h-.02s.22.09.22.09c1.2.58,1.99,1.85,1.93,3.33,0,.2-.03.39-.07.57,1.91-1.52,3.16-3.71,3.28-6.14.05-1.15-.15-2.24-.57-3.23h0s-.02-.05-.02-.05c-.03-.07-.06-.14-.09-.21l-.02-.05s-.02-.04-.03-.06c-.03-.06-.06-.12-.09-.19v-.02c-.05-.07-.09-.14-.13-.21-.01-.02-.02-.04-.03-.06-.04-.07-.09-.15-.13-.22h0c-.05-.08-.09-.16-.14-.23-.01-.02-.03-.04-.04-.06-.04-.06-.09-.13-.13-.19l-.02-.03c-.05-.07-.1-.14-.16-.21-.01-.02-.03-.03-.04-.05-.05-.06-.09-.12-.14-.17l-.03-.04s-.05-.06-.08-.09h.02c.08.06.15.11.23.16-.03-.02-.07-.05-.1-.07h-.01s-.07-.06-.11-.08h0s-.04-.03-.06-.04h0s-.07-.04-.1-.06h0s-.08-.05-.12-.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "13.5 46.8 13.5 46.78 13.5 46.82 13.5 46.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "13.77 48.9 13.77 48.9 13.77 48.87 13.76 48.86 13.76 48.86 13.77 48.9 13.77 48.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m28.45,38.61h-.02s.02,0,.02,0c.06.05.12.1.19.15l-.02-.02s-.09-.07-.13-.11l-.03-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "14.78 51.38 14.79 51.4 14.8 51.42 14.8 51.42 14.78 51.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "14.59 51.05 14.59 51.05 14.6 51.07 14.59 51.05 14.59 51.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m15.47,52.39h0s0,.01,0,.01h0s.03.05.04.07c-.02-.03-.04-.05-.06-.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "15.21 52.05 15.23 52.08 15.25 52.1 15.21 52.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m16.39,53.39s.08.07.11.11h0s-.08-.07-.11-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m16.58,53.56s.05.04.07.06l.04.04s-.08-.06-.11-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "18.22 54.69 18.24 54.7 18.23 54.7 18.22 54.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m21.46,52.35l-.05-.02.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m21.32,52.31s-.04-.01-.05-.02c.02,0,.04.01.05.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "21.15 52.24 21.14 52.24 21.18 52.25 21.15 52.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m23.06,55.66h0c1.19-.1,2.33-.44,3.37-.97.29-.15.57-.31.84-.49.08-.05.16-.11.25-.16.2-.14.39-.28.57-.43.02-.02.05-.04.07-.06.09-.07.18-.15.27-.23l.02-.02c.17-.15.34-.32.51-.48h.01c.25-.27.49-.55.71-.83h0s0,0,0,0c.15-.19.29-.39.43-.59.14-.22.28-.44.41-.66.08-.13.15-.27.22-.41.07-.14.14-.28.2-.43.04-.1.09-.2.13-.3,0-.02.02-.04.02-.06.04-.1.08-.2.12-.31h0c.04-.11.07-.22.11-.32v-.04c.05-.11.08-.22.11-.33h0c.03-.12.06-.23.09-.35h0c.09-.36.15-.72.2-1.09.04-.29.06-.59.08-.89.02-.46,0-.92-.04-1.37,0-.04,0-.07-.01-.11-.01-.13-.03-.27-.05-.4,0-.03-.01-.07-.02-.1-.02-.11-.04-.21-.06-.32,0-.04-.01-.07-.02-.11-.03-.13-.06-.26-.09-.39,0-.02-.01-.04-.02-.06-.03-.11-.06-.22-.1-.33-.01-.04-.02-.07-.03-.11-.04-.13-.08-.26-.13-.38h0s0,0,0,0h0s-.02-.05-.02-.05c-.01-.03-.02-.06-.03-.09-.02-.05-.04-.1-.06-.15,0-.02-.02-.04-.02-.06,0-.02-.02-.04-.03-.07-.03-.07-.06-.14-.09-.21v-.02s-.04-.05-.05-.08c-.03-.06-.05-.11-.08-.17-.01-.02-.02-.05-.03-.07-.04-.08-.09-.17-.13-.25h0s0,0,0,0h0c-.05-.09-.09-.17-.14-.25-.01-.02-.03-.04-.04-.06-.04-.07-.09-.15-.13-.22h0s-.02-.03-.02-.03h0c-.04-.07-.09-.14-.14-.21l-.02-.03h0s-.03-.04-.04-.06c-.05-.07-.09-.13-.14-.2l-.03-.04s-.05-.06-.07-.09c-.03-.04-.07-.09-.1-.13h0s-.04-.05-.04-.05c-.03-.03-.05-.06-.08-.09-.02-.02-.04-.04-.05-.06l-.02-.02-.04-.05h0s-.07-.07-.1-.11l-.03-.04s-.04-.04-.06-.06l-.04-.05c-.05-.06-.11-.11-.16-.17l-.05-.05c-.07-.07-.13-.13-.2-.19l-.02-.02-.02-.02h0c-.06-.06-.11-.11-.17-.16-.02-.02-.04-.03-.05-.05l-.03-.03c-.06-.05-.12-.1-.19-.15h-.02s-.01-.02-.01-.02h0c-.07-.05-.13-.1-.2-.15-.02-.01-.04-.03-.06-.04-.05-.04-.11-.08-.16-.11-.02-.02-.05-.03-.07-.05h-.01c-.07-.06-.15-.11-.23-.16h-.02s.05.05.08.08l.03.04c.05.06.1.11.14.17.01.02.03.03.04.05.05.07.11.14.16.21l.02.03c.05.06.09.13.13.19.01.02.03.04.04.06.05.07.1.15.14.22h0c.04.08.09.15.13.23.01.02.02.04.03.06.04.07.08.14.12.21v.02c.04.06.07.12.1.19,0,.02.02.04.03.06l.02.05c.03.07.06.14.09.21l.02.04h0c.42,1.01.62,2.1.57,3.25-.11,2.43-1.37,4.62-3.28,6.14-.28,1.43-1.36,2.58-2.72,2.95l-.04,1.08h-1.77l-.22-.1.04-1.05c-.12-.04-.23-.09-.35-.14l-.22-.1h.01s-.09-.04-.13-.06h-.02c-.07-.05-.13-.09-.19-.12h0c-.06-.04-.13-.09-.19-.13l-.02-.02c-.06-.04-.11-.09-.17-.13-.09,0-.19,0-.28,0-1.82,0-3.49-.48-4.87-1.31.73,2,2.12,3.65,3.91,4.67.03.01.07.03.1.04h.02c.1.05.2.08.31.12h.01c.11.04.22.08.33.11h0c.11.03.22.06.32.09h.03c.22.06.44.11.67.14h.03c.23.04.46.07.69.09h.03c.12.01.23.02.35.02.1,0,.2,0,.31,0,.27,0,.53-.01.79-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "16.8 53.75 16.8 53.75 16.82 53.76 16.78 53.73 16.8 53.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "15 51.74 15 51.75 15.03 51.78 15 51.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "17.07 53.96 17.08 53.97 17.08 53.97 17.05 53.94 17.07 53.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m17.65,54.36h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "17.91 54.52 17.94 54.54 17.95 54.54 17.91 54.52 17.91 54.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m16.12,53.13h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m24.1,52.11c-.1.05-.21.1-.31.15.11-.04.21-.09.31-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m15.88,52.87l.04.04h0s-.03-.03-.05-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m18.87,55h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m15.67,52.64s.03.04.05.05h0s-.04-.05-.07-.07v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.2,55.6c.36-.29.71-.6,1.04-.93.32-.33.63-.67.91-1.03.09-.12.19-.24.28-.37.02-.02.03-.04.05-.07.14-.19.27-.38.39-.58.41-.65.76-1.35,1.04-2.08.07-.18.14-.36.2-.55.04-.11.07-.23.11-.35.27-.93.44-1.9.48-2.9,0-.12,0-.24,0-.36,0-.12,0-.25,0-.37v-.05c-.03-1.03-.19-2.03-.47-2.97-.03-.1-.06-.21-.1-.31-.03-.1-.07-.21-.11-.31-.24-.65-.53-1.27-.87-1.85-.16-.27-.34-.54-.53-.8-.16-.22-.32-.43-.49-.63-.11-.13-.22-.25-.33-.37-.02-.02-.04-.05-.07-.07-.68-.71-1.45-1.33-2.3-1.83-.24-.14-.48-.27-.73-.39l-.3-.14-.59-.28-.2-.1.03.02c.09.04.18.09.27.13.03.01.05.03.08.04.1.05.2.11.3.16h.02c.09.06.18.12.28.18.03.02.05.03.08.05.07.04.13.08.19.13.03.02.05.03.08.05h0s0,.01,0,.01c.09.06.19.13.28.2.02.02.05.03.07.05.08.06.16.12.24.18l.04.03c.09.07.17.14.26.21.02.02.04.04.07.06.07.06.14.13.21.19l.05.04c.08.08.16.15.24.23.02.02.04.04.06.06.07.07.13.13.2.2.02.02.03.04.05.05.07.07.14.15.21.23l.02.02s.03.04.05.06c.06.07.12.14.18.22.02.02.03.04.05.06.03.04.06.08.1.13.04.05.07.09.11.14l.04.05c.06.08.11.16.17.24.02.02.03.05.05.07.06.09.13.19.19.28l.02.04c.05.09.11.17.16.26.02.03.03.05.05.08.06.1.12.2.17.3h0c.05.11.1.21.16.31.01.03.03.05.04.08.05.1.09.19.14.29v.03c.06.11.11.21.15.32.01.03.02.06.03.08.04.09.08.19.11.28l.02.05c.04.11.08.22.12.33,0,.03.02.06.03.08.03.09.06.19.09.28,0,.02.01.04.02.07h0c.03.11.06.23.09.34,0,.03.01.05.02.08.02.1.05.19.07.29,0,.03.01.05.02.08.02.12.05.23.07.35,0,.02,0,.05.01.07.02.09.03.19.04.28v.02s.01.06.02.09c.02.12.03.24.04.36,0,.02,0,.04,0,.06,0,.05,0,.11.01.16,0,.05,0,.11.01.16,0,.03,0,.06,0,.1,0,.12.01.25.02.37v.04c0,.11,0,.23,0,.34,0,.03,0,.07,0,.1,0,.13,0,.25,0,.38-.18,4.41-2.77,8.23-6.39,10.1h-.03c-.08.05-.16.09-.23.13h-.01c-.92.45-1.89.77-2.91.94h-.04c-.11.02-.21.04-.32.06h-.03c-.12.02-.23.03-.35.05h0c-.11.01-.21.02-.32.03-.03,0-.06,0-.09,0-.08,0-.17,0-.25.01-.03,0-.06,0-.09,0-.11,0-.22,0-.33,0-.1,0-.2,0-.29,0-.03,0-.06,0-.1,0-.07,0-.13,0-.19,0-.04,0-.08,0-.11,0-.06,0-.12,0-.17-.01-.04,0-.08,0-.12-.01-.05,0-.11-.01-.16-.02-.04,0-.08,0-.12-.01-.05,0-.11-.01-.16-.02-.04,0-.08-.01-.12-.02-.05,0-.1-.02-.16-.02-.04,0-.08-.01-.13-.02-.05,0-.1-.02-.15-.03-.04,0-.08-.02-.12-.02-.03,0-.05-.01-.08-.02-.03,0-.05-.01-.08-.02-.02,0-.04,0-.06-.01-.02,0-.04,0-.06-.01-.05-.01-.1-.02-.15-.04-.04-.01-.08-.02-.12-.03-.05-.01-.1-.03-.15-.04-.04-.01-.08-.02-.12-.03-.05-.01-.1-.03-.15-.05-.04-.01-.08-.02-.11-.04-.05-.02-.1-.03-.15-.05-.04-.01-.07-.02-.11-.04-.05-.02-.11-.04-.16-.06-.03-.01-.06-.02-.1-.04-.06-.02-.13-.05-.19-.08-.02,0-.04-.02-.06-.03-.08-.03-.17-.07-.25-.11-.02,0-.04-.02-.06-.03-.06-.03-.12-.06-.18-.09h-.01s1.09.52,1.09.52c1.35.65,2.87,1.01,4.49,1.01,1.83,0,3.58-.47,5.13-1.29.63-.34,1.23-.73,1.79-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m15.16,50.41c-.21-.56-.36-1.16-.46-1.77,0-.03,0-.06-.01-.09-.04-.28-.07-.56-.09-.85-.03-.01-.05-.03-.08-.04.03.01.06.03.08.04-.02-.32-.02-.64,0-.96.22-5.24,4.49-9.48,9.55-9.48,1.14,0,2.22.22,3.2.61-.07-.04-.14-.08-.22-.12-.02-.01-.04-.02-.07-.03l-.03-.02c-.06-.03-.13-.07-.19-.1l-.04-.02h0s-.04-.02-.05-.02h-.03s-.04-.03-.06-.04c-.02-.01-.05-.02-.07-.03l-.04-.02s-.08-.04-.13-.05l-.04-.02h-.03c-.06-.04-.12-.06-.18-.09-.03-.01-.05-.02-.08-.03-.05-.02-.09-.03-.14-.05-.03-.01-.06-.02-.09-.03-.02,0-.04-.01-.06-.02-.02,0-.05-.02-.07-.02h0s-.06-.02-.1-.03h0s-.08-.03-.12-.04h0s-.07-.02-.1-.03c-.04-.01-.08-.02-.12-.03-.03,0-.07-.02-.1-.03h-.04s-.03-.02-.03-.02c-.02,0-.04,0-.06-.01-.04,0-.07-.02-.11-.02h0s-.08-.02-.12-.03c-.04,0-.07-.01-.11-.02-.04,0-.08-.02-.13-.02-.04,0-.07-.01-.11-.02-.02,0-.04,0-.07-.01-.02,0-.04,0-.06,0-.04,0-.07-.01-.11-.02-.04,0-.09-.01-.13-.02-.04,0-.07,0-.11-.01-.04,0-.09,0-.13-.01h0s-.07,0-.11,0h-.03s-.07,0-.11,0h0s-.07,0-.1,0c-.05,0-.1,0-.15,0-.03,0-.06,0-.09,0-.07,0-.14,0-.21,0h-.03c-.21,0-.41,0-.62.02-.46.03-.92.1-1.37.2h0c-.22.05-.44.11-.66.18h0c-.22.07-.43.14-.64.22h0c-.21.08-.42.17-.62.27h0c-.2.1-.4.2-.6.31h0c-.2.11-.39.23-.58.35h0c-.19.13-.37.26-.55.39-2.11,1.62-3.58,4.12-3.86,6.96,0,.09-.02.18-.02.27v.02c0,.09-.01.19-.02.29,0,.08,0,.16,0,.24,0,.03,0,.05,0,.08,0,.06,0,.11,0,.17,0,.03,0,.06,0,.09h0s0,.04,0,.04v.04s0,.05,0,.07c0,.03,0,.07,0,.1,0,.02,0,.04,0,.06,0,.06,0,.13.01.19,0,.04,0,.07,0,.11,0,.02,0,.04,0,.06v.02s0,0,0,0c0,.05,0,.1.01.15,0,.03,0,.06.01.09,0,.05.01.09.02.13,0,.03,0,.06.01.09h0s0,.05.01.08c0,.03,0,.06.01.08.02.1.03.19.05.29,0,.02,0,.04.01.06.01.06.02.12.04.18,0,.03.01.06.02.09,0,.04.02.09.03.13v.02s0,.02,0,.02h0s0,.02,0,.02h0c.02.09.04.18.06.26,0,.02.01.04.02.06.02.08.05.16.07.25h0c.04.12.08.24.12.35h0s.01.05.02.07c.04.11.08.22.13.32v.02c.06.12.11.23.16.34v.03s.01,0,.01,0c.05.11.11.23.17.34h0s0,.01,0,.01l.02.04.02.04h0s.01.03.01.03c.02.04.04.08.07.12.01.03.03.05.04.08.02.03.03.05.05.08l.02.03.02.04h0s.03.05.04.07c.04.07.09.14.13.21h0s.02.03.02.03h0s.03.05.03.05c.03.04.06.09.08.13.01.02.03.04.05.06.02.03.04.05.05.07h0s.03.05.03.05h0c.07.1.14.2.22.29h0s.04.05.06.08c.04.05.08.1.12.15.02.03.04.05.07.08.05.05.1.11.14.16.02.02.03.04.05.05.06.07.13.14.2.21h0c.07.08.15.15.22.22h.01s.03.05.03.05c.04.03.08.07.11.1h0s.03.03.03.03l.05.04s.08.07.11.1h0l.03.02s.04.03.05.04h0s0,0,0,0l.04.04c.07.06.15.12.23.18l.04.03c.08.06.17.13.26.19h0c.09.07.18.13.28.19h.02c.08.07.17.12.26.17l.05.03c.09.05.18.1.27.15h.01s.01.01.01.01c.2.1.4.2.6.29h.03c.07.04.13.07.2.09-1.79-1.02-3.18-2.67-3.91-4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.88,39.92c.07.02.15.04.22.07l.04-1.05-.22-.1-.04,1.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.63,41.82h-.03s-.06-.04-.09-.05c-.02,0-.05-.02-.07-.03-.03-.01-.07-.02-.1-.03-.02,0-.04-.01-.07-.02-.04,0-.08-.01-.12-.02-.02,0-.04,0-.06,0-.06,0-.12-.01-.18-.01-.05,0-.09,0-.13,0-.03,0-.06,0-.09,0-.03,0-.06,0-.08.01-.03,0-.06.01-.08.02-.03,0-.05.01-.08.02-.03,0-.05.02-.08.03-.03,0-.05.02-.08.03-.03.01-.05.02-.08.03-.03.01-.05.02-.08.04-.02.01-.05.03-.07.04-.02.01-.05.03-.07.04-.02.02-.05.03-.07.05-.02.02-.05.03-.07.05-.02.02-.04.03-.06.05-.02.02-.04.04-.06.06-.02.02-.04.04-.06.06-.02.02-.04.04-.06.06-.02.02-.04.04-.05.06-.02.02-.04.05-.05.07-.02.02-.03.04-.05.06-.02.03-.03.05-.05.08-.01.02-.03.04-.04.07-.02.03-.03.06-.04.08-.01.02-.02.05-.03.07-.01.03-.02.06-.04.09,0,.02-.02.05-.03.07-.01.03-.02.07-.03.1,0,.02-.01.04-.02.07,0,.04-.02.08-.02.12,0,.02,0,.04-.01.06,0,.06-.01.12-.02.18h0c0,.05,0,.11,0,.16h0s0,.05,0,.05c0,.04,0,.08.01.12v.04s.02.09.03.14v.04s.03.08.05.12h0s.01.05.01.05c.01.04.03.07.05.11h0s.02.05.02.05c.02.04.04.08.06.11l.02.03s.04.07.07.1l.03.04s.05.07.08.1v.02s.08.07.12.1l.03.03s.04.03.07.05c.02.01.04.03.06.04.03.02.06.04.08.05.03.02.05.03.08.05.03.02.06.03.1.05.02,0,.04.02.06.02h.02c-.52-.3-.86-.88-.83-1.56.04-.98.85-1.78,1.8-1.78.21,0,.41.04.6.11h-.02s-.06-.04-.08-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.29,47.21s-.05-.02-.07-.03c-.03-.01-.07-.02-.1-.03-.02,0-.04-.01-.07-.02-.04,0-.08-.01-.12-.02-.02,0-.04,0-.06,0-.06,0-.12-.01-.18-.01s-.13,0-.19,0h-.05s-.04,0-.06,0c-.03,0-.05,0-.08,0-.02,0-.05,0-.07,0-.02,0-.04,0-.05,0h-.02s-.03,0-.03,0c-.03,0-.05,0-.08-.01-.03,0-.07-.01-.1-.02-.03,0-.05-.01-.08-.02-.03,0-.07-.02-.1-.03-.03,0-.05-.01-.08-.02h-.01s-.02,0-.02,0c-.02,0-.04-.01-.07-.02-.03,0-.05-.02-.08-.03-.03-.01-.06-.02-.08-.03h0s0,0,0,0c-.02,0-.05-.02-.07-.03-.03-.01-.06-.03-.09-.04l-.04-.02.22.1c.44.21.92.33,1.44.33.21,0,.42.04.6.12-.04-.03-.09-.05-.14-.07-.03-.01-.06-.03-.09-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m20.91,49.09s0,.08.01.12v.04c.01.05.02.1.04.15v.02s.03.08.05.12l.02.04s.03.07.05.11v.03s.06.09.09.13l.02.03s.04.07.07.1l.03.04s.05.07.08.1v.02s.08.07.12.1l.03.03s.06.05.09.07l.03.03s.08.06.12.08h0c.07.04.13.07.21.1-.52-.3-.86-.89-.83-1.56l-.22-.1c0,.06,0,.11,0,.16v.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.46,52.35l-.05-.02h-.03s-.03-.02-.03-.02h-.03s-.04-.03-.05-.03c-.03-.01-.06-.02-.08-.03l-.04-.02h-.03s-.04-.03-.06-.04h-.01s.22.1.22.1c.11.05.23.1.35.14v-.04s-.09-.03-.14-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m24.61,40.22l.05.02h.01c.06.04.13.08.19.12l.03.02c.06.04.12.08.17.13l.03.03c.06.05.11.09.16.14l.02.02s.08.08.12.12h0s.02.03.02.03v.02c.06.05.1.1.14.14h0s0,.02,0,.02l.03.03c.04.06.09.11.13.17l.02.03c.04.05.07.1.1.16h0s.01.03.01.03v.02c.04.05.07.11.1.17v.02h.01v.02c.04.06.07.12.1.19v.02s.02.03.02.03c.03.06.05.13.07.19h0s.01.05.01.05c.02.07.04.13.06.2h0s0,.02,0,.02h0c.02.08.03.15.05.22v.03s0,.02,0,.02c.01.07.02.15.03.22v.02s0,.03,0,.03c0,.08.01.15.02.23h0s0,.04,0,.04c0,.08,0,.17,0,.25h-1.8l.22.1h1.8c.06-1.47-.74-2.74-1.93-3.31l-.22-.1h.02s.1.06.14.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m26.37,48.98c.06-1.48-.74-2.75-1.93-3.33l-.22-.1h.02s.04.03.04.03c.02.01.05.03.07.04.02.01.05.02.07.04h.02s0,.01,0,.01l.05.03s.04.02.06.04c.02.02.05.03.07.05l.03.02.03.02s.05.04.08.06l.05.04.03.02h.02s.03.04.03.04l.04.03s.05.05.08.07h.01s.04.05.04.05c.05.04.09.09.13.13l.02.03c.05.05.1.11.14.16l.03.04.02.03h0s.06.08.08.11h0s.02.04.02.04c.02.03.04.06.06.09v.02s.05.06.06.08l.02.04h0c.03.06.06.11.09.17l.02.05c.03.07.06.13.09.2l.02.04c.02.06.05.12.07.18,0,.02.01.04.02.05.02.07.04.14.06.22v.04c.02.06.04.13.05.19,0,.02,0,.04.01.06.01.08.02.15.03.23v.02c0,.07.01.14.02.22,0,.02,0,.04,0,.06,0,.08,0,.16,0,.24,0,.05,0,.11,0,.16-.01.16-.04.31-.07.46-.01.05-.02.1-.03.15-.1.4-.26.77-.47,1.11-.05.08-.11.17-.17.25-.34.46-.79.84-1.3,1.11-.1.05-.21.1-.31.15-.05.02-.1.04-.15.06h0c-.09.03-.18.06-.27.09v.09s-.03.76-.03.76v.24h-1.78l.22.1h1.77l.04-1.08c1.36-.36,2.44-1.51,2.72-2.95.04-.19.06-.38.07-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.12,45.24s.04,0,.07,0c-.02,0-.04,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.62,45.22c.05,0,.11,0,.16,0-.05,0-.11,0-.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.46,46.85h0c-.07-.03-.15-.06-.22-.1.02,0,.04.02.05.03.03.01.06.03.09.04.02.01.05.02.07.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.16,43.2s.01-.08.02-.11c0,.04-.02.08-.02.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.2,43.02s.02-.07.03-.1c-.01.03-.02.07-.03.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.8,46.97s.06.02.1.03h.02c-.07-.01-.14-.03-.21-.05h.01s.05.02.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.63,46.92s.04.01.07.02c-.08-.02-.15-.05-.23-.08.03.01.06.02.08.03.02,0,.05.02.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.13,43.44c0-.06,0-.12.02-.18,0,.06-.01.12-.02.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.05,50.58c.11.03.22.06.33.07-.12-.01-.23-.04-.33-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.1,48.88c0,.23,0,.45.03.67l.37-.67h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.45,45.29s.05,0,.07.01c-.02,0-.05-.01-.07-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.31,45.16s.06.02.09.02c-.03,0-.06-.02-.09-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.29,45.26s.05,0,.07.01c-.02,0-.05,0-.07-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.65,50.96c-.13-.21-.24-.43-.33-.66.09.23.2.46.33.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.32,50.29c-.09-.24-.15-.49-.19-.75.04.26.1.51.19.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.79,51.16c-.05-.06-.09-.13-.13-.19.04.07.09.13.13.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.46,45.19s.07.01.11.02c-.04,0-.07,0-.11-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.38,43.15c0-.08,0-.15-.02-.23h0c0,.07.01.15.02.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.36,42.87c0-.07-.02-.15-.03-.22h0c.01.07.02.14.03.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.38,43.44h0c0-.08,0-.17,0-.25h0c0,.08,0,.16,0,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.32,42.6c-.01-.07-.03-.14-.05-.21h0s0-.02,0-.02c.02.08.04.16.05.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.49,40.87s-.04.03-.06.05c-.13.1-.24.23-.36.34-.06.06-.11.12-.17.18-.03.03-.06.06-.08.09l-.08.1c-.21.25-.4.52-.58.8-.18.28-.34.58-.49.89,0-.18.03-.35.07-.52.02-.09.05-.17.07-.25.03-.08.06-.17.09-.25.14-.32.32-.63.55-.9.11-.14.24-.26.37-.38.14-.11.27-.23.43-.32.14-.1.3-.17.46-.24l.27-.49s.08-.02.12-.04c-1.53.41-2.72,1.83-2.79,3.52-.02.46.05.9.18,1.3-.02-.07-.04-.14-.06-.21l2.04-3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.45,41.73s.05-.01.08-.02c-.03,0-.05.01-.08.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.13,43.44c0,.05,0,.11,0,.16,0-.05,0-.11,0-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.26,42.36c-.02-.07-.04-.13-.06-.2v-.03c.02.08.04.15.06.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.57,43.28c0,.05,0,.11,0,.17,0-.06,0-.11,0-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.29,51.69c-.06-.05-.11-.1-.17-.16.05.05.11.11.17.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.61,42.26s.04-.04.06-.06c-.02.02-.04.04-.06.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.78,44.89s-.04-.03-.07-.05l-.03-.03s-.07-.07-.1-.1v-.02s-.07-.06-.1-.1l-.03-.04s-.05-.06-.07-.1l-.02-.03s-.04-.08-.06-.11l.02.04-.98,1.77c-.05-.05-.1-.1-.15-.15.18.21.39.39.61.54l.92-1.66.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.5,42.4s.04-.05.05-.07c-.02.02-.04.05-.05.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.32,42.69s.03-.06.04-.08c-.02.03-.03.06-.04.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.25,42.85s.02-.06.04-.09c-.01.03-.02.06-.04.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.41,42.54s.03-.05.05-.08c-.02.03-.03.05-.05.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22,41.93s.05-.03.07-.04c-.02.01-.05.03-.07.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.33,47.07s.05,0,.08,0c-.07,0-.14-.01-.2-.02.02,0,.04,0,.05,0,.02,0,.05,0,.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.86,42.03s.04-.03.07-.05c-.02.02-.05.03-.07.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.73,42.14s.04-.04.06-.06c-.02.02-.04.04-.06.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.83,41.66h-.04s.09,0,.13,0c.06,0,.12,0,.18.01.02,0,.04,0,.06,0,.04,0,.08.01.12.02.02,0,.04.01.07.02.03,0,.07.02.1.03.02,0,.05.02.07.03h.02s-.05-.01-.08-.02l.92-1.65c.08.03.15.07.22.11-.05-.03-.09-.05-.14-.07-.12-.06-.24-.11-.36-.15-.07-.03-.14-.05-.22-.07h0l.04-1.08h0l-.04.92-1.05,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.59,44.97c-.02-.06-.05-.12-.07-.18.02.06.04.12.07.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "22.16 38.84 22.12 39.72 22.61 38.84 22.16 38.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.69,45.2c-.03-.07-.06-.13-.09-.2.03.07.06.14.09.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.31,51.71h0c.05.05.11.09.17.14-.06-.04-.12-.09-.17-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.3,42.42s-.03-.05-.05-.08c.02.03.04.05.05.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.24,46.76c-.15-.07-.29-.15-.42-.24.13.09.27.17.42.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.19,45.95c-.1-.11-.18-.23-.27-.35.08.12.17.24.27.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.91,45.59c-.04-.06-.07-.11-.11-.17.03.06.07.11.11.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.79,45.39c-.03-.06-.07-.12-.1-.19.03.06.06.13.1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.51,42.9s-.03-.1-.04-.14c.02.05.03.09.04.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.1,47.88c-.06-.09-.12-.18-.2-.26.07.08.14.17.2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.89,45.98l-.03-.03h-.02s-.03-.03-.03-.03c.03.02.05.04.08.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.55,43.06s-.01-.07-.02-.11c0,.04.02.07.02.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.15,43.8c0,.05.02.1.03.15-.01-.05-.02-.09-.03-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.38,42.56s-.03-.06-.05-.09c.02.03.03.06.05.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.57,43.22s0-.08-.01-.11c0,.04,0,.07.01.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.46,42.74s-.04-.09-.06-.13c.02.04.04.09.06.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.49,45.7l-.05-.03h0s-.02-.01-.02-.01c.03.01.05.03.07.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.63,45.79h0s-.05-.03-.07-.05c.03.02.05.03.08.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.77,45.38s.04.01.07.02c-.02,0-.04-.01-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.84,41.94s-.04-.03-.07-.04c.02.01.05.03.07.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.93,45.43s.04.01.06.02c-.02,0-.04-.02-.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.1,45.5s.06.03.09.04c-.03-.01-.06-.03-.09-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.24,48.18c-.04-.11-.09-.21-.15-.3.06.09.11.2.15.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.95,51.36c-.05-.06-.1-.12-.15-.18.05.06.1.12.15.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.55,50.66c.12,0,.24-.01.35-.04-.11.02-.23.04-.35.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.23,50.52c.1-.05.21-.1.3-.16-.09.06-.19.12-.3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.61,45.33s.05.01.07.02c-.02,0-.05-.01-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.21,42.29s-.05-.06-.07-.09c.03.03.05.06.07.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.12,51.54c-.06-.06-.11-.12-.16-.18.05.06.11.12.16.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.97,42.04s-.04-.03-.06-.05c.02.02.04.03.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.09,42.16s-.05-.05-.08-.08c.03.02.05.05.08.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.95,45.23s.04,0,.06,0c-.02,0-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.41,46.52l-.02-.03-.03-.04c-.05-.06-.09-.11-.14-.16l-.02-.03s-.09-.09-.13-.13l-.03-.03c.14.13.27.27.39.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.67,46.9l-.02-.03s-.03-.06-.05-.08c.02.04.05.08.07.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.12,48.22l-2.21,3.99c-.09.04-.18.07-.27.11.05-.02.1-.04.15-.06.11-.04.21-.09.31-.15.51-.26.95-.65,1.3-1.11.06-.08.12-.16.17-.25.21-.34.37-.71.47-1.11.01-.05.02-.1.03-.15.03-.15.05-.31.07-.46,0-.05,0-.11,0-.16,0-.08,0-.16,0-.24,0-.02,0-.04,0-.06,0-.07,0-.15-.01-.22v-.02c-.01-.08-.02-.16-.03-.23,0-.02,0-.04-.01-.06-.01-.07-.03-.13-.04-.19v-.04c-.03-.07-.05-.15-.07-.22,0-.02-.01-.04-.02-.05-.02-.06-.04-.12-.07-.18l-.02-.04c-.03-.07-.06-.14-.09-.2l-.02-.05c-.03-.05-.06-.11-.09-.16.23.39.38.84.45,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.59,46.76s-.04-.06-.06-.09l-.02-.03s.05.07.08.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.56,41.01s-.08-.1-.13-.14v-.02s-.03-.02-.03-.02c.06.06.11.12.16.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.39,40.82s-.08-.08-.12-.12l-.02-.02c-.05-.05-.11-.1-.16-.14l-.03-.03c-.06-.04-.11-.09-.17-.13l-.03-.02c-.06-.04-.12-.08-.19-.12h-.01s-.05-.03-.05-.03c.29.16.56.36.79.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.19,42.11c-.02-.07-.05-.13-.07-.19v-.03c.02.07.05.15.07.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.09,41.86c-.03-.06-.06-.12-.09-.19v-.02h-.01c.03.07.07.14.1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.98,41.63c-.03-.06-.06-.11-.09-.17v-.02s-.02-.02-.02-.02c.04.07.08.14.12.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.86,41.42c-.03-.05-.07-.11-.1-.16l-.02-.03c-.04-.06-.08-.12-.13-.17l-.03-.03h0c.1.12.2.25.29.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.46,52.35s.09.03.14.04c-.07-.02-.15-.04-.22-.07h.03s.05.03.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.36,52.49v-.09c.1-.02.19-.05.28-.09-.09.03-.18.06-.27.09v.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.69,52c-.06-.04-.13-.08-.19-.13.06.04.12.09.19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.89,52.11c-.07-.04-.13-.07-.19-.11.06.04.13.08.19.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.29,41.78s.05-.02.08-.03c-.03,0-.05.02-.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.62,41.69s.06,0,.08-.01c-.03,0-.06,0-.08.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.24,45.14s-.05-.02-.07-.03h-.02s.06.02.09.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.24,44.16v-.02s.03.09.05.13h0s-.03-.08-.05-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.63,41.82s.06.03.08.04c-.03-.02-.06-.03-.08-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.13,43.65h0s0,.09.02.14h0c0-.05,0-.09-.01-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.14,41.85s.05-.03.08-.04c-.03.01-.05.02-.08.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.93,44.98s-.06-.03-.08-.05c.03.02.06.04.08.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.1,45.08s-.06-.03-.1-.05c.03.02.06.03.1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.23,44.11s-.03-.08-.04-.12c.01.04.02.08.04.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.07,47.03s.05,0,.08.01h.03c-.08,0-.15-.02-.23-.04h.02s.07.02.1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.7,47.09c-.08,0-.16,0-.23,0h.05c.06,0,.12,0,.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.37,47.23h.02s.09.06.14.08c.04.03.09.05.13.08-.09-.06-.18-.12-.29-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.36,50.14v-.02s-.07-.06-.1-.1v-.02c.05.09.13.17.21.24h0s-.07-.08-.11-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.17,49.89l-.02-.03s-.05-.09-.07-.13v-.03s-.05-.07-.06-.11v-.02c.05.16.13.31.23.44v-.02s-.06-.06-.08-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.92,52.13s.09.05.13.07c.02.01.04.02.06.03-.07-.03-.13-.06-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.26,52.29s.04.01.05.02h.03c-.07-.01-.14-.04-.2-.07h.03s.06.04.08.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.28,45.58s.05.03.07.04c-.02-.01-.05-.03-.07-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.68,45.82s.05.04.08.06c-.03-.02-.05-.04-.08-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.42,46.53s.06.07.08.11c-.03-.04-.05-.07-.08-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.92,46.01s.05.05.08.07c-.03-.02-.05-.05-.08-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "23.33 53.24 23.2 53.48 21.56 53.48 23.32 53.48 23.33 53.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m14.54,50.96c-.06-.11-.11-.22-.17-.34h0s-.01-.03-.01-.03c-.05-.11-.1-.23-.15-.34v-.02c-.05-.11-.1-.22-.14-.32v-.03s-.03-.04-.03-.04c-.04-.12-.08-.23-.12-.35h0c-.03-.08-.05-.16-.07-.25,0-.02-.01-.04-.02-.06-.02-.08-.04-.16-.06-.25h0s0-.03,0-.03v-.04s0,0,0,0c-.01-.04-.02-.09-.03-.13,0-.03-.01-.06-.02-.09-.01-.06-.02-.12-.04-.18,0-.02,0-.04-.01-.06-.02-.1-.03-.19-.05-.29,0-.03,0-.06-.01-.08,0-.03,0-.05-.01-.08h0s0-.06-.01-.09c0-.04-.01-.09-.02-.13,0-.03,0-.06-.01-.09,0-.05,0-.1-.01-.15v-.02s0-.04,0-.06c0-.04,0-.07,0-.11,0-.06,0-.13-.01-.19,0-.02,0-.04,0-.06,0-.03,0-.07,0-.1,0-.02,0-.05,0-.07,0-.02,0-.05,0-.07h0s0-.07,0-.1c0-.06,0-.11,0-.17,0-.03,0-.05,0-.08,0-.08,0-.16,0-.24,0-.1,0-.19.02-.29v-.02c0-.09.02-.18.03-.27h0s-1.67,3.01-1.67,3.01h0c.01.08.03.15.04.23,0,.04.01.07.02.11.02.07.03.15.05.22,0,.02.01.04.02.07.03.15.07.29.11.43,0,.03.02.06.03.1.02.07.04.14.06.22,0,.03.02.06.03.1.05.15.1.3.15.45v.02c.03.07.06.14.09.21.01.03.03.06.04.1.03.07.06.14.09.21l.02.04c.06.14.12.28.19.42.01.03.03.06.04.08.03.07.07.13.1.2.01.03.03.05.04.08.07.14.15.27.22.4l.02.03c.04.07.08.13.12.19.02.03.03.05.05.08.04.06.08.13.12.19h0s1.03-1.86,1.03-1.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m21.3,35.59c-.98.26-1.91.63-2.78,1.1l-1.1,1.98h0c.18-.14.36-.27.55-.39h0c.19-.13.38-.24.58-.35h0c.2-.11.4-.22.6-.31h0c.2-.1.41-.19.62-.27h0c.21-.08.42-.16.64-.22h0c.22-.07.44-.13.66-.18h0c.45-.1.9-.17,1.37-.2l1.03-1.86h0c-.11,0-.23,0-.34,0h0c-.09,0-.18,0-.27,0-.03,0-.06,0-.09,0-.06,0-.12,0-.18,0-.04,0-.07,0-.11,0-.06,0-.11,0-.17.01-.04,0-.08,0-.11,0-.05,0-.1,0-.16.01-.04,0-.08,0-.12.01-.05,0-.1.01-.15.02-.04,0-.08.01-.12.02-.05,0-.1.01-.15.02-.04,0-.08.01-.12.02-.05,0-.1.02-.15.02-.04,0-.08.01-.12.02-.05,0-.1.02-.14.03-.04,0-.08.02-.12.03-.05.01-.09.02-.14.03-.04,0-.08.02-.12.03-.05.01-.1.02-.14.04-.04,0-.08.02-.12.03-.05.01-.1.03-.14.04-.04.01-.08.02-.11.03-.05.01-.1.03-.14.04-.04.01-.07.02-.11.03-.05.02-.1.03-.15.05-.03.01-.07.02-.1.03-.05.02-.11.04-.16.06-.03.01-.06.02-.09.03-.07.03-.15.06-.22.09h-.03s0,.01,0,.01l-.31.56c.81-.33,1.66-.55,2.52-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m21.33,44.35l-.02-.04-.02-.04h0s-.04-.09-.06-.13v-.02s-.01,0-.01,0c-.01-.04-.03-.08-.04-.12v-.04s-.03-.1-.04-.15v-.02s-.01-.09-.02-.14v-.03s0-.01,0-.01c0-.05,0-.11,0-.16h0s0,0,0,0c0-.06,0-.12.02-.18,0-.02,0-.04.01-.06h0s.01-.08.02-.12h0s.01-.05.02-.07h0s.02-.07.03-.1c0-.02.02-.05.03-.07h0s.02-.06.04-.09c.01-.02.02-.05.03-.07h0s.03-.06.04-.08c.01-.02.03-.05.04-.07.02-.03.03-.05.05-.08.02-.02.03-.04.05-.06h0s.04-.05.05-.07h0s.04-.04.05-.06h0s.04-.04.06-.06c.02-.02.04-.04.06-.06.02-.02.04-.04.06-.06.02-.02.04-.03.06-.05.02-.02.04-.03.07-.05.02-.02.05-.03.07-.05.02-.02.05-.03.07-.04.02-.01.05-.03.07-.04.02-.01.05-.03.08-.04.03-.01.05-.02.08-.03.03-.01.05-.02.08-.03.03,0,.05-.02.08-.03.03,0,.05-.01.08-.02.03,0,.06-.01.08-.02.03,0,.06,0,.08-.01.03,0,.06,0,.09,0h.04s1.05-1.9,1.05-1.9l.04-.92h-1.31l-.49.88v.2s-.09.02-.13.04l-.27.49c.17-.07.34-.12.51-.16-.07.06-.14.11-.21.16-.07.05-.14.09-.2.15-.07.05-.13.1-.2.15-.05.03-.09.07-.13.11l-2.04,3.67c.02.07.04.14.06.21v.04c.03.06.06.12.08.18v.03c.04.07.07.14.1.2h0c.03.07.06.13.1.19l.02.03c.03.06.07.11.11.17h0c.08.13.17.25.27.36l.02.02c.05.05.1.1.15.15l.98-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m16.34,53.34h0c-.07-.07-.15-.14-.22-.22h0c-.07-.07-.13-.14-.2-.21h0s-.04-.04-.04-.04h0c-.05-.06-.1-.12-.14-.17h0s-.03-.04-.05-.06v-.02c-.06-.05-.1-.1-.14-.15-.01-.02-.03-.04-.04-.05h0s0-.02,0-.02h0c-.07-.1-.15-.2-.22-.3h0s-.97,1.74-.97,1.74c.09.1.18.21.27.31h0c.09.1.18.2.27.29h0c.09.1.19.19.28.28h.01c.1.1.2.19.3.28l.93-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m23.78,36.76h0s0,0,0,0c.03,0,.06,0,.09,0,.05,0,.09,0,.14.01.03,0,.07,0,.1.01h0s.09.01.13.02h0s.07.01.1.02c.02,0,.04,0,.06,0,.02,0,.04,0,.07.01h0s.07.01.1.02c.04,0,.09.02.13.02h.02s.06.02.08.02c.04,0,.08.02.13.03.03,0,.07.02.1.02.03,0,.06.01.09.02h.04s0,0,0,0c.03,0,.07.02.1.03.03,0,.07.02.1.03l.93-1.67h0c-.12-.04-.23-.07-.35-.11-.02,0-.05-.01-.07-.02-.11-.03-.23-.06-.35-.09h0c-.26-.06-.53-.12-.8-.16h0s-.97,1.75-.97,1.75h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m31.75,47.1h0c-.05.37-.12.73-.2,1.08h0c-.03.13-.06.24-.09.35h0c-.03.12-.07.23-.1.34v.04c-.05.1-.08.21-.12.31h0c-.04.11-.08.22-.12.32,0,.02-.02.04-.02.06-.04.1-.08.2-.13.3h0s2.64-4.76,2.64-4.76c0-.05,0-.1,0-.15,0-.03,0-.06,0-.1,0-.05,0-.11-.01-.16,0-.05,0-.11-.01-.16,0-.02,0-.04,0-.06-.01-.12-.03-.24-.04-.36,0-.03,0-.06-.01-.09v-.02s-.01-.04-.01-.06l-1.74,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m30.12,51.39h0c-.14.2-.28.4-.43.59h0c-.22.29-.46.56-.71.82h-.01c-.16.18-.33.34-.51.5l-.02.02c-.09.08-.18.15-.27.23h0s-1.74,3.13-1.74,3.13c.17-.07.35-.15.52-.23h.01c.08-.04.16-.08.23-.12h.03c.08-.06.17-.1.25-.15l2.66-4.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m15.6,38.31c.39-.37.81-.72,1.25-1.03l.03-.02.35-.63h0c-.23.14-.45.3-.66.45h0c-.21.16-.42.33-.63.5h0s-.48.87-.48.87c.05-.05.1-.1.15-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m15.9,38.62c-.56.54-1.07,1.13-1.52,1.76l-1.41,2.55c-.13.31-.26.63-.37.95.02-.15.05-.3.09-.45l-.83,1.5h0c-.02.1-.03.21-.04.31h0c-.01.11-.02.2-.03.3v.03c-.01.09-.02.18-.03.27v.05c-.01.1-.02.21-.02.31,0,.11,0,.22,0,.32l4.63-8.33c-.15.13-.3.27-.45.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m23.2,53.48l.13-.24.03-.76v-.09c.1-.02.19-.05.28-.09h0c.09-.03.18-.07.27-.11l2.21-3.99c-.06-.48-.22-.92-.45-1.31h0s0-.01,0-.01c-.02-.04-.05-.08-.07-.12v-.02s-.06-.07-.09-.11h0s0-.01,0-.01c-.03-.04-.05-.07-.08-.11h0c-.12-.15-.25-.29-.39-.42h-.01s-.01-.02-.01-.02c-.03-.02-.05-.05-.08-.07l-.04-.03s-.05-.04-.08-.06l-.05-.04s-.05-.04-.08-.06l-.03-.02-.03-.02s-.05-.03-.08-.05c-.02-.01-.04-.02-.06-.04-.02-.01-.05-.03-.07-.04-.02-.01-.05-.02-.07-.04-.02-.01-.05-.03-.07-.04l-.04-.02s-.03-.02-.05-.02c-.03-.01-.06-.03-.09-.04-.04-.02-.07-.03-.11-.05-.02,0-.04-.02-.06-.02-.03-.01-.06-.02-.09-.03-.02,0-.04-.01-.07-.02-.03,0-.06-.02-.09-.03-.02,0-.05-.01-.07-.02-.03,0-.06-.02-.09-.02-.02,0-.05-.01-.07-.01-.03,0-.06-.01-.1-.02-.02,0-.05,0-.07-.01-.03,0-.07,0-.1-.01-.02,0-.04,0-.07,0-.04,0-.08,0-.11,0-.02,0-.04,0-.06,0-.06,0-.11,0-.17,0s-.11,0-.16,0c-.02,0-.03,0-.05,0-.04,0-.07,0-.11-.02-.02,0-.04,0-.06-.01-.03,0-.06-.02-.09-.02-.02,0-.04-.01-.06-.02-.03-.01-.06-.02-.09-.03-.02,0-.04-.02-.06-.02-.03-.01-.06-.03-.1-.05-.03-.01-.05-.03-.08-.05-.03-.02-.06-.03-.08-.05-.02-.01-.04-.03-.06-.04l-.04-.03-.92,1.66h0c.13.09.27.17.42.24h0c.07.04.14.07.22.1h0c.07.03.15.06.23.08h.02c.07.03.14.04.21.06h.04c.07.03.15.04.23.05h.02c.07.01.14.02.2.03.02,0,.04,0,.06,0h0c.08,0,.15,0,.23,0,.06,0,.12,0,.18.01.02,0,.04,0,.06,0,.04,0,.08.01.12.02.02,0,.04.01.07.02.03,0,.07.02.1.03.02,0,.05.02.07.03.02,0,.05.02.07.03.1.05.2.1.29.16.09.06.17.14.25.22.07.08.14.17.2.26.06.09.11.2.15.3.04.11.07.22.09.33.02.12.03.24.02.36,0,.18-.04.36-.1.53-.02.06-.04.11-.06.16-.05.11-.11.21-.17.3-.13.19-.3.35-.49.48-.09.06-.19.12-.3.16-.1.05-.21.08-.33.1-.11.02-.23.04-.35.04-.06,0-.12,0-.18,0-.12-.01-.23-.04-.33-.07-.03-.01-.06-.02-.1-.04-.07-.03-.14-.06-.21-.1h0s-.08-.05-.12-.08l-.03-.03s-.06-.05-.09-.07l-.02-.02c-.08-.07-.16-.15-.22-.24-.1-.13-.18-.28-.24-.44v-.02s-.03-.08-.05-.12v-.02s0,0,0,0c-.01-.05-.02-.1-.03-.15v-.04s-.02-.08-.02-.12v-.05c0-.05,0-.11,0-.16h-1.4l-.37.67c.04.26.1.51.19.75h0c.09.24.2.46.33.67h0c.04.07.09.14.13.2h.01c.05.08.1.14.15.2h0c.05.06.11.12.16.18h0c.05.06.11.11.17.16l.02.02c.06.05.11.09.17.14l.02.02c.06.04.12.09.19.13h0c.06.04.13.08.19.12h.02c.06.05.13.08.2.11h.03s0,.02,0,.02c.07.03.13.06.2.08h.03c.07.04.14.06.22.08v.04s-.04,1.05-.04,1.05h1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m17.97,56.65c.08.04.17.07.25.11.02,0,.04.02.06.03.06.03.13.05.19.08.03.01.06.02.1.04.05.02.11.04.16.06.04.01.07.02.11.04.05.02.1.03.15.05.04.01.08.02.11.04.05.02.1.03.15.05.04.01.08.02.12.03.05.01.1.03.15.04.04.01.08.02.12.03.05.01.1.02.15.04.02,0,.04,0,.06.01.02,0,.04,0,.06.01.03,0,.05.01.08.02.03,0,.05.01.08.02.04,0,.08.02.12.02.05,0,.1.02.15.03.04,0,.08.01.13.02.05,0,.1.02.16.02.04,0,.08.01.12.02.05,0,.11.01.16.02.02,0,.04,0,.06,0l.99-1.78c-.12,0-.23-.01-.35-.02h0s-.03,0-.03,0h0c-.23-.02-.46-.05-.69-.08h-.03s0,0,0,0c-.23-.04-.45-.08-.67-.14h0s-.03,0-.03,0h0c-.11-.03-.22-.06-.32-.09h0c-.11-.03-.22-.07-.33-.1h-.01s0,0,0,0c-.1-.03-.2-.07-.31-.11h0s-.02,0-.02,0h0s-.07-.03-.1-.04c-.07-.03-.13-.05-.2-.08h-.03c-.2-.1-.41-.2-.6-.3h-.02c-.09-.06-.18-.11-.27-.16h-.01s0,0,0,0l-.03-.02h0s0,0,0,0c-.09-.05-.17-.1-.26-.16h-.02c-.09-.07-.19-.13-.28-.2h0c-.09-.07-.17-.13-.26-.19h0s-.01-.01-.01-.01h-.02c-.08-.07-.15-.13-.23-.19l-.02-.02-.91,1.65c.2.16.41.3.62.45.03.02.06.04.09.06.06.04.11.07.17.11.08.05.16.1.25.15.04.02.07.04.11.06.07.04.14.08.2.11.03.02.07.03.1.05.1.05.2.1.3.15.06.03.12.06.18.09.02,0,.04.02.06.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m26.38,43.19v-.02s0-.01,0-.01c0-.08,0-.16-.02-.24v-.02s0-.02,0-.02c0-.08-.02-.16-.03-.23h0s0-.04,0-.04c-.01-.08-.03-.16-.05-.23h0c-.02-.09-.04-.16-.07-.24h0s0-.02,0-.02c-.03-.07-.05-.15-.08-.22h0s0-.03,0-.03c-.03-.07-.06-.14-.1-.21v-.02c-.05-.07-.09-.14-.13-.21h0c-.09-.15-.18-.28-.29-.41h0c-.05-.07-.1-.13-.16-.19h0c-.23-.25-.5-.45-.79-.61h0c-.07-.04-.15-.08-.22-.11l-.92,1.65s.05.02.08.03c.02,0,.04.02.07.03h.03s.06.04.08.06h.02s.04.04.04.04c.02.01.05.03.07.04.02.01.04.03.06.04.02.02.04.03.06.05l.05.04s.05.05.08.08l.05.05s.05.06.07.09l.04.05s.04.05.05.08c.01.02.02.03.03.05.02.03.03.06.05.09l.03.05s.04.09.06.13v.02s.04.09.05.14v.05s.03.07.03.11c0,.02,0,.04,0,.06,0,.04,0,.07.01.11,0,.02,0,.03,0,.05,0,.05,0,.11,0,.17h1.8c0-.09,0-.17,0-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m27.24,35.72c-.11-.05-.23-.1-.34-.14h0s-.92,1.65-.92,1.65c.04.01.08.03.12.04.02,0,.05.02.07.03.07.03.13.05.2.08h.02s0,0,0,0l.04.02c.06.02.11.05.17.07.02,0,.04.02.07.03.03.01.06.03.09.04.02,0,.04.02.05.02h0s.02,0,.02,0h.02s0,0,0,0c.06.03.13.06.19.1l.03.02s.04.02.06.03h0c.07.04.15.08.22.12l.03.02h.01s.08.05.12.08h.01s.07.05.1.07h0s.04.03.06.04c.08.05.15.1.23.15h.01c.08.06.16.12.23.17h0s.04.03.05.04h0s0,0,0,0c.07.05.13.1.2.15h0s.03.02.03.02c.04.03.08.07.12.1l.04.04.02.02.03.03h0s.03.02.03.02l.03.02s.06.05.09.08c.03.02.06.05.08.07h0s.04.04.04.04h0c.07.06.14.13.2.2h0s.05.05.05.05c.03.03.06.06.08.09l.04.04.04.05h0s.04.04.04.04l.02.02s.05.05.07.08c.03.04.07.07.1.11h0s.04.05.04.05c.03.03.05.06.07.09.03.03.05.06.08.09h0s.04.05.04.05h0s.07.09.1.13l.03.03s.03.04.05.06l.03.04c.05.07.1.13.14.2.01.02.03.04.04.06h0s0,0,0,0l.02.03s.06.09.09.14l.99-1.78s-.06-.08-.1-.13c-.02-.02-.03-.04-.05-.06-.06-.07-.12-.15-.18-.22-.02-.02-.03-.04-.05-.06l-.02-.02c-.07-.08-.14-.15-.21-.23-.02-.02-.03-.04-.05-.05-.06-.07-.13-.14-.2-.2-.02-.02-.04-.04-.06-.06-.08-.08-.16-.16-.24-.23l-.05-.04c-.07-.06-.14-.13-.21-.19-.02-.02-.04-.04-.07-.06-.09-.07-.17-.14-.26-.21l-.04-.03c-.08-.06-.16-.12-.24-.18-.02-.02-.05-.04-.07-.05-.09-.07-.18-.13-.28-.2h0s0-.01,0-.01c-.03-.02-.05-.03-.08-.05-.06-.04-.13-.09-.19-.13-.03-.02-.05-.03-.08-.05-.09-.06-.18-.11-.28-.17h-.02c-.1-.07-.2-.12-.3-.18-.03-.01-.05-.03-.08-.04-.09-.05-.18-.09-.27-.13-.11-.05-.23-.11-.34-.16-.02-.01-.05-.02-.07-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m30.87,41.62h0c.03.06.05.12.08.17.01.03.03.05.04.08v.02c.04.07.07.14.1.21,0,.02.02.04.03.07,0,.02.02.04.02.06.02.05.04.1.06.15.01.03.02.06.03.09v.02s.02.02.02.02h0s0,0,0,0h0c.05.13.09.26.13.39.01.03.02.07.03.11.03.11.07.22.1.33,0,.02.01.04.02.06.03.13.06.26.09.39,0,.04.02.07.02.11.02.11.04.21.06.32,0,.03.01.07.02.1.02.13.04.27.05.4,0,.04,0,.07.01.11,0,.06.01.12.02.18l1.37-2.47h0s-.01-.05-.02-.07c-.03-.1-.06-.19-.09-.28,0-.03-.02-.06-.03-.08-.04-.11-.08-.22-.12-.33l-.02-.05c-.04-.1-.07-.19-.11-.28-.01-.03-.02-.06-.03-.08-.04-.11-.09-.21-.14-.32v-.03c-.06-.1-.1-.19-.15-.29-.01-.03-.03-.05-.04-.08-.05-.1-.1-.2-.16-.3h0c-.06-.11-.11-.21-.17-.31-.02-.03-.03-.05-.05-.08-.05-.08-.09-.15-.14-.22l-1.04,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m26.43,54.69h0c-1.04.53-2.17.87-3.37.97l-1.04,1.88c.06,0,.12,0,.18,0,.11,0,.22,0,.33,0,.03,0,.06,0,.09,0,.08,0,.17,0,.25-.01.03,0,.06,0,.09,0,.11,0,.21-.02.32-.03h0c.12-.01.23-.03.35-.04h.03c.11-.02.21-.03.32-.05h.04c.35-.07.69-.14,1.03-.24l1.37-2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m20.83,41c-.13.12-.26.24-.37.38-.23.27-.41.58-.55.9-.03.08-.06.16-.09.25-.03.08-.05.17-.07.25-.04.17-.07.34-.07.52.15-.31.31-.61.49-.89.17-.28.37-.55.58-.8l.08-.1s.06-.06.08-.09c.06-.06.11-.12.17-.18.12-.11.23-.23.36-.34.02-.02.04-.03.06-.05.04-.04.09-.08.13-.11.07-.05.13-.1.2-.15.06-.06.14-.1.2-.15.07-.05.14-.1.21-.16-.17.04-.34.09-.51.16-.16.06-.31.14-.46.24-.15.09-.29.21-.43.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m18.78,36.22c-.18.08-.37.15-.55.24-.48.23-.93.5-1.36.8l-.03.02c-.44.31-.86.66-1.25,1.03-.05.05-.1.1-.15.15-.71.71-1.32,1.53-1.8,2.41-.44.81-.77,1.67-.96,2.57-.03.15-.06.3-.09.45.11-.32.24-.64.37-.95.28-.66.6-1.29.98-1.89.14-.22.29-.44.44-.66.45-.63.96-1.22,1.52-1.76.15-.14.3-.28.45-.41.24-.21.48-.41.74-.59.41-.31.85-.59,1.31-.85.04-.02.09-.05.13-.07.87-.47,1.81-.84,2.78-1.1-.86.08-1.71.3-2.52.63Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.53,35.8l-1.11-.53.03.02h0c-.11-.06-.23-.11-.35-.16-.03-.01-.05-.02-.08-.03-.07-.03-.15-.06-.22-.09,0,0-.02,0-.02,0-.04-.01-.07-.03-.11-.04h0c-.19-.07-.39-.14-.58-.21h0c-.12-.04-.24-.07-.36-.11-.03,0-.05-.01-.08-.02-.12-.03-.23-.06-.35-.09h0c-.27-.07-.54-.12-.82-.16h0c-.42-.07-.85-.11-1.29-.12-.12,0-.23,0-.35,0-.09,0-.19,0-.28,0-.03,0-.06,0-.09,0-.06,0-.12,0-.19,0-.04,0-.07,0-.11,0-.06,0-.11,0-.17.01-.04,0-.08,0-.12.01-.05,0-.11,0-.16.01-.04,0-.08,0-.12.01-.05,0-.1.01-.15.02-.04,0-.08.01-.12.02-.05,0-.1.01-.15.02-.04,0-.08.01-.12.02-.05,0-.1.02-.15.03-.04,0-.08.01-.12.02-.05,0-.1.02-.15.03-.04,0-.08.02-.12.03-.05.01-.1.02-.15.03-.04,0-.08.02-.12.03-.05.01-.1.02-.14.04-.04.01-.08.02-.12.03-.05.01-.1.03-.14.04-.04.01-.08.02-.12.03-.05.01-.1.03-.15.04-.04.01-.08.02-.11.03-.05.02-.1.03-.15.05-.04.01-.07.02-.11.04-.05.02-.11.04-.16.06-.03.01-.06.02-.09.03-.07.03-.15.06-.22.09h-.03c-.66.28-1.3.61-1.9.99h0c-.23.15-.46.3-.67.46h0c-.22.16-.43.33-.64.51h0c-2.18,1.86-3.72,4.51-4.17,7.5h0c-.02.11-.03.21-.04.32h0c-.01.11-.02.21-.03.31v.03c-.01.09-.02.18-.03.27,0,.02,0,.04,0,.05,0,.11-.01.21-.02.32h0c0,.11,0,.22,0,.33-.01.74.05,1.46.16,2.15h0c.01.08.03.16.04.23,0,.04.01.07.02.11.02.08.03.15.05.23,0,.02.01.05.02.07.03.15.07.29.11.44,0,.03.02.06.03.1.02.07.04.15.06.22.01.03.02.07.03.1.05.16.1.31.16.46v.02c.03.07.06.15.09.22.01.03.03.07.04.1.03.07.06.14.09.21l.02.04c.06.14.13.29.19.43.01.03.03.06.04.09.03.07.07.14.1.2.01.03.03.06.04.08.07.14.15.28.23.42l.02.03c.04.07.08.13.12.2.02.03.03.06.05.08.04.07.08.13.12.2h0c.24.37.5.71.78,1.05h0s.02.03.04.04c.03.04.06.08.1.11.05.05.09.11.14.16h0c.09.1.18.2.28.3h0c.09.1.19.2.29.29h.01c.05.06.11.11.16.16,0,0,0,0,.01.01.04.04.08.07.13.11h0c.16.14.32.27.48.39h0s.03.02.04.03c.02.02.05.04.07.06.03.03.07.05.1.07.02.02.05.04.07.05.03.02.07.05.1.07.02.02.05.03.07.05.06.04.11.08.17.12.03.02.06.04.09.06.06.04.11.07.17.11.08.05.17.1.25.15.04.02.07.04.11.06.07.04.14.08.21.11.03.02.07.04.1.05.1.05.2.11.31.16h0s-.01,0-.01,0l1.11.53c1.38.66,2.93,1.03,4.58,1.03,6.17,0,11.39-5.18,11.65-11.57.19-4.68-2.33-8.71-6.12-10.54Zm-1.94,1.18h.02s.02.02.02.02h0s-.04-.02-.04-.02h0Zm-.81-.34s.06.02.09.03c.03,0,.05.02.08.03,0,0,0,0,0,0-.03-.01-.05-.02-.08-.03-.03-.01-.06-.02-.08-.03Zm.61.25s.04.02.05.03h0s-.04-.02-.06-.03Zm.46.23h0s.04.02.06.03c-.02-.01-.04-.02-.06-.03Zm-1.45-.6h0s.06.02.1.03c0,0,0,0,0,0-.03-.01-.07-.02-.1-.03Zm-.7-.18h0s.07.02.11.02c0,0,0,0,0,0-.04,0-.07-.02-.11-.02Zm-.71-.13s-.05,0-.08,0c.03,0,.05,0,.08.01.04,0,.07.01.11.02h0s-.07-.01-.11-.02Zm-.38-.04s-.02,0-.02,0c0,0,.01,0,.02,0h0Zm.15.01s.03,0,.04,0c.01,0,.02,0,.03,0-.03,0-.05,0-.08,0Zm6.49,4.06l-.02-.03h0s.02.03.02.03h0Zm.15.24s.02.03.03.05h0s-.02-.03-.02-.03h0Zm.48.91v-.02s-.01,0-.01,0c0,0,0,0,0,0v.02s.04.07.06.11c-.02-.04-.03-.07-.05-.11Zm-.13-.27s.03.07.05.1c-.02-.03-.03-.07-.05-.1-.01-.02-.02-.05-.03-.07.01.02.02.04.03.06h0Zm-.72-1.21s.02.02.03.04c0-.01-.02-.03-.03-.04h0Zm-2.01-2.06s0,0,0,0h0s0,0,0,0Zm1.45,1.35s-.01-.01-.02-.02c0,0,.01.01.02.02h0Zm-.49-.53h0s0,0,.01.01c0,0,0,0-.01-.01Zm.87,1h0s0,0,0,0l.03.04c.04.06.08.11.12.17-.04-.06-.08-.11-.12-.17-.01-.01-.02-.03-.03-.04Zm-1.12-1.23s-.05-.05-.08-.07c.03.02.05.05.08.07l.02.02-.02-.02Zm-.21-.18s-.02-.02-.03-.03c-.07-.06-.15-.12-.22-.18l-.02-.02.02.02c.08.06.15.12.22.18.01,0,.02.02.03.03Zm-.78-.6h-.01s0,0,0,0h.01s0,.01,0,.01c0,0,0,0,0,0Zm-.54-.34h0s0,0,0,0h0Zm-1.45-.67s-.01,0-.02,0c-.02,0-.04-.01-.05-.02.02,0,.04.01.05.02,0,0,.01,0,.02,0h0Zm-2.48-.5s.06,0,.1,0h0s-.07,0-.1,0c-.05,0-.1,0-.16,0-.03,0-.06,0-.09,0-.04,0-.08,0-.11,0,.04,0,.08,0,.12,0,.03,0,.05,0,.08,0,.06,0,.11,0,.17,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m18.81,36.92h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m18.18,37.24h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.18,55.14h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m12.42,42.4l1.46-2.63c-.16.22-.31.45-.45.68-.39.62-.72,1.27-1.01,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m13,45.5v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.8,36.23h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.53,55.25h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.45,36.64h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.11,36.41h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m16.67,53.81h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m17.56,54.41l-.03-.02.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m16.95,54.02h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m18.86,55.02h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m15.46,52.72l-.04-.04.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m13.63,49.77s-.01-.04-.02-.06c0,.02.01.04.02.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m13.79,50.15h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m13.7,49.97v-.03s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m15.26,52.5s-.03-.04-.05-.06c.02.02.03.04.05.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m13.87,50.34h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m17.59,37.6h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m28.43,53.13l-.03.02.03-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "31.33 41.98 31.32 41.98 31.32 41.98 31.33 41.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m29.71,51.77h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m28.97,52.62h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "29.82 39.32 29.8 39.3 29.8 39.3 29.8 39.3 29.82 39.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "28.39 37.91 28.42 37.94 28.39 37.91 28.39 37.91 28.39 37.91 28.39 37.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m29.64,39.11h0s.04.05.06.08c-.02-.03-.04-.05-.06-.08-.01-.02-.03-.03-.04-.05.01.02.03.03.04.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.17,49.24s-.02.04-.02.06c0-.02.02-.04.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m28.17,37.74s-.03-.02-.04-.03c-.08-.06-.16-.11-.24-.17.08.06.16.11.24.17.01.01.03.02.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m29.14,38.57h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m28.7,38.17c.06.05.13.11.19.17l.04.04h0s0,0,0,0c.04.03.07.07.11.1h0s-.08-.07-.11-.1l-.04-.04c-.06-.06-.12-.11-.19-.17-.02-.02-.04-.03-.05-.05-.07-.06-.15-.13-.23-.19.08.06.15.12.23.19.02.02.04.03.05.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.85,44.19s0,.04,0,.06c0-.02,0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.68,43.2s.01.05.02.07c0-.02-.01-.05-.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.75,43.55v.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.51,42.56s.01.04.02.06c0-.02-.01-.04-.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.61,42.91s0,.03.01.05c0-.02,0-.03-.01-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.81,43.87s0,.04,0,.06c0-.02,0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.42,42.26s.02.05.03.08c0-.03-.02-.05-.03-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.3,48.91h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.53,48.2h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.42,48.55v.04s0-.04,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.62,47.84h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.11,41.44s-.03-.07-.05-.11v-.02s0,.02,0,.02c.02.04.03.07.05.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m11.16,45.42c0-.09.01-.19.02-.28,0,.09-.02.19-.02.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.78,34.54s.08-.02.12-.03c-.04.01-.08.02-.12.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m11.14,45.8c0-.11.01-.22.02-.32,0,.11-.01.22-.02.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m11.19,45.11c0-.1.02-.2.03-.3-.01.1-.02.2-.03.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m11.34,48.54c-.01-.08-.03-.16-.04-.23.01.08.03.16.04.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m11.41,48.89c-.02-.08-.03-.15-.05-.23.02.08.03.15.05.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m11.22,44.8c.01-.11.03-.21.04-.32-.02.11-.03.21-.04.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19,34.8s.06-.02.09-.03c-.03.01-.06.02-.09.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.26,34.71s.07-.02.11-.04c-.04.01-.07.02-.11.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.52,34.62s.08-.02.11-.04c-.04.01-.08.02-.11.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m18.75,34.9h.03s-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m16.14,36.36c.22-.16.45-.32.68-.47-.23.15-.46.31-.68.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.89,55.34h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m11.54,49.4c-.04-.15-.08-.3-.11-.44.03.15.07.3.11.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m14.63,54.6c-.1-.09-.2-.19-.29-.28.09.1.19.19.29.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m16.35,55.92c-.06-.04-.12-.07-.17-.11.06.04.12.07.17.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m14.33,54.31c-.1-.1-.19-.2-.28-.3.09.1.19.2.28.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m11.63,49.73c-.02-.07-.04-.15-.07-.22.02.08.04.15.07.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m17.03,56.31s-.07-.04-.1-.05c.03.02.07.04.1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m16.72,56.14s-.08-.04-.11-.06c.04.02.08.04.11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m12.98,52.63c-.04-.07-.08-.13-.13-.2.04.07.08.13.13.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m12.04,50.85c-.03-.07-.06-.14-.09-.22.03.07.06.14.09.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m12.67,52.12c-.08-.14-.16-.28-.23-.42.07.14.15.28.23.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m11.82,50.3c-.06-.16-.11-.31-.16-.47.05.16.1.32.16.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m11.91,50.54c-.03-.07-.06-.15-.08-.22.03.07.05.15.08.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m12.39,51.62c-.04-.07-.07-.14-.1-.21.03.07.07.14.1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m12.25,51.32c-.07-.14-.13-.29-.19-.43.06.15.13.29.19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m15.48,36.88c.21-.18.43-.35.65-.52-.22.16-.44.34-.65.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.46,57.41c-.12.02-.24.03-.36.04.12-.01.24-.03.36-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.09,57.45c-.11.01-.22.02-.33.03.11,0,.22-.02.33-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m17.86,56.7s.04.02.06.03c.07.03.13.05.2.08-.07-.03-.13-.05-.2-.08-.02,0-.04-.02-.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m27.25,34.99c.12.05.24.11.35.16-.12-.06-.23-.11-.35-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.82,57.35c-.11.02-.22.04-.33.05.11-.02.22-.03.33-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m27.12,56.25c-.08.04-.16.08-.24.12.08-.04.16-.08.24-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.67,57.49c-.09,0-.17,0-.26.01.09,0,.17,0,.26-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.37,55.58h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m18.39,56.9s.07.03.11.04c.04.01.08.03.13.04-.04-.01-.08-.03-.13-.04-.04-.01-.07-.02-.11-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.62,55.49h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.35,57.39c-.05,0-.11-.02-.16-.03-.04,0-.09-.01-.13-.02.04,0,.09.02.13.02.05,0,.11.02.16.03.04,0,.09.01.13.02.05,0,.11.01.16.02-.05,0-.11-.01-.16-.02-.04,0-.09-.01-.13-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.57,57.24s.03,0,.04,0c.03,0,.05.01.08.02-.03,0-.05-.01-.08-.02-.01,0-.03,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m18.93,57.08s-.06-.02-.08-.03c.03,0,.06.02.08.03.04.01.08.02.12.03.05.01.1.03.15.04-.05-.01-.1-.03-.15-.04-.04-.01-.08-.02-.12-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.93,34.09h0c.12,0,.24,0,.35,0-.12,0-.24,0-.35,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.85,34.28s.08-.02.12-.02c-.04,0-.08.02-.12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.13,34.24s.08-.01.12-.02c-.04,0-.08.01-.12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.86,34.49c.12.03.24.07.36.11-.12-.04-.24-.07-.36-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.4,34.19s.08-.01.12-.02c-.04,0-.08.01-.12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.31,34.4s.08-.02.12-.03c-.04,0-.08.02-.12.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.58,34.34s.08-.02.12-.03c-.04,0-.08.02-.12.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.68,34.16s.08,0,.12-.01c-.04,0-.08,0-.12.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.59,34.22c.28.04.56.1.83.16-.27-.06-.55-.12-.83-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.04,34.47s.08-.02.12-.03c-.04.01-.08.02-.12.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.43,34.38c.12.03.24.06.36.09-.12-.03-.24-.06-.36-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.25,34.11s.07,0,.11,0c-.04,0-.07,0-.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.55,34.1s.06,0,.09,0c-.03,0-.06,0-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.96,34.13s.08,0,.12-.01c-.04,0-.08,0-.12.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m12.8,52.35c-.04-.07-.08-.13-.12-.2.04.07.08.13.12.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m30.24,39.89c.05.07.09.14.14.21l.02.04h0s.02.03.02.03h0s0,0,0,0c.05.07.09.15.14.23h0s0,0,0,0c.01.02.03.04.04.07h0s.05.09.07.13c.02.04.05.09.07.13h0c.05.09.09.18.13.27h0s.02.04.03.06l1.08-1.94-.02-.04-.02-.04c-.06-.1-.13-.2-.2-.29-.02-.02-.03-.05-.05-.07-.06-.08-.12-.16-.18-.24-.01-.02-.02-.03-.04-.05-.04-.05-.08-.1-.11-.15l-1.02,1.84c-.04-.06-.08-.12-.12-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m13,46.92h0s0,.03,0,.04c0-.01,0-.03,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "13.25 48.55 13.25 48.57 13.25 48.55 13.25 48.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m32.58,40.13s-.03-.06-.04-.08c-.02-.03-.03-.07-.05-.1.02.03.04.07.05.1.01.03.03.06.04.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m33.29,41.94v.03s0-.03,0-.03c-.03-.1-.06-.2-.09-.29,0-.03-.02-.06-.03-.09,0,.03.02.06.03.09.03.1.06.19.09.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m12.97,46.39h0s0,.01,0,.01c0,.02,0,.05,0,.07,0-.02,0-.05,0-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m12.98,45.8h0c0,.08,0,.17,0,.25,0-.08,0-.17,0-.25h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "31.23 38.03 31.23 38.03 31.2 37.99 31.23 38.03 31.23 38.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.71,36.04h0,0s-.06,0-.09,0c.03,0,.06,0,.09,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m13.43,49.22s0-.03-.01-.04c.02.07.04.14.07.2-.02-.05-.03-.1-.05-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m13.53,49.51h0s.02.04.03.07c0-.02-.02-.04-.02-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m13.34,48.92c.02.09.05.17.08.25h0s0,0,0,0c-.03-.08-.05-.17-.08-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m30.16,36.9h-.02s-.07-.08-.11-.11c.04.03.07.06.11.1h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m13.33,48.86h0s.01.04.02.06c0-.02-.01-.04-.02-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m28.94,35.93h-.02c-.06-.05-.12-.09-.19-.13.06.04.12.08.19.12h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.51,36.77s.05.02.07.03c-.02-.01-.05-.02-.07-.03-.04-.02-.09-.04-.14-.06h.01s.08.04.12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m27.96,35.33s-.05-.03-.08-.04c-.05-.02-.09-.05-.14-.07.05.02.09.05.14.07.03.01.05.03.08.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m28.13,53.39c-.05.04-.1.08-.16.13-.28.22-.58.43-.89.62-.05.03-.1.06-.15.09-.2.12-.39.23-.6.33l-1.42,2.55c-.35.1-.7.18-1.06.24,1.05-.18,2.07-.51,3.01-.97-.18.09-.36.17-.54.24l1.8-3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.78,57.51l1.08-1.94c-.27.02-.54.04-.81.04-.11,0-.21,0-.32,0l-1.02,1.84s.04,0,.07,0c.06,0,.11.01.17.02.04,0,.08,0,.13.01.06,0,.12,0,.18.01.04,0,.08,0,.12,0,.07,0,.13,0,.2,0,.03,0,.07,0,.1,0,.1,0,.2,0,.3,0,.12,0,.23,0,.35,0-.11,0-.23,0-.35,0-.06,0-.12,0-.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.29,36.68h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.58,36.8h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m27.57,37.34h0s.04.03.06.04c-.02-.01-.04-.03-.06-.04l-.04-.02.04.02h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "27.32 37.18 27.32 37.18 27.32 37.18 27.32 37.19 27.32 37.18 27.28 37.16 27.32 37.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.82,36.21h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.21,36.1h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.85,36.05s.04,0,.05,0c-.02,0-.04,0-.05,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m33.66,43.71v-.04s-.01-.06-.02-.09c0,.03,0,.06.01.09v.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.45,36.14h0s.09.02.13.02c.04,0,.07.01.11.02.03,0,.07.01.1.02h.01s-.08-.01-.11-.02c-.04,0-.07-.01-.11-.02-.04,0-.09-.02-.13-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.34,36.12s.07.01.11.02c-.04,0-.07-.01-.11-.02h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.92,45.29c0,.17,0,.34,0,.5-.01.31-.04.62-.08.92l1.8-3.23s0,.06.01.09c-.01-.1-.03-.21-.05-.31,0-.03,0-.05-.01-.08-.02-.12-.05-.24-.07-.36,0-.03-.01-.05-.02-.08-.02-.1-.05-.2-.07-.3,0-.03-.01-.06-.02-.08-.03-.12-.06-.23-.09-.35l-1.42,2.55c.02.24.03.48.03.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m33.74,44.53c0,.05,0,.11,0,.16l-2.73,4.92c-.23.52-.5,1.01-.81,1.48-.02.03-.03.05-.05.07l-2.75,4.94c-.09.05-.17.09-.26.14,3.75-1.94,6.42-5.88,6.61-10.44,0-.13,0-.26,0-.39,0-.03,0-.07,0-.1,0-.12,0-.24,0-.35v-.04c0-.13-.01-.26-.02-.38,0-.03,0-.07,0-.1,0-.07-.01-.14-.02-.22,0,.07.01.14.02.22,0,.03,0,.07,0,.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "26.72 36.87 26.74 36.88 26.72 36.87 26.72 36.87 26.72 36.87 26.72 36.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m13.12,40.27c.5-.91,1.12-1.75,1.86-2.49l.5-.9c-2.21,1.88-3.77,4.56-4.22,7.6l.86-1.55c.2-.92.54-1.82,1-2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.21,36.02c.21-.01.42-.02.64-.02h.03s.07,0,.11,0c.04,0,.08,0,.12,0,.03,0,.06,0,.08,0,.06,0,.11,0,.17,0,.03,0,.07,0,.1,0h0s0,0,0,0h.03s.07,0,.1,0l1.01-1.81c-.43-.07-.86-.11-1.31-.12l-1.07,1.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m14.77,51.88v-.02s-.06-.07-.08-.1h0s0-.02,0-.02h0s-.02-.04-.04-.06c-.03-.04-.05-.08-.08-.12-.01-.02-.03-.04-.04-.06l-.02-.03-.02-.02h0s-.02-.04-.04-.06v-.02s-.03-.03-.04-.05c-.01-.02-.03-.04-.04-.06l-.02-.03s-.02-.03-.03-.05l-.02-.03s-.04-.08-.07-.11v-.02s-.02-.02-.02-.02h0s-.01-.03-.01-.03c-.03-.06-.06-.11-.09-.17v-.02s-.03-.05-.04-.07v-.02s-.01-.01-.01-.01l-1.07,1.92c.32.49.68.95,1.06,1.37-.09-.1-.19-.21-.28-.32l1-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m17.86,35.72c.19-.09.37-.17.57-.25l.32-.57c-.67.27-1.32.6-1.93.99l-.36.65c.45-.31.92-.59,1.41-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m17.34,56.47h0s0,0,0,0c.03.02.06.03.1.04-.03-.01-.06-.03-.1-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m16.38,53.59l-.02-.02h0s-.04-.03-.05-.05l-.03-.02s-.08-.07-.12-.1c-.02-.01-.03-.03-.05-.04l-.03-.03-.03-.03s-.06-.05-.08-.08l-.04-.03h-.02s-.96,1.71-.96,1.71c-.1-.09-.21-.18-.31-.28.45.42.93.8,1.44,1.14-.22-.15-.44-.3-.65-.46l.95-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m13.02,45.2c.29-2.93,1.81-5.51,4-7.19h0s1.14-2.05,1.14-2.05c-.04.02-.09.05-.13.07-.47.27-.92.55-1.35.88-.26.19-.51.4-.76.61l-4.78,8.61h0c-.01.75.05,1.47.17,2.18l1.73-3.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.16,36.29s-.07-.02-.1-.03c-.04-.01-.09-.02-.13-.03.04.01.09.02.13.03.03,0,.07.02.1.03.04.01.09.02.13.04.03,0,.07.02.1.03h0s0,0,0,0c.04.01.09.03.13.04h0s.06.02.1.03c.05.01.09.03.14.05.03.01.06.02.09.03.05.02.1.04.15.05.03,0,.05.02.08.03-.03,0-.05-.02-.08-.03-.04-.02-.08-.03-.13-.05l.95-1.7c.12.05.24.1.36.15-.31-.13-.62-.25-.95-.36l-.96,1.72s-.07-.02-.11-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m30.15,51.16s.03-.05.05-.07c-.02.03-.03.05-.05.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 31.29,
    y: 48.91,
    width: 0.01,
    height: 0,
    transform: "translate(-25.37 61.6) rotate(-70.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m15.21,52.44s.03.04.05.06h0s-.03-.04-.05-.06h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 31.62,
    y: 47.84,
    width: 0.01,
    height: 0,
    transform: "translate(-22.34 67.25) rotate(-76.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26.26,42.37s0,.03,0,.04h0s0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m31.41,48.59v-.04s0,.04,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m31.15,49.3s.02-.04.02-.06h0s-.02.04-.02.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m31.02,49.61h0c-.23.52-.5,1.01-.81,1.48.31-.47.58-.96.81-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m30.6,40.46s.05.09.07.13c-.02-.04-.05-.09-.07-.13l-.02-.03.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26.28,42.51s0,.04,0,.06h0s0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m22.75,46.73s-.03,0-.05,0c.02,0,.04,0,.05,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m22.61,46.71s.04,0,.06,0c-.02,0-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m22.84,46.75h-.04s.03,0,.05,0h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m23.06,46.81s.03.01.05.02c-.02,0-.03-.01-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m22.89,46.76s.03,0,.05.01c-.02,0-.03,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m22.98,46.78s.03,0,.05.02c-.02,0-.03-.01-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m23.17,46.86h-.02s.03,0,.04.01h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26.28,42.65s0,.05,0,.08h0s0-.05,0-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26.28,42.79s0,.09,0,.14h0s0-.09,0-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m22.48,46.71s.06,0,.09,0c-.03,0-.06,0-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m14.76,51.87s-.05-.07-.07-.1c.02.03.05.07.07.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 29.7,
    y: 51.77,
    width: 0,
    height: 0,
    transform: "translate(-29.36 43.21) rotate(-51.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 31.52,
    y: 48.2,
    width: 0,
    height: 0,
    transform: "translate(-23.21 66.14) rotate(-74.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26.09,41.57s.01.04.02.07h0s-.02-.04-.03-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26.04,41.45s.01.03.02.04v.02s0-.04-.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m31.32,41.97h0s0,0,0,0h0s0,0,0,0v-.04s-.04-.07-.05-.1v-.03s.02.09.04.14c0,.01.01.03.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.99,41.32v.03s.02.02.02.02c0-.02-.01-.03-.02-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "26.21 42.03 26.22 42.05 26.21 42.02 26.21 42.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "26.2 41.96 26.2 41.97 26.2 41.98 26.2 41.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m30.93,41.06c.03.07.07.14.1.2-.03-.07-.06-.14-.1-.2-.01-.02-.02-.05-.03-.07h0s.02.05.04.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.94,41.2v.02s.02.02.02.02c0-.01-.01-.03-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m31.15,41.55s-.02-.05-.03-.07c0-.01-.01-.03-.02-.04.02.04.03.07.05.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m30,39.56l.02.03s.02.03.03.04c-.01-.01-.02-.03-.03-.04l-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26.18,41.88v.04s0-.05-.01-.08c0,.01,0,.03.01.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26.34,54.56c.2-.1.4-.21.6-.33-.2.12-.39.23-.6.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m27.97,53.51c-.28.22-.58.43-.89.62.31-.19.6-.4.89-.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "28.4 53.15 28.43 53.13 28.4 53.15 28.4 53.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m28.13,53.39h0c-.05.04-.1.08-.16.13.05-.04.1-.08.16-.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 28.95,
    y: 52.62,
    width: 0.02,
    height: 0,
    transform: "translate(-28.82 36.19) rotate(-45.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "26.24 42.18 26.24 42.18 26.24 42.18 26.24 42.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "28.19 37.75 28.19 37.75 28.15 37.73 28.19 37.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "25.92 41.17 25.93 41.17 25.92 41.16 25.92 41.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "26.25 42.23 26.25 42.26 26.25 42.27 26.25 42.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "25.88 41.08 25.89 41.09 25.9 41.12 25.88 41.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "22.27 46.7 22.26 46.7 22.29 46.7 22.27 46.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "26.22 42.1 26.23 42.12 26.23 42.12 26.22 42.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m20.89,49.58s.03.05.05.08c-.02-.03-.04-.06-.06-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m12.98,46.58s0,.04,0,.07c0-.02,0-.04,0-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m13.53,49.51s.02.05.02.07c0,.02.01.04.02.06v-.03s-.03-.06-.05-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m20.62,48.68s0-.08,0-.12c0,.04,0,.08,0,.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 13,
    y: 47.18,
    width: 0.03,
    height: 0,
    transform: "translate(-6.84 2.45) rotate(-8.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m20.95,49.68s.02.03.03.04l.02.03s-.04-.05-.06-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.49,50.17s.05.03.08.04h.02s-.07-.02-.1-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.11,49.87s.03.03.04.04l.03.02s-.05-.04-.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.03,49.78s.05.06.07.08c-.02-.03-.05-.05-.07-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.2,49.96s.05.05.08.07h0s-.06-.05-.08-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.42,50.13s.05.03.07.04c-.03-.02-.06-.04-.09-.06l.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.29,50.04s.05.04.08.06c-.03-.02-.06-.04-.08-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m13.44,49.24h0s0-.02,0-.02c.02.05.03.1.05.16v.04c0-.05-.02-.1-.04-.15v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m13.63,49.77s-.01-.03-.02-.05h0s.01.04.02.06c0,.02.01.04.02.05v-.02s-.02-.03-.02-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "14.51 51.5 14.53 51.52 14.51 51.51 14.51 51.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "14.22 51.01 14.22 51.01 14.22 51.01 14.22 51.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m14.37,51.28s.03.04.04.06c-.01-.02-.02-.03-.03-.05h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "14.44 51.39 14.46 51.41 14.45 51.41 14.44 51.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m14.24,51.05s.04.08.07.11c-.02-.03-.03-.06-.05-.09v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m14.18,50.95s-.02-.03-.03-.05c-.01-.03-.03-.05-.04-.08.03.06.06.11.09.17v-.02s-.02-.01-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m13.67,49.89h0s.02.03.02.05v.03s.02.01.02.01c0-.02-.01-.03-.02-.05,0-.01-.01-.03-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m13.76,50.09s.02.04.02.05h0s.01.04.01.04c-.01-.03-.03-.06-.04-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m13.86,50.32v.02s.01,0,.01,0l.02.04h0s-.02-.04-.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m14.06,50.74s.02.05.04.07v-.02s-.03-.03-.04-.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 19.18,
    y: 55.13,
    width: 0,
    height: 0.01,
    transform: "translate(-39.2 55.72) rotate(-71.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 15.44,
    y: 52.68,
    width: 0,
    height: 0.06,
    transform: "translate(-31.48 24.17) rotate(-42.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 19.53,
    y: 55.25,
    width: 0,
    height: 0,
    transform: "translate(-38.94 59.16) rotate(-74.37)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "21.72 46.63 21.69 46.62 21.73 46.63 21.72 46.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "20.59 55.48 20.62 55.49 20.62 55.49 20.59 55.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.52,46.57s-.03,0-.04-.01c.02,0,.05.01.07.02h-.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 19.88,
    y: 55.33,
    width: 0,
    height: 0.03,
    transform: "translate(-38.63 61.19) rotate(-75.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 16.66,
    y: 53.8,
    width: 0,
    height: 0.01,
    transform: "translate(-36.43 34.98) rotate(-53.27)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "22.1 46.69 22.08 46.69 22.1 46.69 22.1 46.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.89,46.66h-.03s.03,0,.05,0h-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "18.83 55.01 18.86 55.02 18.86 55.02 18.83 55.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 17.55,
    y: 54.38,
    width: 0,
    height: 0.03,
    transform: "translate(-38.27 42.07) rotate(-59.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m20.66,48.98s.01.07.02.1c0-.03-.01-.07-.02-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m20.72,49.23v.04s.03.03.03.05c-.01-.03-.02-.06-.03-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m20.68,49.09h0s.02.08.03.11c-.01-.04-.02-.07-.03-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m20.82,49.47s.03.05.04.08c-.02-.03-.03-.05-.04-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m20.76,49.34s.03.07.05.1c-.02-.03-.03-.07-.05-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.86,41.04h0s-.02-.02-.02-.03l.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.2,46.46h0s-.05-.02-.07-.03c.03.01.05.02.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m20.63,48.83s0,.06.01.09v.02s0-.08-.01-.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 21.35,
    y: 55.56,
    width: 0,
    height: 0.03,
    transform: "translate(-35.69 72.63) rotate(-85.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.37,46.53h-.02s-.04-.02-.05-.03h0s.05.02.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m20.63,48.82s0-.07,0-.11c0,.04,0,.07,0,.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "16.04 53.3 16.07 53.33 16.07 53.33 16.04 53.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m14.64,51.69l-.02-.03s-.03-.05-.05-.08c.03.04.05.08.08.12h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m24.89,45.69s.04.04.06.06c-.03-.03-.06-.06-.09-.08h0s.02.03.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m24.98,45.77s.07.07.11.11c-.04-.04-.07-.08-.11-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.29,46.12v.02s-.04-.07-.07-.1c.02.03.04.06.07.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.39,46.25l.02.03s-.06-.09-.09-.13c.02.03.04.05.06.08v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.7,46.78s.03.07.05.11c-.02-.04-.03-.07-.05-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.76,46.93s.04.1.06.15c-.02-.05-.04-.1-.06-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.11,45.91s.05.06.08.09c-.03-.03-.05-.06-.08-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.6,46.6s.05.09.07.14c-.02-.05-.05-.09-.07-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.61,40.64s.03.05.05.07c-.02-.02-.03-.05-.05-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "24.75 45.56 24.72 45.54 24.74 45.56 24.75 45.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m23.03,41.12s.03,0,.05.01c-.02,0-.03,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.74,40.83h0s-.03-.05-.05-.07c.02.02.03.05.05.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m24.63,45.47s-.03-.02-.05-.03l.03.02h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m24.71,45.53s-.05-.04-.07-.05l.02.02s.03.02.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.83,47.11s.03.09.04.13c-.01-.04-.03-.09-.04-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m23.12,41.14s.03,0,.05.01c-.02,0-.03,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m24.83,45.63s-.05-.04-.07-.06l.02.02s.03.03.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m23.21,41.17s.03,0,.05.02c-.02,0-.03-.01-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.99,47.71s0,.04.01.06c0-.04-.02-.09-.02-.13,0,.02,0,.05.01.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.56,46.52s.03.05.05.08c-.03-.05-.05-.09-.08-.14,0,.01.02.03.03.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26.15,41.79s-.02-.06-.02-.09c0,.03.02.06.02.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m20.86,42.94s0,.08,0,.11h0s0-.07,0-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.01,39.99s.05.04.07.06c-.02-.02-.05-.04-.07-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.8,40.93v.02s-.02-.05-.03-.07c.01.02.02.04.03.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "25.82 40.97 25.82 40.97 25.83 40.99 25.82 40.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m24.79,39.82s.05.03.07.05c-.02-.02-.05-.03-.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m24.39,39.57s.03.02.05.03h.01s.04.03.06.04c-.04-.02-.08-.05-.12-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26,49.04c-.02.09-.04.19-.06.28.02-.09.04-.18.06-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26.01,47.82s.01.09.02.14c0-.05-.01-.09-.02-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26.03,47.99c0,.06.01.11.01.17,0-.06,0-.11-.01-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.94,47.44c.01.05.03.11.04.16-.01-.05-.02-.11-.04-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m23.4,41.24h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.47,46.39l.02.04s-.04-.07-.07-.1c.01.02.02.03.03.05v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.89,47.28s.02.08.04.12c-.01-.04-.02-.08-.04-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26.05,48.2s0,.09,0,.13c0-.04,0-.09,0-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m26.05,48.38c0,.06,0,.12,0,.17,0-.06,0-.12,0-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m24.53,45.4h.02s-.07-.03-.1-.06l.02.02s.04.03.06.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m20.86,43.17v.03s0,0,0,0c0-.03,0-.06,0-.08,0,.02,0,.04,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.41,44.32s-.05-.04-.07-.07c.02.02.04.05.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.22,40.17s.03.03.04.05h0s-.04-.03-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.33,44.24s-.05-.05-.07-.08c.02.03.05.06.07.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m15.96,53.22s.06.05.08.08c-.03-.03-.06-.05-.08-.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.49,44.4h0s-.04-.03-.07-.05c.02.02.04.03.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.24,44.14s-.04-.05-.06-.07c.02.03.04.05.06.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.45,40.43h.01s.03.06.03.06c-.01-.02-.03-.04-.05-.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 21.6,
    y: 44.48,
    width: 0,
    height: 0,
    transform: "translate(-27.18 36.37) rotate(-54.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.01,43.77h0s0,.03,0,.03c0-.02-.01-.03-.02-.05v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.17,44.05s-.04-.06-.06-.09c.02.03.04.06.06.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m20.98,43.69s-.01-.03-.02-.05c0,.02.01.03.02.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "25.35 40.31 25.36 40.32 25.34 40.3 25.35 40.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m20.93,43.54h0s0,.03,0,.03c0-.02-.01-.04-.02-.06v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.36,40.33h.01s.03.05.03.05c-.01-.02-.03-.03-.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m16.36,53.57l.02.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "25.27 40.23 25.28 40.24 25.31 40.27 25.27 40.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m21.07,43.88h0s.02.04.03.05c-.01-.02-.03-.05-.04-.07v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m20.88,43.31h0s0,.01,0,.01c0-.02,0-.05,0-.07,0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "24.28 45.24 24.25 45.22 24.26 45.22 24.28 45.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m24.67,39.74s.05.03.07.05c-.02-.02-.05-.03-.07-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "25.18 40.14 25.18 40.14 25.21 40.16 25.18 40.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m24.9,39.9s.04.04.07.05c-.02-.02-.04-.04-.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m22.94,41.11s.04,0,.05,0c-.02,0-.04,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m22.71,41.09s.06,0,.09,0c-.03,0-.06,0-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m22.84,41.1s.04,0,.06,0c-.02,0-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m24.4,45.31h.02s-.09-.05-.13-.07c.02.01.04.02.05.03.02.01.04.03.06.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m22.86,55.57h0c-.27.02-.54.04-.81.04-.11,0-.21,0-.32,0,.1,0,.21,0,.32,0,.27,0,.55-.01.81-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m16.16,53.4h0s.08.07.12.1c-.04-.03-.08-.07-.12-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.53,40.53h0s.03.05.04.06c-.02-.02-.03-.04-.05-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m20.9,43.42v.02s0,0,0,0c0-.02,0-.04-.01-.06v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m24.54,39.65h.02s0,.02,0,.02c.02.01.04.03.06.04-.03-.02-.06-.04-.09-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "25.44 40.42 25.44 40.42 25.44 40.41 25.44 40.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m24.23,45.21s-.06-.03-.09-.05c.02,0,.03.02.05.02l.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m25.17,40.13h0s-.04-.03-.06-.05c.02.02.04.03.05.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m27.32,37.18l-.03-.02c-1.02-.41-2.14-.63-3.31-.63-5.23,0-9.65,4.39-9.87,9.8-.01.34-.01.67,0,1-.02-.01-.05-.03-.08-.04.03.01.06.03.08.04.02.3.05.59.09.88,0,.03,0,.07.01.1.1.63.26,1.25.47,1.83,1.43.86,3.16,1.35,5.04,1.35.1,0,.2,0,.29,0-.02-.01-.03-.03-.05-.04-.02-.02-.04-.03-.06-.05-.01-.01-.03-.03-.04-.04-.02-.02-.04-.04-.06-.06l-.02-.02s-.1-.1-.14-.15v-.02s-.06-.05-.08-.07l-.02-.03s-.04-.05-.06-.07l-.02-.03s-.04-.05-.06-.08l-.02-.03s-.04-.06-.06-.08v-.02c-.12-.17-.22-.36-.3-.55h0s-.03-.09-.04-.12v-.02s-.03-.08-.05-.11h0c-.07-.22-.12-.43-.15-.65h0c-.03-.22-.04-.45-.03-.69h1.86l.22.11c-.03.7.32,1.31.86,1.62h0c.19.08.39.12.61.12s.42-.04.62-.11c.08-.03.16-.07.24-.11.05-.03.1-.06.15-.09.17-.12.32-.26.45-.43.04-.05.07-.1.1-.15.1-.15.17-.32.22-.49.03-.12.06-.24.07-.37,0-.03,0-.06,0-.09.01-.29-.04-.56-.14-.8-.02-.05-.05-.11-.08-.16-.15-.28-.37-.51-.64-.66-.19-.07-.4-.12-.62-.12-.54,0-1.04-.12-1.49-.34l-.22-.11.04.02s-.03-.02-.05-.02h-.01s-.07-.04-.11-.06h0c-.36-.2-.68-.45-.95-.76l-.02-.02c-.1-.11-.19-.23-.28-.36h0c-.04-.07-.07-.13-.11-.19l-.02-.03c-.04-.06-.07-.13-.1-.19h0c-.03-.07-.07-.14-.09-.21v-.03c-.04-.06-.06-.12-.08-.18,0-.01,0-.03-.01-.04-.14-.42-.21-.87-.19-1.35.07-1.71,1.23-3.14,2.75-3.6.04-.01.08-.03.13-.04v-.21s.05-.91.05-.91h1.82l.22.11-.04,1.08c.14.05.27.11.4.17h.01s.03.02.03.02c-.03-.01-.05-.03-.08-.04l.22.11c1.23.59,2.06,1.9,2,3.42h-1.86l-.22-.11h0s0-.09,0-.13v-.03s0-.09-.01-.13v-.02s-.01-.08-.02-.12v-.02s-.02-.08-.03-.12v-.02c-.03-.08-.06-.16-.1-.24v-.02s-.05-.08-.07-.11h0s-.04-.08-.07-.12h0s-.05-.08-.08-.11h0c-.05-.08-.11-.14-.18-.2h0c-.09-.09-.2-.16-.31-.23-.19-.07-.39-.11-.61-.11-.98,0-1.81.83-1.86,1.84-.03.7.32,1.3.86,1.62l.04.02h.01c.08.03.17.06.26.07h.02s.09.02.13.02h.02s.09,0,.14,0c.06,0,.12,0,.18,0,.02,0,.04,0,.06,0,.04,0,.08,0,.12,0,.02,0,.05,0,.07,0,.03,0,.07,0,.1.01.02,0,.05,0,.07.01.03,0,.07.01.1.02.02,0,.05.01.07.02.03,0,.06.01.09.02.02,0,.05.01.07.02.03,0,.06.02.09.03.02,0,.05.01.07.02.03.01.06.02.09.03.02,0,.04.02.06.02.04.01.07.03.11.05.03.01.06.03.1.04.02.01.05.02.07.03l-.04-.02.22.11c1.24.59,2.06,1.91,2,3.44,0,.2-.03.4-.07.59,1.97-1.57,3.27-3.83,3.39-6.35.06-1.19-.16-2.32-.59-3.34h0s-.02-.05-.02-.05c-.03-.07-.06-.14-.1-.22,0-.02-.02-.04-.02-.05,0-.02-.02-.04-.03-.06-.03-.06-.06-.13-.1-.19v-.02c-.05-.07-.09-.15-.13-.22-.01-.02-.02-.04-.04-.06-.04-.08-.09-.15-.13-.23h0c-.05-.09-.1-.16-.15-.24-.01-.02-.03-.04-.04-.06-.05-.07-.09-.13-.14-.2l-.02-.03c-.05-.07-.11-.14-.16-.22-.01-.02-.03-.04-.04-.05-.05-.06-.1-.12-.15-.18l-.03-.04s-.06-.06-.08-.09h.02c.08.06.16.11.23.17-.04-.03-.08-.05-.11-.07-.04-.03-.08-.05-.12-.08-.02-.01-.04-.03-.07-.04h0l-.04-.02c-.07-.04-.13-.08-.2-.12h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m29.14,38.57s.03.03.05.05c.06.06.11.12.17.17.01.02.03.03.04.05-.01-.02-.03-.03-.04-.05-.06-.06-.11-.12-.17-.17-.02-.02-.03-.03-.05-.05-.03-.03-.06-.06-.1-.09h0s.07.06.1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m14.68,51.76h0s.05.08.07.11v.02s.02,0,.02,0c-.03-.04-.06-.09-.09-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m24.76,51.32c.11-.1.22-.21.32-.33-.1.12-.21.23-.32.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m23.73,51.99h0c-.09.04-.18.08-.27.11h0c.24-.09.48-.2.7-.33-.14.08-.28.16-.42.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m15.21,52.44s.03.04.05.06h0s-.04-.05-.07-.07v.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "20.89 52.04 20.88 52.03 20.91 52.04 20.89 52.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "23.14 52.8 23.17 52.19 23.19 52.19 23.17 52.19 23.14 52.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m15.43,52.68l.04.04h0s-.03-.03-.05-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m14.32,51.19s-.04-.07-.06-.11c.02.03.03.06.05.09l.02.03v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m14.38,51.3s.02.03.03.05c0,.02.02.03.03.05v.02s-.04-.08-.06-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m23.31,52.15h0s.09-.03.13-.04h0s-.08.03-.13.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m16.16,53.4s.08.07.12.1c-.04-.03-.08-.07-.12-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m15.01,52.2h0s.03.05.05.07c-.02-.03-.04-.06-.07-.08h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m13.58,49.64v.02s0-.03-.01-.05v.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "13.76 50.08 13.76 50.09 13.76 50.09 13.76 50.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m18.52,54.89h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m13.64,49.81v.02s.02.03.02.05h0s-.02-.04-.03-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m23.12,53.27v-.2s0,.2,0,.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "13.89 50.38 13.89 50.38 13.88 50.37 13.89 50.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m14.19,50.96v.02s.03.03.03.03h0s-.02-.03-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m14.51,51.51v.02s.04.04.05.06c.02.03.03.05.05.08-.03-.05-.07-.1-.1-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m21.34,52.19h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "21.03 52.09 21.02 52.09 21.05 52.1 21.03 52.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "16.66 53.81 16.67 53.81 16.68 53.82 16.64 53.79 16.66 53.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m24.64,51.42c-.12.1-.24.19-.37.27.13-.08.25-.18.37-.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "17.85 54.56 17.87 54.58 17.86 54.57 17.85 54.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "13.45 49.27 13.44 49.24 13.44 49.24 13.45 49.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m16.07,53.33s-.08-.07-.12-.11c.03.03.06.05.08.08l.03.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m22.86,55.57h0c1.23-.11,2.41-.46,3.48-1.01.2-.1.4-.21.6-.33.05-.03.1-.06.15-.09.31-.19.6-.4.89-.62.05-.04.1-.08.16-.13.09-.08.18-.15.27-.23l.03-.02c.18-.16.35-.33.52-.5v-.02c.28-.27.52-.55.75-.84h0c.15-.2.3-.41.44-.62.02-.02.03-.05.05-.07.31-.47.58-.96.81-1.48.05-.1.09-.21.13-.31,0-.02.02-.04.02-.06.04-.11.08-.21.12-.32h0c.04-.12.08-.22.11-.33v-.04c.05-.11.08-.23.12-.34h0c.03-.12.06-.24.09-.36h0c.09-.38.16-.75.21-1.13.04-.3.07-.61.08-.92,0-.17,0-.34,0-.5,0-.24-.01-.49-.03-.73h0c0-.11-.02-.21-.03-.32,0-.02,0-.04,0-.06-.01-.09-.02-.17-.03-.26,0-.02,0-.04,0-.06-.02-.1-.03-.2-.05-.31v-.02c-.02-.09-.04-.19-.06-.28,0-.02-.01-.05-.02-.07-.02-.08-.04-.17-.06-.25,0-.02,0-.03-.01-.05-.02-.1-.05-.19-.08-.29,0-.02-.01-.04-.02-.06-.02-.07-.05-.15-.07-.22,0-.03-.02-.05-.03-.08-.03-.09-.06-.18-.1-.27h0s0,0,0,0h0s-.01-.03-.02-.05c-.02-.05-.04-.09-.05-.14-.01-.04-.03-.07-.04-.11,0-.02-.02-.04-.02-.06,0-.02-.02-.05-.03-.07-.02-.04-.03-.07-.05-.11-.02-.04-.03-.07-.05-.11v-.02s-.03-.03-.03-.05c-.03-.07-.06-.14-.1-.2-.01-.02-.02-.05-.04-.07-.04-.09-.09-.17-.13-.26h0c-.02-.05-.05-.1-.07-.14-.02-.04-.05-.09-.07-.13l-.02-.03-.02-.03h0c-.05-.08-.09-.15-.14-.23h0s-.02-.03-.02-.03l-.02-.04c-.05-.07-.09-.14-.14-.21-.01-.02-.03-.04-.04-.06l-.03-.04c-.04-.06-.08-.11-.12-.17-.01-.01-.02-.03-.03-.04l-.02-.03s-.02-.03-.04-.05c-.04-.05-.08-.11-.12-.16-.01-.02-.03-.03-.04-.05h0s-.06-.08-.09-.12c-.02-.03-.04-.05-.06-.08h0s-.03-.03-.04-.05c-.06-.07-.12-.13-.18-.2l-.02-.02s-.03-.03-.04-.05c-.06-.06-.11-.12-.17-.17-.02-.02-.03-.03-.05-.05-.03-.03-.07-.07-.1-.1-.04-.03-.07-.07-.11-.1h0s-.04-.04-.04-.04c-.06-.06-.12-.11-.18-.16-.02-.02-.04-.03-.06-.05-.07-.06-.15-.13-.23-.19l-.03-.02h0c-.07-.05-.14-.11-.21-.16l-.03-.02-.03-.02c-.08-.06-.16-.11-.24-.17h-.01c-.08-.06-.16-.11-.23-.16h-.02s.06.05.08.08l.03.04c.05.06.1.12.15.18.01.02.03.04.04.05.06.07.11.14.16.22l.02.03c.05.07.09.13.14.2.01.02.03.04.04.06.05.08.1.15.15.23h0c.05.08.09.16.13.23.01.02.02.04.04.06.04.07.08.15.12.22v.02c.04.06.08.13.11.19,0,.02.02.04.03.06,0,.02.02.04.02.05.03.07.07.14.1.22l.02.04h0c.43,1.04.64,2.17.59,3.36-.12,2.52-1.42,4.78-3.39,6.35-.29,1.48-1.41,2.67-2.81,3.04l-.05,1.12h-1.82l-.22-.11h0l.04-1.08c-.12-.04-.24-.09-.36-.15l-.22-.11h.01s0,0,0,0c-.03-.01-.05-.03-.08-.04-.02,0-.03-.02-.05-.02-.03-.01-.06-.03-.08-.05l-.04-.02s-.08-.05-.11-.07c-.02,0-.03-.02-.04-.03-.02-.02-.05-.03-.07-.05-.02-.01-.04-.02-.05-.04-.02-.01-.04-.03-.06-.04-.02-.01-.04-.03-.05-.04-.02-.01-.03-.03-.05-.04-.02-.02-.04-.03-.06-.05h0c-.1,0-.2,0-.29,0-1.88,0-3.61-.5-5.04-1.35.76,2.07,2.19,3.77,4.04,4.83.04.01.07.03.11.04h.02c.1.05.21.09.32.12h.01c.11.04.23.08.34.11h0c.11.03.22.06.33.09h.03c.23.06.46.11.69.15h.03c.23.04.47.07.71.09h.03c.12.01.24.02.36.02.1,0,.21,0,.32,0,.27,0,.55-.01.81-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m17.26,54.22h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m14.1,50.8v-.02s0,.02,0,.02v.02s.04.05.05.08c-.02-.03-.04-.07-.05-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m14.64,51.69h0s.02.04.04.06c-.01-.02-.03-.04-.04-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m25.89,49.5c-.04.14-.09.27-.14.4.05-.13.1-.26.14-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m25.71,49.99c-.04.08-.07.16-.11.24.04-.08.08-.16.11-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m25.48,50.44c-.09.15-.19.29-.3.43.11-.14.21-.28.3-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m17.53,54.39l.03.02h.01s-.03-.01-.05-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m15.68,52.95h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m16.38,53.59h0l.02.02s-.03-.02-.05-.04l.02.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "21.17 52.14 21.16 52.14 21.2 52.15 21.17 52.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m28.69,35.68l-1.12-.54.03.02h0s.09.05.14.07c.05.02.09.05.14.07.03.01.05.03.08.04.1.06.21.11.31.17h.02c.1.07.19.12.29.18.03.02.05.03.08.05.03.02.06.04.09.06.06.04.12.08.19.12h.02c.1.08.19.14.29.21.02.02.05.04.07.05.08.06.16.12.25.19l.04.03c.09.07.18.15.27.22.02.02.04.04.07.06.04.03.07.07.11.1.04.03.07.06.11.1h.02s.03.04.03.04c.08.08.17.16.25.24.02.02.04.04.06.06.07.07.14.14.2.21.02.02.04.04.05.06.08.08.16.17.23.26.02.02.03.04.05.06.05.06.11.12.16.19l.03.04h0s.03.05.05.07c.03.04.07.09.1.13.04.05.08.1.11.15.01.02.02.03.04.05.06.08.12.16.18.24.02.02.03.05.05.07.07.1.13.19.2.29l.02.04.02.04c.05.08.1.15.14.23.02.03.03.05.05.08.06.1.12.21.18.31h0c.04.08.07.15.11.22.02.03.04.07.05.1.01.03.03.06.04.08.05.1.1.2.14.3v.03c.06.11.11.22.16.33.01.03.02.06.04.09.04.1.08.19.11.29,0,.02.01.03.02.05.04.11.08.23.12.34,0,.03.02.06.03.09.03.1.06.19.09.29v.03s.02.03.02.03h0c.03.12.06.24.09.35,0,.03.01.06.02.08.02.1.05.2.07.3,0,.03.01.05.02.08.03.12.05.24.07.36,0,.03,0,.05.01.08.02.1.03.21.05.31,0,.03,0,.06.01.09v.04c.02.11.03.22.05.33,0,.02,0,.04,0,.06,0,.04,0,.07,0,.11,0,.07.01.14.02.22,0,.03,0,.07,0,.1,0,.13.01.25.02.38v.04c0,.12,0,.23,0,.35,0,.03,0,.07,0,.1,0,.13,0,.26,0,.39-.19,4.56-2.86,8.5-6.61,10.44h-.03c-.08.05-.16.09-.24.13h0c-.95.46-1.96.79-3.01.97h-.04c-.11.03-.22.04-.33.06h-.03c-.12.02-.24.03-.36.05h-.01c-.11.01-.22.02-.33.03-.03,0-.06,0-.09,0-.09,0-.17,0-.26.01-.03,0-.06,0-.1,0-.11,0-.23,0-.35,0-.1,0-.2,0-.3,0-.03,0-.07,0-.1,0-.07,0-.13,0-.2,0-.04,0-.08,0-.12,0-.06,0-.12,0-.18-.01-.04,0-.08,0-.13-.01-.06,0-.11-.01-.17-.02-.02,0-.04,0-.07,0-.02,0-.04,0-.06,0-.05,0-.11-.01-.16-.02-.04,0-.09-.01-.13-.02-.05,0-.11-.02-.16-.03-.04,0-.09-.01-.13-.02-.05,0-.11-.02-.16-.03-.04,0-.09-.02-.13-.03-.03,0-.05-.01-.08-.02-.03,0-.05-.01-.08-.02-.01,0-.03,0-.04,0-.03,0-.06-.01-.08-.02-.05-.01-.1-.02-.16-.04-.04-.01-.08-.02-.13-.03-.05-.01-.1-.03-.15-.04-.04-.01-.08-.02-.12-.03-.03,0-.06-.02-.08-.03-.02,0-.05-.01-.07-.02-.04-.01-.08-.02-.12-.04h-.03s-.08-.04-.13-.05c-.04-.01-.07-.02-.11-.04-.06-.02-.11-.04-.17-.06-.03-.01-.07-.02-.1-.04-.07-.03-.13-.05-.2-.08-.02,0-.04-.02-.06-.03-.09-.04-.17-.07-.26-.11-.02,0-.04-.02-.07-.03-.03-.01-.06-.03-.1-.04-.03-.01-.06-.03-.1-.04h-.01s1.12.53,1.12.53c1.4.67,2.97,1.05,4.64,1.05,6.25,0,11.52-5.24,11.79-11.71.19-4.74-2.36-8.82-6.19-10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m14.69,50.14c-.21-.58-.37-1.2-.47-1.83,0-.03-.01-.07-.01-.1-.04-.29-.07-.58-.09-.88-.03-.01-.06-.03-.08-.04.03.01.06.03.08.04-.02-.33-.02-.66,0-1,.22-5.41,4.64-9.8,9.87-9.8,1.17,0,2.29.22,3.31.63-.07-.04-.15-.08-.23-.12-.02-.01-.05-.02-.07-.04-.08-.04-.15-.08-.23-.12l-.04-.02h0s-.09-.04-.14-.06c-.02-.01-.05-.02-.07-.03-.04-.02-.08-.03-.12-.05h-.01s-.05-.03-.08-.04h-.03c-.06-.04-.12-.06-.19-.09-.03-.01-.06-.02-.08-.03-.05-.02-.09-.03-.14-.05-.03-.01-.06-.02-.09-.03-.04-.01-.09-.03-.13-.04-.03-.01-.07-.02-.1-.03h0s-.09-.03-.13-.04h0s-.07-.02-.1-.03c-.04-.01-.08-.02-.13-.03-.04,0-.07-.02-.11-.03-.04-.01-.08-.02-.13-.03-.04,0-.07-.02-.11-.02h-.02s-.01,0-.01,0c-.03,0-.07-.01-.1-.02-.04,0-.07-.01-.11-.02-.04,0-.08-.02-.13-.02h0s-.07-.01-.11-.02c-.04,0-.09-.01-.13-.02-.04,0-.07-.01-.11-.02-.03,0-.05,0-.08-.01-.02,0-.04,0-.06,0-.04,0-.07,0-.11-.01-.05,0-.09,0-.14-.01h0s-.07,0-.11-.01h-.01s0,0,0,0c-.03,0-.07,0-.1,0h-.03s0,0,0,0c-.03,0-.07,0-.1,0-.05,0-.1,0-.16,0-.03,0-.06,0-.09,0-.04,0-.08,0-.12,0-.04,0-.07,0-.11,0h-.03c-.21,0-.43,0-.64.02-.48.03-.95.1-1.41.21h0c-.23.05-.46.11-.68.18h0c-.22.07-.45.15-.66.23h0c-.22.09-.43.18-.64.28h0c-.21.1-.42.21-.62.32h0c-.2.12-.4.24-.6.37h0c-.19.13-.38.27-.57.41-2.19,1.68-3.7,4.26-4,7.19,0,.09-.02.19-.02.28v.02c0,.1-.01.2-.02.29h0c0,.08,0,.17,0,.25,0,.03,0,.05,0,.08,0,.06,0,.11,0,.17,0,.03,0,.05,0,.08h0s0,.02,0,.02c0,.02,0,.05,0,.07,0,.02,0,.05,0,.07v.03s0,.01,0,.01c0,.02,0,.04,0,.05h0s0,.05,0,.08c0,.07,0,.13.01.2h0s0,.03,0,.04c0,.02,0,.05,0,.07,0,.02,0,.05,0,.07h0s0,0,0,0h0s0,.04,0,.04h0s0,.04,0,.04h0s0,.05,0,.07c0,.03,0,.06.01.09,0,.05.01.09.02.14,0,.03,0,.06.01.1,0,.03,0,.05.01.08,0,.03,0,.06.01.09.02.1.03.2.05.3,0,.02,0,.04.01.06.01.06.02.12.04.18,0,.03.01.06.02.09.01.05.02.1.04.15h0s0,.02,0,.02v.03c.03.09.05.17.07.26h0s.01.04.02.06c.02.09.05.17.08.25h0s0,.03.01.05h0s0,.02,0,.02v.02c.02.05.04.1.06.15,0,.03.02.06.03.08h0s0,.01,0,.01c.01.03.02.06.03.09,0,.02.01.03.02.05,0,.02.02.04.02.06,0,.02.01.03.02.05,0,.02.01.03.02.05,0,.02.02.05.03.07,0,.01.01.03.02.04,0,.02.01.03.02.05.01.03.03.07.04.1h0s.03.07.04.09c.02.05.04.09.06.14,0,.02.02.03.02.05v.02c.06.11.11.22.17.32h0s0,.01,0,.01v.02s.02.03.03.05v.02s.05.07.07.1c0,.02.02.03.03.05h0s.02.05.03.06h0s0,.02,0,.02v.02s.03.02.03.02c.02.04.04.07.06.11v.02s.03.03.04.05l.02.03h0c.02.05.05.09.07.13h0s.02.04.04.06h0s.02.02.02.02h0c.03.06.07.11.1.16l.02.03h0s.03.04.04.06h0s0,0,0,0c.03.04.06.09.09.13.07.1.15.2.22.3.02.03.04.06.07.08.04.05.09.1.13.16.02.03.04.05.07.08.05.06.1.11.15.17.02.02.03.04.05.06.07.07.13.14.2.21h0c.07.08.15.16.23.23h0s.02.01.02.01l.04.03h0s.08.07.12.11h0s.03.03.03.03c.02.01.03.03.05.04h0s.08.07.12.1l.03.02s.04.03.05.04h0s.03.03.05.04c.08.06.15.12.23.18l.04.03c.09.07.18.13.27.19h0c.09.07.19.13.29.2h.02c.09.07.18.12.27.17.02,0,.03.02.05.03.09.05.18.1.27.15h.01s.01.01.01.01c.2.11.41.21.62.3h.03c.07.04.14.07.21.1-1.85-1.06-3.28-2.76-4.04-4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.7,39.3c.08.02.15.04.23.07l.04-1.08-.22-.11-.05,1.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.15,46.85l-.04-.02s-.03-.01-.05-.02h-.04s-.03-.02-.05-.03h-.04s-.03-.02-.05-.02h-.04s-.03-.02-.05-.02h-.04s-.04-.01-.05-.01h-.04s-.04,0-.06-.01h-.03s-.06,0-.09,0h0c-.06,0-.11,0-.17,0h-.03s-.03,0-.03,0c-.04,0-.08,0-.12,0-.01,0-.03,0-.04,0h-.02s-.09-.01-.14-.02h-.03s-.03-.01-.05-.01c-.03,0-.05,0-.08-.01-.02,0-.04,0-.06-.01h-.04s-.04-.02-.06-.02c-.03,0-.05-.01-.08-.02-.02,0-.05-.01-.07-.02h-.04s-.04-.03-.07-.03c-.03,0-.05-.02-.08-.03-.03-.01-.06-.02-.09-.03h0s-.05-.02-.08-.03c-.03-.01-.06-.03-.09-.04l-.04-.02.22.11c.45.22.95.34,1.49.34.22,0,.43.04.62.12-.04-.02-.09-.05-.13-.07-.01,0-.03-.01-.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m20.63,48.71s0,.07,0,.11h0c0,.05,0,.09.02.13v.03s.02.07.03.1v.02s.02.07.04.11v.03s.03.06.04.09v.02s.04.07.06.1v.02s.04.05.06.08v.02s.05.06.07.09v.02s.05.05.07.07l.02.02s.05.06.07.08h.01s.04.06.07.08l.02.02s.05.05.08.07h0s.05.05.08.07l.02.02s.06.04.09.06h0s.07.04.1.05c.04.02.08.04.13.06-.54-.31-.89-.92-.86-1.62l-.22-.11s0,.08,0,.12v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.34,52.19s-.09-.03-.13-.04h-.01s-.04-.02-.04-.02c-.03,0-.06-.02-.09-.03h-.02s-.03-.02-.03-.02c-.02,0-.05-.02-.07-.03h-.03s-.03-.03-.03-.03c-.02,0-.04-.02-.07-.03-.01,0-.03-.01-.04-.02h-.01s.22.1.22.1c.12.06.24.1.36.15v-.04s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m24.51,39.64l.03.02s.06.04.09.05c.01,0,.03.02.04.03.02.02.05.03.07.05.01.01.03.02.04.03.02.02.05.03.07.05.01.01.03.02.04.03.02.02.04.04.07.05l.04.03s.05.04.07.06l.03.03s.04.04.06.06h0s.03.03.03.03h0s.04.04.05.06h0s.04.04.04.04l.03.03.02.02h0s.03.04.04.05l.03.04h0s0,.01,0,.01c.02.02.03.04.05.06l.03.04h0s.03.05.05.07c.01.01.02.03.03.04.02.02.03.05.05.07,0,.01.02.03.03.04.02.03.03.05.05.08v.02s.02.02.02.02c.01.02.03.05.04.07v.02s.03.03.03.03v.02s.03.03.03.05v.03s.03.03.03.03c0,.01.01.03.02.04h0s.01.04.01.04c0,.01.01.03.02.04,0,.02.01.03.02.05v.03s.03.03.03.05c0,.02.01.03.02.05v.02s.02.04.03.06c0,.02.01.03.02.05v.02s.02.05.03.08c0,.01,0,.03.01.04h0s.02.07.02.09c0,.01,0,.03.01.04h0s.01.06.02.09c0,.02,0,.03.01.05v.02s.01.04.01.04v.03s.01.03.02.05v.03s.01.04.01.05h0s0,.04,0,.06v.04s0,.04.01.06c0,.01,0,.03,0,.04,0,.02,0,.03,0,.05,0,.02,0,.04,0,.06v.03s0,.04,0,.06c0,.02,0,.04,0,.06v.02s0,.05,0,.08c0,.02,0,.03,0,.05h0c0,.06,0,.11,0,.15h-1.86l.22.11h1.86c.06-1.52-.76-2.83-2-3.42l-.22-.11s.05.03.08.04h.03s.08.06.12.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.55,51.02s-.04-.05-.06-.07c.02.02.04.05.06.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.64,51.12s-.04-.05-.06-.07c.02.02.04.05.06.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.47,50.91s-.04-.05-.06-.08c.02.03.04.05.06.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.8,51.29s-.1-.1-.14-.15c.05.05.09.1.14.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.97,51.45s-.04-.03-.06-.05c.02.02.04.03.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.4,50.8s-.04-.06-.06-.08c.02.03.04.06.06.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.87,51.36s-.04-.04-.06-.06c.02.02.04.04.06.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.95,50.29c.08-.03.16-.07.24-.11-.08.04-.16.08-.24.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.19,50.18c.05-.03.1-.06.15-.09-.05.03-.1.06-.15.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.04,47.76c-.02-.05-.05-.11-.08-.16.03.05.05.1.08.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.95,41.22s.02.05.03.07c0-.02-.01-.03-.02-.05v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m18.94,49.89c-.07-.21-.12-.42-.15-.64.03.22.08.44.15.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.04,50.14s-.03-.07-.04-.11c.01.04.03.07.04.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m18.99,50.01s-.03-.08-.04-.11c.01.04.03.08.04.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.33,50.7c-.11-.17-.21-.36-.29-.55.08.19.18.38.29.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m18.76,48.55c0,.24,0,.47.03.69l.38-.69h-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.3,46.5s-.06-.02-.09-.03c.03.01.06.02.09.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.57,50.22c.05.03.1.05.16.07h0s-.08-.04-.13-.06h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.97,46.36s-.07-.04-.11-.05c.04.02.07.04.11.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.19,46.46c-.07-.03-.14-.06-.21-.09.02,0,.03.02.05.02.03.01.06.03.09.04.02.01.05.02.07.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.11,41.64s.01.04.02.05c0-.01,0-.03-.01-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.01,41.36s.02.05.03.07c0-.02-.01-.03-.02-.05v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.25,42.26s0,.04,0,.06c0-.02,0-.04,0-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.06,41.49s.02.04.02.07c0-.02-.01-.03-.02-.05v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.27,42.41s0,.04,0,.06c0-.02,0-.04,0-.06h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "26.28 42.93 26.28 42.94 24.42 42.94 24.42 42.94 24.42 42.94 26.28 42.94 26.28 42.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.28,42.57s0,.04,0,.06c0-.02,0-.04,0-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.39,39.57h-.03s-.03-.03-.03-.03c.04.02.07.04.11.06-.02,0-.03-.02-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.19,45.19s-.03-.02-.05-.02l-.03-.02s.05.03.07.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.46,40.44s.04.05.07.08l-.03-.04-.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.42,42.77v.03s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.55,46.51s-.02-.03-.03-.04l-.02-.04-.02-.04s.05.08.07.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.47,45.36l-.02-.02-.04-.02h-.02s.05.02.08.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "20.86 43.05 20.86 43.08 20.86 43.06 20.86 43.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.1,41.2h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.27,41.15h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.02,41.23h.03s-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.19,41.17h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.33,45.27s-.04-.02-.05-.03h0s-.02-.01-.02-.01c.03.01.05.03.08.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.9,43.45v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.99,47.71s0-.05-.01-.07v-.04c-.02-.05-.03-.11-.04-.16v-.04s-.03-.08-.05-.12c0-.02,0-.03-.01-.05-.01-.04-.03-.09-.04-.13v-.02c-.03-.05-.05-.1-.07-.15l-.02-.04s-.03-.07-.05-.11c0-.01-.01-.03-.02-.04-.02-.05-.05-.09-.07-.14h0s-.03-.05-.05-.08c.21.36.36.76.44,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.94,41.27h.03s-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.93,43.55h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.12,42.03l.02-.04-.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.6,44.48h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.08,42.11l.02-.04-.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.02,43.78h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.87,41.31l.03-.02-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.17,41.96l.02-.04-.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.46,46.37s-.02-.03-.03-.05l-.02-.03-.02-.03s.05.08.08.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.22,41.89l.03-.03-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.38,46.24s-.04-.05-.06-.08l-.02-.02v-.02s.04.08.07.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.74,45.56h-.02s-.02-.03-.02-.03c-.02-.01-.03-.02-.05-.04.03.02.05.04.08.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.86,45.66h0s-.03-.03-.03-.03c-.01-.01-.03-.03-.05-.04.03.02.06.05.08.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.29,46.12s-.04-.06-.07-.08l-.03-.04s-.05-.06-.08-.09l-.02-.03s-.07-.08-.11-.11l-.03-.02s-.04-.04-.06-.06c.14.13.28.28.4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.27,41.81l.03-.03-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.72,41.4l.03-.02-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.65,41.45l.03-.02-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.33,41.75l.03-.03-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.79,41.35l.03-.02-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.58,41.5l.03-.02-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.51,41.56l.03-.03-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.39,41.68l.03-.03-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.45,41.62l.03-.03-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.75,44.99s.04.02.06.02c-.02,0-.04-.02-.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.04,41.74h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.12,41.85h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.86,41.54h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.19,41.97h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21,42.27s.01-.03.02-.04c0,.01-.01.03-.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.97,42.36s.01-.03.02-.04c0,.01-.01.03-.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.94,42.44s0-.03.01-.05c0,.02,0,.03-.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.98,44.68h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.26,42.1v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.35,42.37v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.47,44.95c-.04-.06-.07-.13-.1-.19.03.07.07.13.1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.6,45.15c-.04-.06-.07-.12-.11-.18.03.06.07.12.11.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.26,44.51c-.02-.06-.05-.12-.07-.18.02.06.04.12.07.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.37,44.75c-.03-.07-.07-.14-.09-.21.03.07.06.14.09.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.39,42.51v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.92,42.53s0-.03.01-.05c0,.02,0,.03-.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.41,42.64v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.91,44.8s.05,0,.07,0c-.02,0-.05,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.92,45.06s.06.03.1.04c-.03-.01-.06-.03-.1-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.59,44.94s.05.01.07.02c-.02,0-.05-.01-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.04,42.19l.02-.04s-.01.03-.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.61,45.45l-.03-.02-.03-.02h-.02s.05.03.08.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.87,42.81s0-.04,0-.06c0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.86,43.2v-.03s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m19.88,45.53c-.1-.11-.19-.23-.28-.36.08.13.18.25.28.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.86,42.93s0-.06,0-.09c0,.03,0,.06,0,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.88,42.71s0-.04,0-.05c0,.02,0,.04,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.25,44.75h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.4,44.77h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.9,42.62s0-.03.01-.05c0,.02,0,.03-.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.74,44.78s.04,0,.06,0c-.02,0-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.09,44.82s.05,0,.07.01c-.02,0-.05,0-.07-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.26,44.85s.05.01.07.02c-.02,0-.05-.01-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.42,44.89s.05.01.07.02c-.02,0-.05-.01-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.88,43.32h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.31,52.15s.08-.03.13-.04c-.04.01-.08.03-.13.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.41,51.78s-.03-.02-.04-.03c.02,0,.03.02.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.29,51.7s-.04-.02-.05-.04c.02.01.03.03.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.69,51.94s-.03-.02-.05-.02c.02,0,.03.02.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.07,51.54s-.04-.03-.06-.05c.02.02.04.03.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.18,51.62s-.04-.03-.05-.04c.02.01.04.03.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m23.45,52.1c.09-.03.18-.07.27-.11-.09.04-.18.08-.27.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.56,51.87l-.04-.02.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.85,44.62h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.79,46.64s-.04,0-.07-.01h0s.04,0,.06.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.44,46.55s-.06-.02-.09-.03h.02s.04.02.07.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.63,46.6s-.07-.02-.11-.03h.03s.05.02.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.14,46.69s-.03,0-.05,0h0s.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.94,46.67s-.03,0-.05,0h.02s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.31,46.71s-.03,0-.05,0h.02s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.68,49.08s-.01-.07-.02-.1v-.03s0-.02,0-.02c0,.06.02.12.04.18h0s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.71,49.21s-.02-.07-.03-.1c.01.06.03.11.05.17v-.04s-.02-.03-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.18,49.94l-.03-.02s.08.08.13.11c-.03-.02-.05-.05-.08-.07l-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.37,50.1s-.06-.04-.08-.06h0s0,0,0,0c.04.04.09.07.14.1l-.02-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.1,49.86s-.05-.05-.07-.08l-.02-.02-.02-.03c.05.07.11.13.17.19-.01-.01-.03-.03-.04-.04h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.87,49.55s-.03-.05-.04-.08v-.02s-.04-.07-.06-.1v-.02s-.02-.03-.03-.05c.04.11.09.22.15.31h0s-.01-.03-.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.08,52.11s-.03-.01-.05-.02h.03s.02.02.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.95,52.06s-.03-.01-.05-.02h.02s.03.02.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m21.21,52.15s-.03,0-.04-.01h.03s.01.01.01.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m20.77,51.98h0s.03.02.04.02c-.02,0-.03-.02-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.08,40.05s-.05-.04-.07-.06l-.04-.03s-.04-.04-.07-.05c-.01-.01-.03-.02-.04-.03-.02-.02-.05-.03-.07-.05-.01-.01-.03-.02-.04-.03-.02-.02-.05-.03-.07-.05-.01,0-.03-.02-.04-.03-.02-.01-.04-.03-.06-.04.22.13.42.28.6.46-.02-.02-.04-.03-.05-.05l-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.2,41.98h0s0,.03.01.05h0s0-.05,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.21,40.16l-.02-.02s.05.05.08.08c-.01-.02-.03-.03-.04-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.83,40.99v-.02s.01.05.03.07l-.02-.03v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.31,40.27l-.03-.03s.05.05.07.08h0s-.03-.04-.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.66,40.71s-.03-.05-.05-.07c-.01-.01-.02-.03-.03-.04-.01-.02-.03-.04-.04-.05.07.09.14.19.2.29-.02-.02-.03-.05-.05-.07,0-.01-.02-.03-.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.51,39.64s-.04-.02-.06-.03c.04.02.07.04.1.06h-.02s-.03-.03-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.23,42.12h0s0,.03.01.05h0s0-.04,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.28,42.73h0s0,.03,0,.05c0-.02,0-.03,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.41,40.37l-.03-.04s.04.05.07.08h0s-.03-.04-.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.17,41.83s0,.04.01.05c0-.01,0-.03-.01-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.75,40.85s.03.05.04.08c-.01-.02-.02-.04-.03-.06v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m25.9,41.12v-.02s.01.05.02.07h0s-.01-.04-.02-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "23.12 53.27 23.13 53.07 23 53.31 21.3 53.31 21.3 53.31 23.12 53.31 23.12 53.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m14.05,50.71c-.06-.11-.11-.22-.16-.32h0s-.02-.04-.02-.04h0s0-.02,0-.02c-.02-.05-.04-.09-.06-.14v-.02s-.02-.01-.02-.01c0-.02-.02-.04-.02-.05h0s-.03-.07-.04-.11h0s-.01-.04-.01-.04c0-.02-.02-.04-.02-.06,0-.02-.01-.03-.02-.05,0-.02-.01-.04-.02-.05,0-.02-.01-.04-.02-.06h0s-.02-.04-.02-.06v-.02s-.02-.04-.03-.06c0-.03-.02-.05-.03-.08,0-.03-.02-.06-.03-.08v-.04c-.04-.07-.06-.13-.08-.2h0c-.03-.09-.05-.17-.08-.26,0-.02-.01-.04-.02-.06h0c-.02-.08-.05-.17-.07-.26v-.03s-.01-.02-.01-.02c-.01-.05-.02-.1-.04-.15,0-.03-.01-.06-.02-.09-.01-.06-.03-.12-.04-.18,0-.02,0-.04-.01-.06-.02-.1-.04-.2-.05-.3,0-.03,0-.06-.01-.09,0-.03,0-.05-.01-.08,0-.03,0-.06-.01-.1,0-.05-.01-.09-.02-.14,0-.03,0-.06-.01-.09,0-.02,0-.04,0-.07v-.04s0-.01,0-.01v-.04s0,0,0,0h0s0-.06,0-.08c0-.02,0-.05,0-.07,0-.01,0-.03,0-.04h0c0-.07,0-.13-.01-.2,0-.02,0-.04,0-.07h0s0-.05,0-.08v-.03s0-.05,0-.07c0-.02,0-.05,0-.07v-.02s0-.05,0-.08c0-.06,0-.11,0-.17,0-.03,0-.05,0-.08,0-.08,0-.17,0-.25h0c0-.1,0-.2.02-.29v-.02c0-.09.02-.19.03-.28h0s-1.73,3.11-1.73,3.11h0c.01.08.03.16.04.23,0,.04.01.08.02.11.02.08.03.15.05.23,0,.02.01.05.02.07.03.15.07.3.11.44,0,.03.02.07.03.1.02.08.04.15.07.22.01.03.02.07.03.1.05.16.1.32.16.47v.02c.03.07.06.15.09.22.01.03.03.07.04.1.03.07.06.14.09.22l.02.04c.06.15.13.29.19.43.01.03.03.06.04.09.03.07.07.14.1.21.01.03.03.06.04.08.07.14.15.28.23.42l.02.03c.04.07.08.13.12.2.02.03.03.06.05.08.04.07.08.13.13.2h0s1.07-1.92,1.07-1.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m21.03,34.82c-1.01.27-1.98.65-2.88,1.14l-1.14,2.05h0c.19-.14.38-.28.57-.41h0c.19-.13.39-.25.6-.37h0c.2-.12.41-.22.62-.32h0c.21-.1.42-.19.64-.28h0c.22-.09.44-.16.66-.23h0c.22-.07.45-.13.68-.18h0c.46-.1.93-.17,1.41-.21h0l1.07-1.93c-.12,0-.24,0-.35,0-.09,0-.19,0-.28,0-.03,0-.06,0-.09,0-.06,0-.13,0-.19,0-.04,0-.07,0-.11,0-.06,0-.11,0-.17.01-.04,0-.08,0-.12.01-.05,0-.11,0-.16.01-.04,0-.08,0-.12.01-.05,0-.1.01-.16.02-.04,0-.08.01-.12.02-.05,0-.1.01-.15.02-.04,0-.08.01-.12.02-.05,0-.1.02-.15.03-.04,0-.08.02-.12.02-.05,0-.1.02-.15.03-.04,0-.08.02-.12.03-.05.01-.1.02-.15.03-.04,0-.08.02-.12.03-.05.01-.1.02-.15.04-.04.01-.08.02-.12.03-.05.01-.1.03-.15.04-.04.01-.08.02-.12.03-.05.01-.1.03-.15.05-.04.01-.08.02-.11.04-.05.02-.1.03-.15.05-.04.01-.07.02-.11.04-.06.02-.11.04-.17.06-.03.01-.06.02-.09.03-.08.03-.15.06-.22.09h-.03s-.32.58-.32.58c.84-.34,1.72-.57,2.6-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m15.91,53.17h0c-.08-.07-.15-.15-.23-.22h0c-.07-.08-.14-.15-.2-.22h0s0,0,0,0l-.04-.04h0s0-.01,0-.01c-.05-.06-.1-.11-.15-.17h0s0,0,0,0c-.02-.02-.03-.04-.05-.06h0v-.02c-.06-.05-.1-.1-.14-.16-.02-.02-.03-.04-.05-.06h0s-.01-.03-.01-.03c-.08-.1-.15-.2-.22-.3h0s-1,1.8-1,1.8c.09.11.18.21.28.32h0c.09.1.19.2.28.3h0c.09.11.19.2.29.29h.01c.1.11.2.2.31.29l.96-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m23.58,36.03h0s.01,0,.01,0h.02s.06,0,.09,0h0s.09,0,.14.01h0s.04,0,.05,0c.02,0,.04,0,.05,0h0s.04,0,.06,0c.03,0,.05,0,.08.01.04,0,.07.01.11.02h0s.09.01.13.02h0s.07.01.11.02c.04,0,.09.02.13.02.04,0,.07.01.11.02.04,0,.08.02.11.02h.02s0,0,0,0c.04,0,.07.02.11.02.04.01.09.02.13.03.03,0,.07.02.1.03.04,0,.07.02.11.03l.96-1.72h0c-.12-.04-.24-.07-.36-.11-.03,0-.05-.01-.08-.02-.12-.03-.24-.06-.36-.09h0c-.27-.07-.55-.12-.83-.16h0l-1.01,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m31.83,46.72h0c-.05.38-.12.75-.21,1.12h0s0,.01,0,.01h0c-.03.12-.06.24-.09.35h0s0,0,0,0h0c-.03.11-.07.23-.1.34v.04c-.05.11-.08.21-.12.32h0s0,.01,0,.01h0c-.04.11-.08.21-.12.32h0s-.02.04-.02.06c-.04.1-.09.21-.13.31l2.73-4.92c0-.05,0-.11,0-.16,0-.03,0-.07,0-.1,0-.07-.01-.14-.02-.22,0-.04,0-.07,0-.11,0-.02,0-.04,0-.06-.01-.11-.03-.22-.04-.33v-.04s-.01-.06-.02-.09c0-.03,0-.06-.01-.09l-1.8,3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m30.15,51.16h0c-.14.21-.29.41-.44.61h0s0,0,0,0h0c-.23.3-.48.58-.74.84h0s-.01.01-.01.01h0c-.17.17-.34.34-.52.5l-.03.02h0c-.09.08-.18.16-.27.23l-1.8,3.23c.18-.08.36-.16.54-.24h0c.08-.04.16-.08.24-.13h.03c.09-.06.17-.1.26-.15l2.75-4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m15.14,37.63c.4-.38.83-.74,1.29-1.06l.03-.02.36-.65h0c-.23.15-.46.31-.68.47h0c-.22.17-.44.34-.65.52h0s-.5.9-.5.9c.05-.05.1-.1.15-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m15.91,37.52c-.16.14-.31.28-.47.43-.58.56-1.1,1.17-1.57,1.82l-1.46,2.63c-.14.32-.26.65-.38.98.03-.15.06-.31.09-.46l-.86,1.55h0c-.02.11-.03.21-.04.32h0c-.01.11-.02.21-.03.31v.03c-.01.09-.02.19-.03.28,0,.02,0,.04,0,.05,0,.11-.01.22-.02.32h0c0,.11,0,.22,0,.33h0s4.78-8.61,4.78-8.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m17.44,56.51s.06.03.1.04c.02,0,.04.02.07.03.09.04.17.08.26.11.02,0,.04.02.06.03.07.03.13.05.2.08.03.01.07.02.1.04.06.02.11.04.17.06.04.01.07.03.11.04.04.01.08.03.13.04h.03s.08.04.12.05c.02,0,.05.01.07.02.03,0,.06.02.08.03.04.01.08.02.12.03.05.01.1.03.15.04.04.01.08.02.13.03.05.01.1.03.16.04.03,0,.06.01.08.02.01,0,.03,0,.04,0,.03,0,.05.01.08.02.03,0,.05.01.08.02.04,0,.09.02.13.03.05.01.11.02.16.03.04,0,.09.02.13.02.05,0,.11.02.16.03.04,0,.09.01.13.02.05,0,.11.01.16.02.02,0,.04,0,.06,0l1.02-1.84c-.12,0-.24-.01-.36-.02h-.03s0,0,0,0c-.24-.02-.48-.05-.71-.08h-.03c-.23-.04-.47-.09-.69-.15h-.03s0,0,0,0c-.11-.03-.22-.06-.33-.09h0s0,0,0,0c-.12-.03-.23-.07-.34-.11h0s-.01,0-.01,0h0c-.11-.04-.21-.07-.32-.11h0s-.02,0-.02,0c-.04-.01-.07-.03-.11-.04-.07-.03-.14-.05-.21-.08h-.03c-.21-.1-.42-.2-.62-.31h-.02c-.09-.06-.18-.11-.27-.16h-.01s0,0,0,0l-.03-.02h0s0,0,0,0c-.09-.05-.18-.11-.27-.16h-.02c-.1-.08-.19-.14-.29-.2h0c-.09-.07-.18-.13-.27-.2h0s0,0,0,0h-.01s-.02-.02-.02-.02c-.08-.06-.16-.12-.23-.18l-.02-.02-.95,1.7c.21.16.42.32.65.46.03.02.06.04.09.06.06.04.12.07.17.11.08.05.17.1.26.15.04.02.08.04.11.06.07.04.14.08.21.12.03.02.07.04.1.05.1.05.21.11.31.16h0s.06.03.1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m25.87,36.51s.08.03.13.05c.03,0,.05.02.08.03.07.03.14.05.2.08h.02s0,0,0,0c.03.01.05.02.08.04.05.02.09.04.14.06.02.01.05.02.07.03h0s.09.05.14.07h0s.02,0,.02,0h.02s0,0,0,0c.08.04.15.08.23.12h0s.04.02.07.04h0c.08.04.15.08.23.12l.03.02h0s0,0,0,0h0c.07.04.13.08.2.12l.04.02s.04.03.06.04h0s.08.05.12.08c.04.03.08.05.11.07h.01c.08.06.16.12.24.18.01.01.03.02.04.03h.02s0,.01,0,.01h0c.07.05.14.1.21.16h0s.03.02.03.02c.08.06.15.12.23.19.02.02.04.03.05.05.06.05.13.11.19.17l.04.04s.08.07.11.11c.03.03.06.06.1.09h0s.03.03.05.05c.06.06.11.12.17.18.01.02.03.03.04.05l.02.02c.06.06.12.13.18.2h0s.03.03.04.05c.02.03.04.05.06.08.03.04.06.07.09.11h0s.02.02.02.02l.02.03c.04.05.08.11.12.16.02.02.04.05.06.07l.03.04c.04.06.08.11.12.17l.03.04h0s.03.04.04.06c.04.06.08.12.12.17l1.02-1.84s-.07-.09-.1-.13c-.02-.02-.03-.04-.05-.06h0s-.03-.04-.03-.04c-.05-.06-.1-.13-.16-.19-.02-.02-.03-.04-.05-.06-.08-.09-.15-.17-.23-.26-.02-.02-.04-.04-.05-.06-.07-.07-.13-.14-.2-.21-.02-.02-.04-.04-.06-.06-.08-.08-.17-.16-.25-.24l-.03-.03h-.02s-.07-.08-.11-.11c-.04-.03-.07-.07-.11-.1-.02-.02-.04-.04-.07-.06-.09-.08-.18-.15-.27-.22l-.04-.03c-.08-.06-.16-.13-.25-.19-.02-.02-.05-.04-.07-.05-.09-.07-.19-.14-.29-.2h-.02c-.06-.05-.12-.09-.19-.13-.03-.02-.06-.04-.09-.06-.03-.02-.05-.03-.08-.05-.09-.06-.19-.12-.29-.17h-.02c-.1-.07-.2-.13-.31-.18-.03-.01-.05-.03-.08-.04-.05-.02-.09-.05-.14-.07-.05-.02-.09-.05-.14-.07h0c-.12-.06-.23-.11-.35-.16-.03-.01-.05-.02-.08-.03-.12-.05-.24-.1-.36-.15l-.95,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m30.92,41.05h0c.04.09.08.17.12.26v.02s.04.07.06.11c0,.01.01.03.02.04,0,.02.02.04.03.07,0,.02.02.05.03.07,0,.02.02.04.02.06.01.04.03.07.04.11v.03s.04.07.05.1v.04s.02,0,.02,0h0s0,0,0,0h0c.03.1.06.19.1.28,0,.03.02.05.03.08.02.07.05.15.07.22,0,.02.01.04.02.06.03.09.05.19.08.29,0,.02,0,.03.01.05.02.08.04.16.06.25,0,.02.01.05.02.07.02.09.04.19.06.28v.02c.02.1.04.2.05.31,0,.02,0,.04,0,.06.01.09.02.17.03.26,0,.02,0,.04,0,.06.01.11.02.21.03.32h0s1.42-2.55,1.42-2.55h0s-.01-.04-.01-.04v-.03c-.04-.1-.07-.2-.1-.29,0-.03-.02-.06-.03-.09-.04-.11-.08-.23-.12-.34,0-.02-.01-.03-.02-.05-.04-.1-.08-.2-.11-.29-.01-.03-.02-.06-.04-.09-.05-.11-.09-.22-.14-.33v-.03c-.06-.1-.11-.2-.16-.3-.01-.03-.03-.06-.04-.08-.02-.03-.03-.07-.05-.1-.04-.07-.07-.14-.11-.21h0c-.06-.12-.12-.22-.18-.32-.02-.03-.03-.05-.05-.08-.05-.08-.09-.15-.14-.23l-1.08,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m26.34,54.56h0c-1.07.55-2.25.9-3.48,1.01l-1.08,1.94c.06,0,.12,0,.19,0,.12,0,.23,0,.35,0,.03,0,.07,0,.1,0,.09,0,.17,0,.26-.01.03,0,.06,0,.09,0,.11,0,.22-.02.33-.03h.01c.12-.01.24-.03.36-.04h.03c.11-.02.22-.04.33-.05h.04c.36-.07.72-.15,1.06-.24l1.42-2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m18.43,35.47c-.19.08-.38.16-.57.25-.49.23-.96.52-1.41.82l-.03.02c-.46.32-.88.68-1.29,1.06-.05.05-.1.1-.15.15-.74.74-1.37,1.58-1.86,2.49-.45.84-.8,1.73-1,2.65-.03.15-.06.31-.09.46.12-.33.24-.66.38-.98.29-.68.62-1.33,1.01-1.95.14-.23.3-.46.45-.68.47-.65.99-1.26,1.57-1.82.15-.15.31-.29.47-.43.25-.21.5-.42.76-.61.43-.32.88-.61,1.35-.88.04-.02.09-.05.13-.07.9-.49,1.87-.87,2.88-1.14-.89.08-1.77.31-2.6.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 21.94,
    cy: 45.47,
    r: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m28.1,43.12c0,.13-.24.24-.54.24h-4.66c-.3,0-.66,0-.8.02-.14,0-.38-.12-.23-.38l1.33-2.31c.15-.26.48-.35.74-.2l3.69,2.13c.26.15.47.38.47.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m22.57,39.69c.11.07.08.33-.06.59l-2.33,4.03c-.15.26-.27.47-.27.47,0,0-.05.1-.11.23-.06.13-.3.27-.45.01l-1.33-2.31c-.15-.26-.06-.59.2-.74l3.69-2.13c.26-.15.56-.22.67-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m16.83,42.76c.11-.07.33.09.48.35l2.33,4.03c.15.26.27.47.27.47,0,0,.07.1.14.21.08.12.09.39-.21.39h-2.67c-.3,0-.54-.24-.54-.54v-4.26c0-.3.09-.59.21-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m16.63,49.27c0-.13.24-.24.54-.24h4.65c.3,0,.54,0,.54,0h.26c.27-.06.38.11.23.36l-1.33,2.31c-.15.26-.48.35-.74.2l-3.69-2.13c-.26-.15-.47-.38-.47-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m22.16,52.7c-.11-.07-.08-.33.06-.59l2.33-4.03c.15-.26.27-.47.27-.47,0,0,.05-.1.11-.23.06-.13.3-.27.45-.01l1.33,2.31c.15.26.06.59-.2.74l-3.69,2.13c-.26.15-.56.22-.67.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m27.89,49.63c-.11.07-.33-.09-.48-.35l-2.33-4.03c-.15-.26-.27-.47-.27-.47,0,0-.07-.1-.14-.21-.08-.12-.09-.39.21-.39h2.67c.3,0,.54.24.54.54v4.26c0,.3-.09.59-.21.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m22.36,44.31c-1.12,0-2.03.91-2.03,2.03s.91,2.03,2.02,2.03h0c.32,0,.61-.07.88-.2-.45-.06-.79-.44-.79-.91,0-.51.41-.92.92-.92.44,0,.8.3.89.71.08-.22.13-.46.13-.71,0-1.12-.91-2.03-2.03-2.03Zm-.77,1.92c-.25,0-.44-.2-.44-.44s.2-.44.44-.44.44.2.44.44-.2.44-.44.44Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 21.61,
    cy: 45.79,
    r: 0.52
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m14.53,19.04c-.26-.37-.21-.82.14-1.16l13.69-13.25c.29-.28.75-.45,1.25-.45.49,0,.95.16,1.25.45l13.78,13.25c.35.33.4.79.14,1.16-.26.37-.8.61-1.38.61h-5.6s0,17.37,0,17.37c0,.29-.17.58-.45.78-.29.21-.69.32-1.1.32h-13.18c-.41,0-.81-.12-1.1-.32-.29-.21-.45-.49-.45-.78v-17.37s-5.6,0-5.6,0c-.58,0-1.12-.24-1.38-.61Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m40.44-35.56c0-.64,0-1.24,0-1.84,0-.58.31-.91.81-.91.44,0,.76.34.77.85.01.86.02,1.71,0,2.57-.01.66-.32.92-1,.92-6.35,0-12.7.01-19.05,0-1.54,0-2.7-.75-3.36-2.15-.19-.4-.29-.89-.29-1.34-.02-7.08-.03-14.17,0-21.25,0-1.29.68-2.28,1.81-2.94.64-.38,1.34-.5,2.08-.5,6.25,0,12.51,0,18.76,0,.82,0,1.05.3,1.05,1.05,0,6.82,0,13.64,0,20.46,0,.68-.3.97-.98.97-6.27,0-12.53,0-18.8,0-.57,0-1.11.1-1.59.48-.92.74-1.04,2-.32,2.88.46.55,1.04.77,1.76.77,5.98-.01,11.95,0,17.93,0,.12,0,.24,0,.41,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("image", {
    width: 100,
    height: 99,
    transform: "translate(-4 41)",
    xlinkHref: "data:image/png;base64,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"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.15a5e197246c4549f62d3d163e2a893e.svg";
export { ForwardRef as ReactComponent };